import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
  useLayoutEffect
} from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Chip,
  Skeleton,
  useMediaQuery,
  useTheme,
  Grid,
  Modal,
  CircularProgress,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Add as AddIcon,
  DeleteOutlineOutlined,
  ChevronRight,
  LocalPostOfficeSharp,
} from "@mui/icons-material";
import { Close } from "@mui/icons-material";
import {
  PrimaryButton,
  PrimaryButtonText,
  UploadButton,
} from "../../components/ui/Button";
import BulkUploadModalContent from "./BulkUploadModalContent";
import ModalPopup from "../../components/ui/ModalPopup";
import UploadIcon from "./../../assets/svgIcons/upload.svg";
import UploadWhiteIcon from "./../../assets/svgIcons/upload-white.svg";
import LinkIcon from "./../../assets/svgIcons/link.svg";
import Eyecon from "./../../assets/svgIcons/eye.svg";
import DigiLockerIcon from "./../../assets/svgIcons/digi locker.svg";
import fileTextAccountStatement from "./../../assets/svgIcons/file-text-account-statement.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { RootState } from "../../services/redux/store";
import { useDispatch, useSelector } from "react-redux";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import postsServices from "../../services/api/service/postsService";
import PDFViewer from "../../components/ui/PDFViewer";
import AddMoreDocumentForm from "./AddMoreDocumentForm";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import CustomDivider from "../../components/common/CustomDivider";
import {
  setAadhaarApplicationNo,
  setConsentApplicationNo,
  setDocumentUploadId,
  setIsDocumentVerified,
  setLastVerifiedEmail,
  setDigiLockerLoaderId,
  removeDigiLockerLoaderId,
  setDocumentApplicantType,
  setAccountAggregatorMobile,
  setHasCheckedInitialSummary,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { setCoApplicantDetails } from "../../services/redux/slices/applicationLoanDetailsSlice";
import LoaderBackdrop from "../../components/ui/LoaderBackdrop";
import applicantDetailsServices from "../../services/api/service/applicantDetailsService";
import applicationDetailsServices from "../../services/api/service/applicationDetails";
import BottomSheet from "../../components/ui/BottomSheet";
import AddNewCoApplicantModal from "../../components/ui/AddNewCoApplicantModal";
import { setAdditionalSummaryDocumentsComplete } from "../../services/redux/slices/tabsSlice";
import {isUploadOptionShow, mapCollateral,checkAllMandatoryDocumentsUploaded } from "../../utils/helpers";
// Types and Interfaces
import documentService from "../../services/api/service/documentService";
import { useTriggerData } from "../../hooks/useTriggerData";
import { decodeBase64FileToUrl, getGAProvisionalOfferStatements } from "../../components/ui/StepperDyanmicForm/helper";
import losServices from "../../services/api/service/losService";
import dropdownService from "../../services/api/service/dropdownService";
import { formatDateAndTime } from "../../utils/formatting";
import ManualBankStatement from "./ManualBankStatement";
import OtpInputForm from "../../pages/common-features/OtpInputForm";
import newVerifyIcon from "../../assets/svgIcons/verify-btn.svg";
import newVerifiedIcon from "../../assets/svgIcons/verified-btn.svg";
import greenCheckVerified from "../../assets/svgIcons/green-check-verified.svg";
import arrowRightVerify from "../../assets/svgIcons/arrow-right-verify.svg";
import { validateImageFile } from "../../utils/imageValidation";
import { TruncatedTextWithTooltip } from "../../components/ui/TruncatedTextWithTooltip";
import BasicDatePicker from "../../components/ui/BasicDatePicker";
import dayjs from "dayjs";
import { InputField } from "../../components/ui/Inputs";
import SelectOptions from "../../components/ui/SelectOptions";
import { trackCustomerJourneyEvent, trackCustomerJourneyEventAndWait } from "../../utils/ga";
import { authSelector } from "../../services/redux/slices/authSlice";
import { decrypt } from "../../utils/crypto";
import axiosInstance from "../../services/api/interceptor/interceptor";
import { setAdditionalSummaryActiveTab } from "../../services/redux/slices/tabsSlice";
import { ROUTES } from "../../routes/routerConfig";

interface Document {
  id: number;
  docName: string;
  description: string;
  byDefault?: boolean;
  isMandatory?: boolean;
  userDocs?: UserDocument[];
}

interface DocumentCategory {
  id: number;
  name: string;
  isMand: boolean;
  documents: Document[];
}

interface UserDocument {
  docUrl: string;
  id: string;
}
enum UploadVia {
  Manual = "manual",
  Account_Aggregator_Manual = "account_aggregator_manual",
}

const consentTypeOptions = [
  { value: "one_time", label: "One Time" },
  { value: "periodic", label: "Periodic" },
];

const CONSENT_DURATION_UNIT = "DAY";
const CONSENT_DURATION_UNIT_ONE = "MONTH";
const PERIODIC_LOOKBACK_DAYS = 180;
const PERIODIC_DEFAULT_TO_DAYS = 1825;
const ONE_TIME_LOOKBACK_DAYS = 365;

interface ApplicantTabsProps {
  applicants: string[];
  applicationDetail: any[];
  mainApplicantDetails: any[];
  coApplicantDetails: any[];
  applicationId?: string;
  handleFetchApplicationDetail: () => void;
  partnerStartedJourney: boolean;
  dropdownData?: [];
  applicationStatus?: string;
  stepper?: any;
  coApplicantEmploymentType?: string;
  isPayPartyPresent?: boolean;
  isPayPartyValue?: string;
  isAdditional?:boolean;
  activeHorizontalIndex?:any
  activeVerticalIndex?:any
  onMandatoryDocumentsCheckStateChange?: (isChecking: boolean) => void;
}

// Constants
const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
] as const;

const ALLOWED_EXTENSIONS = ["jpeg", "jpg", "png", "pdf"] as const;

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const a11yProps = (index: number) => ({
  id: `applicant-tab-${index}`,
  "aria-controls": `applicant-tabpanel-${index}`,
});
const dataTypeOptions = [
  { value: "banking", label: "Banking" },
  { value: "bankingWithInvestment", label: "Banking with Investment" },
];
const TabPanel: React.FC<{
  children?: React.ReactNode;
  index: number;
  value: number;
}> = ({ children, value, index, ...other }) => {
  if (value !== index) return null;
  return (
    <div
      role="tabpanel"
      id={`applicant-tabpanel-${index}`}
      aria-labelledby={`applicant-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: { xs: 0, md: 2 } }}>{children}</Box>
    </div>
  );
};

const ApplicantTabs: React.FC<ApplicantTabsProps> = ({
  applicants,
  applicationDetail,
  mainApplicantDetails,
  coApplicantDetails,
  applicationId,
  handleFetchApplicationDetail,
  partnerStartedJourney,
  dropdownData,
  applicationStatus,
  coApplicantEmploymentType,
  isPayPartyPresent,
  isPayPartyValue,
  isAdditional = false,
  activeHorizontalIndex,
  activeVerticalIndex,
  onMandatoryDocumentsCheckStateChange,

}) => {
  // set email value
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [openMobileOtpModal, setOpenMobileOtpModal] = useState(false);
  const [otpEmailKey, setOtpEmailKey] = useState("");
  const [otpMobileKey, setOtpMobileKey] = useState("");
  const [otpEmailTime, setOtpEmailTime] = useState("");
  const [otpMobileTime, setOtpMobileTime] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const hasCheckedInitialStatus = useRef(false);
  const [usernameDet, setUsername] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    trackingId: string;
    applicantId: string;
    applicationId: string;
  } | null>(null);
  const [openEmailOtpModal, setOpenEmailOtpModal] = useState(false);

  const { stepper } = useSelector((state: RootState) => state);
  const isHasCheckedInitialSummary = useSelector(
    (state: RootState) => state.stepper.isHasCheckedInitialSummary
  );
  const fields =
    stepper.fetchUserApplicationData?.horizontalSteps?.[0]?.verticalSteps?.[0]
      ?.fields || [];


  const parseBooleanFlag = (value: unknown): boolean => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true") return true;
      if (normalized === "false") return false;
    }
    if (typeof value === "number") return value === 1;
    return Boolean(value);
  };
  
  useEffect(() => {
    const mobileObj = fields.find((f: any) => f.isMobileVerified !== undefined);
    const emailObj = fields.find((f: any) => f.isEmailVerified !== undefined);

    const firstName =
      fields.find((f: any) => f.firstName !== null && f.firstName !== undefined)
        ?.firstName || null;

    const lastName =
      fields.find((f: any) => f.lastName !== null && f.lastName !== undefined)
        ?.lastName || null;
    const email =
      fields.find((f: any) => f.email !== null && f.email !== undefined)
        ?.email || null;
    const phone =
      fields.find(
        (f: any) => f.phone_number !== null && f.phone_number !== undefined
      )?.phone_number || null;

    const applicantId =
      stepper?.fetchUserApplicationData?.applicantId ||
      stepper?.applicantId ||
      null;

    const applicationId =
      stepper?.fetchUserApplicationData?.applicationId ||
      stepper?.applicationId ||
      null;

    const trackingId = stepper?.trackingId || null;
    if (firstName && lastName) {
      setUsername({
        firstName,
        lastName,
        email,
        phone,
        applicantId,
        trackingId,
        applicationId,
      });
    }

    if (mobileObj?.isMobileVerified !== undefined) {
      setIsMobileVerified(parseBooleanFlag(mobileObj.isMobileVerified));
      // setIsMobileVerified(false);
    }

    if (emailObj?.isEmailVerified !== undefined) {
      setIsEmailVerified(parseBooleanFlag(emailObj.isEmailVerified));
      // setIsEmailVerified(false);
    }
  }, [fields]);

  //end

  // OTP Handling Functions
  const handleSendEmailOtp = async (email: string) => {
    try {
      let firstName = usernameDet?.firstName;
      let lastName = usernameDet?.lastName;
      if (tabIndex > 0) {
        const key: any = `coapplicant${findCoApplicantNumber}`;
        const co = coApplicantDetails?.[key];
        firstName = co?.FirstName;
        lastName = co?.LastName;

      }
      setIsLoading(true);
      // Call your OTP service here
      const response = await eligibilityCheckServices.sendOtp({
        name: `${firstName || ""} ${lastName || ""}`.trim(),
        email: email?.toLowerCase(),
        isResend: false,
      });

      if (response?.data?.status === "success") {
        const summaryEmailVerificationEventName =
          tabIndex === 0
            ? "APPLICANT_SUMMARY_EMAIL_VERIFICATION"
            : `COAPPLICANT${findCoApplicantNumber}_SUMMARY_EMAIL_VERIFICATION`;

        trackCustomerJourneyEvent(
          summaryEmailVerificationEventName,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: summaryEmailVerificationEventName,
            category: summaryEmailVerificationEventName,
            action: summaryEmailVerificationEventName,
            page: `Summar Page Verification Email `,
          }
        );


        setOtpEmailKey(response.data.data.value);
        setOtpEmailTime(response.data.data.otpTime);
        setOpenEmailOtpModal(true);
        // dispatch(
        //   setStatusPopup({
        //     status: "success",
        //     message: "OTP sent to your email successfully!",
        //   })
        // );
      } else {
        dispatch(
          setStatusPopup({
            status: "error",
            message: response?.data?.message || "Failed to send OTP",
          })
        );
      }
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: Array.isArray(error?.response?.data?.errors)
            ? error?.response?.data?.errors?.[0]?.constraints?.matches
            : error?.response?.data?.message || "Failed to send OTP",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendMobileOtp = async (mobile: string) => {
    try {
      let firstName = usernameDet?.firstName;
      let lastName = usernameDet?.lastName;
      if (tabIndex > 0) {
        const key: any = `coapplicant${findCoApplicantNumber}`;
        const co = coApplicantDetails?.[key];
        firstName = co?.FirstName;
        lastName = co?.LastName;

      }
      setIsLoading(true);
      // Call your OTP service here
      const response = await eligibilityCheckServices.sendOtp({
        name: `${firstName || ""} ${lastName || ""}`.trim(),
        mobileNumber: mobile,
        isResend: false,
      });

      if (response?.data?.status === "success") {
        const summaryMobileVerificationEventName =
          tabIndex === 0
            ? "APPLICANT_SUMMARY_MOBILE_VERIFICATION"
            : `COAPPLICANT${findCoApplicantNumber}_SUMMARY_MOBILE_VERIFICATION`;

        trackCustomerJourneyEvent(
          summaryMobileVerificationEventName,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: summaryMobileVerificationEventName,
            category: summaryMobileVerificationEventName,
            action: summaryMobileVerificationEventName,
            page: `Summar Page Verification Mobile `,
          }
        );


        setOtpMobileKey(response.data.data.value);
        setOtpMobileTime(response.data.data.otpTime);
        setOpenMobileOtpModal(true);
        // dispatch(
        //   setStatusPopup({
        //     status: "success",
        //     message: "OTP sent to your mobile successfully!",
        //   })
        // );
      } else {
        dispatch(
          setStatusPopup({
            status: "error",
            message: response?.data?.message || "Failed to send OTP",
          })
        );
      }
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: Array.isArray(error?.response?.data?.errors)
            ? error?.response?.data?.errors?.[0]?.constraints?.matches
            : error?.response?.data?.message || "Failed to send OTP",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  //  api call for verification
  const handleEmailOtpSubmit = async (otp: string) => {
    try {
      setIsLoading(true);
      let email = usernameDet?.email;
      let applicantId: any = usernameDet?.applicantId;
      let applicationId = usernameDet?.applicationId;
      let trackingId = usernameDet?.trackingId;
      const userType = tabIndex > 0 
        ? `Co-Applicant ${findCoApplicantNumber}` 
        : "Applicant";
      if (tabIndex > 0) {
        const key: any = `coapplicant${findCoApplicantNumber}`;
        const co = coApplicantDetails?.[key];
        email = co?.Email;
        applicantId = localStorage.getItem("coAppId");
      }

      const response = await eligibilityCheckServices.verifyOtp({
        type: "email",
        email: email?.toLowerCase(),
        key: otpEmailKey,
        emailOtp: otp,
        emailOtpCrtdAt: otpEmailTime,
        userType: userType,
        ...(applicationNumber && { trackingId: applicationNumber }),
      });

      if (response?.data?.status === "success") {
        const summaryEmailVerificationEventName =
          tabIndex === 0
            ? "APPLICANT_SUMMARY_EMAIL_VERIFICATION"
            : `COAPPLICANT${findCoApplicantNumber}_SUMMARY_EMAIL_VERIFICATION`;

        trackCustomerJourneyEvent(
          summaryEmailVerificationEventName,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: summaryEmailVerificationEventName,
            category: summaryEmailVerificationEventName,
            action: summaryEmailVerificationEventName,
            page: `Summar Page Verification Email `,
          }
        );

        setIsEmailVerified(true);
        setOpenEmailOtpModal(false);
        if (tabIndex > 0) {
          try {
            const coApplicantType = `Co-Applicant ${findCoApplicantNumber}`;
            const updatePayload = {
              trackingId: applicationNumber,
              coApplicantType: coApplicantType,
              key: `basicCoApplicant${findCoApplicantNumber}IsEmailVerified`,
              value: true,
            };
            await applicantDetailsServices.updateCoApplicantFormData(updatePayload);
          } catch (error: any) {
            console.error("Failed to update co-applicant form data:", error);
          }
          setCoApplicantConsentTimes((prev) => ({
            ...prev,
            [tabIndex]: new Date().toISOString(),
          }));
        }
        // Email and Mobile Verification
        const emailVerificationPayload = {
          verificationType: "Email",
          applicantId: Number(applicantId) || 0,
          applicationId: Number(applicationId) || 0,
          trackingId: applicationNumber,
          eventName: `COAPPLICANT${findCoApplicantNumber}_EMAIL_VERIFICATION`,
          userApplicantType: `Co-Applicant ${findCoApplicantNumber}`,
        };
        if (emailVerificationPayload.applicationId > 0) {
          const saveToPic = losServices.emailAndMobileVerification(
            emailVerificationPayload
          );
        }
        // Fetch latest user application data after email verification
        if (typeof handleFetchApplicationDetail === 'function') {
          await handleFetchApplicationDetail();
        }
        dispatch(
          setStatusPopup({
            status: "success",
            message: "Email verified successfully!",
          })
        );
      } else {
        setErrorMsg(response?.data?.message || "Invalid OTP");
        // setOpenEmailOtpModal(false);
        // dispatch(
        //   setStatusPopup({
        //     status: "error",
        //     message: response?.data?.message || "Invalid OTP",
        //   })
        // );
      }
    } catch (error: any) {
      setErrorMsg(error?.response?.data?.message || "Failed to verify OTP");
      // setOpenEmailOtpModal(false);
      // dispatch(
      //   setStatusPopup({
      //     status: "error",
      //     message: error?.response?.data?.message || "Failed to verify OTP",
      //   })
      // );
    } finally {
      setIsLoading(false);
    }
  };

  const handleMobileOtpSubmit = async (otp: string) => {
    try {
      setIsLoading(true);
      // Call your OTP verification service here
      let phone = usernameDet?.phone;
      let applicantId: any = usernameDet?.applicantId;
      let applicationId = usernameDet?.applicationId;
      let trackingId = usernameDet?.trackingId;
      const userType = tabIndex > 0 
        ? `Co-Applicant ${findCoApplicantNumber}` 
        : "Applicant";
      if (tabIndex > 0) {
        const key: any = `coapplicant${findCoApplicantNumber}`;
        const co = coApplicantDetails?.[key];
        phone = co?.PhoneNumber;
        applicantId = localStorage.getItem("coAppId");
      }

      const response = await eligibilityCheckServices.verifyOtp({
        type: "mobile",
        mobileNumber: phone,
        key: otpMobileKey,
        mobileOtp: otp,
        mobileOtpCrtdAt: otpMobileTime,
        userType: userType,
        ...(applicationNumber && { trackingId: applicationNumber }),
      });

      if (response?.data?.status === "success") {
        const summaryMobileVerificationEventName =
          tabIndex === 0
            ? "APPLICANT_SUMMARY_MOBILE_VERIFICATION"
            : `COAPPLICANT${findCoApplicantNumber}_SUMMARY_MOBILE_VERIFICATION`;

        trackCustomerJourneyEvent(
          summaryMobileVerificationEventName,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: summaryMobileVerificationEventName,
            category: summaryMobileVerificationEventName,
            action: summaryMobileVerificationEventName,
            page: `Summar Page Verification Mobile `,
          }
        );

        setIsMobileVerified(true);
        setOpenMobileOtpModal(false);
        if (tabIndex > 0) {
          try {
            const coApplicantType = `Co-Applicant ${findCoApplicantNumber}`;
            const updatePayload = {
              trackingId: applicationNumber,
              coApplicantType: coApplicantType,
              key: `basicCoApplicant${findCoApplicantNumber}IsMobileVerified`,
              value: true,
            };
            await applicantDetailsServices.updateCoApplicantFormData(updatePayload);
          } catch (error: any) {
            console.error("Failed to update co-applicant form data:", error);
          }
          setCoApplicantConsentTimes((prev) => ({
            ...prev,
            [tabIndex]: new Date().toISOString(),
          }));
        }
        const phoneVerificationPayload = {
          verificationType: "Mobile",
          applicantId: Number(applicantId) || 0,
          applicationId: Number(applicationId) || 0,
          trackingId: trackingId,
          eventName: `COAPPLICANT${findCoApplicantNumber}_MOBILE_VERIFICATION`,
          userApplicantType: `Co-Applicant ${findCoApplicantNumber}`,
        };
        if (phoneVerificationPayload.applicationId > 0) {
          await losServices.emailAndMobileVerification(phoneVerificationPayload);
        }
        if (typeof handleFetchApplicationDetail === 'function') {
          await handleFetchApplicationDetail();
        }
        dispatch(
          setStatusPopup({
            status: "success",
            message: "Mobile number verified successfully!",
          })
        );
      } else {
        setErrorMsg(response?.data?.message || "Invalid OTP");
        // setOpenMobileOtpModal(false);
        // dispatch(
        //   setStatusPopup({
        //     status: "error",
        //     message: response?.data?.message || "Invalid OTP",
        //   })
        // );
      }
    } catch (error: any) {
      setErrorMsg(error?.response?.data?.message || "Failed to verify OTP");
      // setOpenMobileOtpModal(false);
      // dispatch(
      //   setStatusPopup({
      //     status: "error",
      //     message: error?.response?.data?.message || "Failed to verify OTP",
      //   })
      // );
    } finally {
      setIsLoading(false);
    }
  };

  //end verification
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(-1);
  const [documentData, setDocumentData] = useState<any>([]);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDoc, setIsLoadingDoc] = useState(true);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState("");
  const [uploadDocumentLoader, setUploadDocumentLoader] = useState<any>([]);
  const [documentCategoryId, setDocumentCategoryId] = useState<number>(0);
  const [documentCategories, setDocumentCategories] = useState<any>([]);
  const [masterDocumentList, setMasterDocumentList] = useState<any>([]);
  const [loadingDocList, setLoadingDocList] = useState(false);
  const [aggregatorLoader, setAggregatorLoader] = useState(false);
  const [applicantDetails, setApplicantDetails] = useState<any[]>([]);
  const [countBulkUpload, setCountBulkUpload] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddMoreModalOpen, setIsAddMoreModalOpen] = useState(false);
  const [modelType, setModelType] = useState<string>("");
  const [isAddCoApplicantModalOpen, setIsAddCoApplicantModalOpen] = useState(false);
  const [isAddCoApplicantLoading, setIsAddCoApplicantLoading] = useState(false);
  const [apiNextCoApplicantNumber, setApiNextCoApplicantNumber] = useState<number | null>(null);
  const [preloadedRelationshipOptions, setPreloadedRelationshipOptions] = useState<
    Array<{ label: string; value: string | number }>
  >([]);
  const [preloadedSalutationOptions, setPreloadedSalutationOptions] = useState<
    Array<{ label: string; value: string | number }>
  >([]);
  const [preloadedNationalityOptions, setPreloadedNationalityOptions] = useState<
    Array<{ label: string; value: string | number }>
  >([]);
  const [preloadedMaritalStatusOptions, setPreloadedMaritalStatusOptions] = useState<
    Array<{ label: string; value: string | number }>
  >([]);
  const [preloadedCountryOptions, setPreloadedCountryOptions] = useState<
    Array<{ label: string; value: string | number }>
  >([]);
  const [coreExamList, setCoreExamList] = useState<any>([]);
  const [languageExamList, setLanguageExamList] = useState<any>([]);
  const [languageExamSystemValues, setLanguageExamSystemValues] = useState<any[]>([]);
  const [coreExamSystemValues, setCoreExamSystemValues] = useState<any[]>([]);
  const [isAggregateVerify, setIsAggregateVerify] = useState(false);
  const [apiCallDigi, setApiCallDigi] = useState(false);
  const [apiCallAgg, setApiCallAgg] = useState(false);
  const [bankName, setBankName] = useState("");

  // Submit Application state
  const [isSubmittingApplication, setIsSubmittingApplication] = useState(false);
  const [allDocumentsData, setAllDocumentsData] = useState<any[]>([]);

  // Store consentTime per co-applicant tab index from getCoApplicantDetails API
  const [coApplicantConsentTimes, setCoApplicantConsentTimes] = useState<Record<number, string>>({});

  // Track pushed document paths for Account Aggregator to prevent duplicate calls
  const pushedAggregatorDocuments = useRef<Set<string>>(new Set());

  // Track if consent API has been called to prevent duplicate calls
  const hasCalledConsentAPI = useRef<boolean>(false);

  // Caches the raw mandatory-documents response getDocumentCategoriesViaAPI just fetched for
  // one applicant, keyed by applicant index. fetchMandatoryDocumentsForSummary's all-applicants
  // recheck (triggered right after by the same documentData update) reads from here instead of
  // re-hitting the API for the applicant that was just fetched, so a single upload doesn't
  // trigger a duplicate mandatory-documents call for the same applicant.
  const lastFetchedApplicantDocsRef = useRef<Record<number, any[]>>({});

  // Bumped only when a document is actually uploaded/deleted/fetched for the active applicant,
  // so the all-applicants mandatory-documents recheck below re-runs on real document changes —
  // not on a plain tab switch, which also updates documentData for the newly selected tab and
  // would otherwise re-trigger the full applicant + co-applicant recheck every time.
  const [documentsMutationTick, setDocumentsMutationTick] = useState(0);

  // Restores the document category position after an upload refreshes the list.
  const pendingScrollSectionRef = useRef<string | null>(null);

  // Once the additional-summary mandatory-documents check has fully succeeded once, the
  // parent's full-screen skeleton should never come back for later rechecks (e.g. after an
  // upload) — only the very first check (on redirect into the page) should block on it.
  const hasCompletedInitialMandatoryDocumentsCheckRef = useRef<boolean>(false);

  // Account Aggregator Modal State
  const [isAccountAggregatorModalOpen, setIsAccountAggregatorModalOpen] =
    useState(false);
  const [accountAggregatorMobileNumber, setAccountAggregatorMobileNumber] =
    useState<string>("");
  const [selectedDocumentId, setSelectedDocumentId] = useState<number>(0);
  const [selectedDocumentItem, setSelectedDocumentItem] = useState<any>({});
  const [mobileNumberError, setMobileNumberError] = useState<string>("");
  const [updatedAt, setUpdatedAt] = useState<string | null>();

  // Bank Statement Upload Confirmation Modal
  const [isBankStatementConfirmModalOpen, setIsBankStatementConfirmModalOpen] =
    useState(false);
  const [pendingUploadDocId, setPendingUploadDocId] = useState<number>(0);
  const [pendingUploadItem, setPendingUploadItem] = useState<any>(null);
  const initialConsentDates = getPastDates();

  const [fromDate, setFromDate] = useState<string>(initialConsentDates.fromDate);
  const [toDate, setToDate] = useState<string>(initialConsentDates.toDate);
  const [savedFromDate, setSavedFromDate] = useState<string>(initialConsentDates.fromDate);
  const [savedToDate, setSavedToDate] = useState<string>(initialConsentDates.toDate);
  const [fromDateError, setFromDateError] = useState<string>("");
  const [toDateError, setToDateError] = useState<string>("");
  const [uploadedVia, setUploadedVia] = useState<UploadVia>(UploadVia.Manual);

  const [consentDurData, setConsentDurData] = useState<{
    consentDuration: null | string;
    consentDurationValue: null | string;
    consentType: null | string;
  }>({
    consentDuration: CONSENT_DURATION_UNIT,
    consentDurationValue: null,
    consentType: "periodic",
  });
  const [dataType, setDataType] = useState<string>(dataTypeOptions[0].value);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity?: "error" | "success";
  }>({
    open: false,
    message: "",
    severity: "error",
  });

  function getPastDates() {
    const fromDate = dayjs()
      .subtract(PERIODIC_LOOKBACK_DAYS, "day")
      .format("YYYY-MM-DD");
    const toDate = dayjs()
      .add(PERIODIC_DEFAULT_TO_DAYS, "day")
      .format("YYYY-MM-DD");

    return {
      fromDate,
      toDate,
    };
  }

  function getOneTimeDates() {
    const toDate = dayjs().format("YYYY-MM-DD");
    const fromDate = dayjs()
      .subtract(ONE_TIME_LOOKBACK_DAYS, "day")
      .format("YYYY-MM-DD");

    return { fromDate, toDate };
  }

  function getConsentDefaults(consentType: string) {
    return consentType === "one_time" ? getOneTimeDates() : getPastDates();
  }

  function getDerivedConsentDurationValue(startDate: string, endDate: string) {
    const start = dayjs();
    const end = dayjs(endDate);
    if (!start.isValid() || !end.isValid()) {
      return "0";
    }

    return String(
      Math.max(end.startOf("day").diff(start.startOf("day"), "day"), 0),
    );
  }

  const applyConsentDates = (nextFromDate: string, nextToDate: string, consentType?: string, updatedAt?: string | null) => {
    if(consentType === "one_time") {
      let nextToDate1 = nextToDate;
      let nextFromDate1 = nextFromDate;
      if(updatedAt && dayjs(updatedAt).isBefore(dayjs())) {
        nextToDate1 = dayjs().format("YYYY-MM-DD");
        nextFromDate1 = dayjs()
          .subtract(ONE_TIME_LOOKBACK_DAYS, "day")
          .format("YYYY-MM-DD");
        // nextFromDate1 = dayjs().subtract(ONE_TIME_LOOKBACK_DAYS, "day").format("YYYY-MM-DD");
      }
      setFromDate(nextFromDate1);
      setToDate(nextToDate1);
      setSavedFromDate(nextFromDate1);
      setSavedToDate(nextToDate1);
    } else {
      setFromDate(nextFromDate);
      setToDate(nextToDate);
      setSavedFromDate(nextFromDate);
      setSavedToDate(nextToDate);
    }
    setFromDateError("");
    setToDateError("");
  };

  const resetConsentDraftDates = () => {
    setFromDate(savedFromDate);
    setToDate(savedToDate);
    setFromDateError("");
    setToDateError("");
  };

  const getRequestConsentDates = (requestType: string) => {
    if (requestType === "button") {
      return {
        fromDate: savedFromDate,
        toDate: savedToDate,
      };
    }

    return {
      fromDate,
      toDate,
    };
  };

  // Date validation function
  const validateDate = (
    dateValue: string,
    setError: (error: string) => void,
    dateType: "from" | "to",
    otherDateValue?: string
  ) => {
    // Only validate complete dates in YYYY-MM-DD format
    if (!dateValue || dateValue.length !== 10) {
      setError("");
      return false;
    }

    // Validate date format using regex
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateValue)) {
      setError("");
      return false;
    }

    const selectedDate = dayjs(dateValue);

    if (!selectedDate.isValid()) {
      setError("");
      return false;
    }

    const today = dayjs().startOf("day");
    const oneTimeMinDate = today.subtract(ONE_TIME_LOOKBACK_DAYS, "day");
    const periodicMaxToDate = today.add(PERIODIC_DEFAULT_TO_DAYS, "day");
    const isOneTime = (consentDurData?.consentType || "periodic") === "one_time";
    const resetToDefaultDates = () => {
      const defaults = getConsentDefaults(consentDurData?.consentType || "periodic");
      setFromDate(defaults.fromDate);
      setToDate(defaults.toDate);
      setFromDateError("");
      setToDateError("");
    };

    if (isOneTime) {
      if (dateType === "from") {
        if (selectedDate.isBefore(oneTimeMinDate, "day")) {
          resetToDefaultDates();
          setError("");
          return true;
        }

        if (selectedDate.isAfter(today, "day")) {
          setError("From Date cannot be later than today");
          return false;
        }
      }

      if (dateType === "to") {
        if (selectedDate.isBefore(oneTimeMinDate, "day")) {
          setError("To Date cannot be earlier than 365 days before today");
          return false;
        }

        if (selectedDate.isAfter(today, "day")) {
          setError("To Date cannot be later than today");
          return false;
        }

        const fromDateToUse = otherDateValue || fromDate;
        if (fromDateToUse && fromDateToUse.length === 10) {
          const fromDateObj = dayjs(fromDateToUse);
          if (!fromDateObj.isValid()) {
            setError("");
            return true;
          }

          if (selectedDate.isBefore(fromDateObj, "day")) {
            setError("To Date cannot be earlier than From Date");
            return false;
          }
        }
      }

      if (dateType === "from") {
        const toDateToUse = otherDateValue || toDate;
        if (toDateToUse && toDateToUse.length === 10) {
          const toDateObj = dayjs(toDateToUse);
          if (!toDateObj.isValid()) {
            setError("");
            return true;
          }

          if (selectedDate.isAfter(toDateObj, "day")) {
            setError("From Date cannot be later than To Date");
            return false;
          }
        }
      }
    } else {
      if (dateType === "from") {
        const expectedFromDate = getPastDates().fromDate;
        if (dateValue !== expectedFromDate) {
          resetToDefaultDates();
          setError("");
          return true;
        }
      }

      if (dateType === "to") {
        if (selectedDate.isBefore(today, "day")) {
          setError("To Date cannot be earlier than today");
          return false;
        }

        if (selectedDate.isAfter(periodicMaxToDate, "day")) {
          setError("To Date cannot be later than 1825 days from today");
          return false;
        }

        const fromDateToUse = otherDateValue || fromDate;
        if (fromDateToUse && fromDateToUse.length === 10) {
          const fromDateObj = dayjs(fromDateToUse);
          if (!fromDateObj.isValid()) {
            setError("");
            return true;
          }

          if (selectedDate.isBefore(fromDateObj, "day")) {
            setError("To Date cannot be earlier than From Date");
            return false;
          }
        }
      }

      if (dateType === "from") {
        const toDateToUse = otherDateValue || toDate;
        if (toDateToUse && toDateToUse.length === 10) {
          const toDateObj = dayjs(toDateToUse);
          if (!toDateObj.isValid()) {
            setError("");
            return true;
          }

          if (selectedDate.isAfter(toDateObj, "day")) {
            setError("From Date cannot be later than To Date");
            return false;
          }
        }
      }
    }

    setError("");
    return true;
  };
  // Validate from date and re-validate to date if needed
  const validateFromDate = (value: string) => {
    const isValid = validateDate(value, setFromDateError, "from");

    // Re-validate to date if it exists and from date is valid
    if (toDate && isValid) {
      validateDate(toDate, setToDateError, "to");
    }

    return isValid;
  };

  // Validate to date
  const validateToDate = (value: string) => {
    return validateDate(value, setToDateError, "to");
  };

  // useEffect to validate dates automatically when they change
  useEffect(() => {
    // Only validate when both dates are complete (10 characters)
    if (fromDate && fromDate.length === 10) {
      validateDate(fromDate, setFromDateError, "from", toDate);
    }

    if (toDate && toDate.length === 10) {
      validateDate(toDate, setToDateError, "to", fromDate);
    }
  }, [fromDate, toDate, consentDurData?.consentType]);

  const [hasNotRequiredDocument, setHasNotRequiredDocument] = useState<any>([]);
  const [viewDocUrl, setViewDocUrl] = useState<string>("");
  const [viewDocMimeType, setViewDocMimeType] = useState<string>("");
  const [docId, setDocId] = useState<number>(0);
  const [docType, setDocType] = useState<string>("");
  const [docTypeItem, setDocTypeItem] = useState<any>({});
  const [docName, setDocName] = useState<string>("");
  const [uploadDocumentLoading, setUploadDocumentLoading] = useState(false);
  const consentApplicationNo = useSelector(
    (state: RootState) => state.stepper.consentApplicationNo
  );
  const documentUploadId = useSelector(
    (state: RootState) => state.stepper.documentUploadId
  );
  const applicationNumber = useSelector(
    (state: RootState) => state.stepper.trackingId
  );
  const fileInputRef = useRef<HTMLInputElement>(null);

  const formUserData: any = useSelector(
    (state: RootState) => state.stepper.formData
  );
  const userProfile: any = useSelector(
    (state: RootState) => state.auth.userProfile
  );
  const submissionTrackingId: any = useSelector(
    (state: RootState) => state.stepper.trackingId
  );

  const aadhaarApplicationNo: any = useSelector(
    (state: RootState) => state.stepper.aadhaarApplicationNo
  );

  const digiLockerLoaderId: any = useSelector(
    (state: RootState) => state.stepper.digiLockerLoaderId
  );

  const documentApplicantType: any = useSelector(
    (state: RootState) => state.stepper.documentApplicantType
  );

  // Get account aggregator mobile from Redux
  const accountAggregatorMobileFromRedux =
    localStorage.getItem("accountAggregatorMobile") || "";

  // Function to validate mobile number for duplicates (without setting state)
  const checkMobileNumberDuplicate = (mobileNumber: string) => {
    try {
      if (!mobileNumber || mobileNumber.length !== 10) {
        return false;
      }

      // Check if applicantDetails is available and is an array
      if (!applicantDetails || !Array.isArray(applicantDetails)) {
        return false; // No duplicates if no data to check against
      }

      // Filter applicants based on current tab
      const applicantsToCheck = applicantDetails.filter(
        (applicant: any, index: number) => {
          if (tabIndex === 0) {
            // If on Applicant tab, check against Co-Applicants only (exclude primary applicant)
            return applicant?.applicantType !== "Applicant";
          } else {
            // If on Co-Applicant tab, check against other applicants (exclude current co-applicant)
            const currentCoApplicantType = `Co-Applicant ${tabIndex}`;
            return applicant?.applicantType !== currentCoApplicantType;
          }
        }
      );

      // Check if the mobile number matches any existing mobile number or aggregator mobile number
      const isDuplicate = applicantsToCheck.some(
        (applicant: any) =>
          applicant?.mobileNumber === mobileNumber ||
          applicant?.aaConsentMobileNo === mobileNumber
      );

      return isDuplicate;
    } catch (error) {
      console.error("Error in checkMobileNumberDuplicate:", error);
      return false; // No duplicates on error
    }
  };

  // Function to validate mobile number for duplicates (with state updates)
  const validateMobileNumber = (mobileNumber: string) => {
    try {
      if (!mobileNumber || mobileNumber.length !== 10) {
        setMobileNumberError("");
        return false;
      }

      const isDuplicate = checkMobileNumberDuplicate(mobileNumber);

      if (isDuplicate) {
        setMobileNumberError(
          "This mobile number is already associated with an applicant. Please use a different number."
        );
        return false;
      }

      setMobileNumberError("");
      return true;
    } catch (error) {
      console.error("Error in validateMobileNumber:", error);
      setMobileNumberError("");
      return true; // Allow on error to prevent blocking
    }
  };

  // Check if proceed button should be enabled
  const isProceedEnabled = () => {
    try {
      const hasValidLength = accountAggregatorMobileNumber.length === 10;
      const hasNoDuplicate = !checkMobileNumberDuplicate(
        accountAggregatorMobileNumber
      );
      const hasNoMobileError = !mobileNumberError;
      const hasNoDateErrors = !fromDateError && !toDateError;
      const hasValidDates = fromDate && toDate;
      const isNotLoading = !aggregatorLoader;

      return (
        hasValidLength &&
        hasNoDuplicate &&
        hasNoMobileError &&
        hasNoDateErrors &&
        hasValidDates &&
        isNotLoading
      );
    } catch (error) {
      console.error("Error in isProceedEnabled:", error);
      return false; // Disable button on error
    }
  };

  const addedMoreDocumentData: any = useSelector(
    (state: RootState) => state.stepper.addedMoreDocumentData
  );

  const { fetchUserApplicationData } = useSelector(
    (state: RootState) => state.stepper
  );

  const { isTriggerDataEmpty, triggerData }: any = useTriggerData();
  const isApplicant = isTriggerDataEmpty ? true : triggerData?.toUser;

  const findApplicantIndex: number = useMemo(() => {
    return applicants?.findIndex(
      (item: any) => item.toLowerCase() === documentApplicantType.toLowerCase()
    );
  }, [documentApplicantType, applicants]);

  const findCoApplicantNumber: number = useMemo(() => {
    const parsedFromDocumentType = String(documentApplicantType ?? "").match(/(\d+)/);
    if (parsedFromDocumentType?.[1]) {
      return Number(parsedFromDocumentType[1]);
    }

    // Fallback for flows where documentApplicantType is not populated yet.
    if (tabIndex > 0) {
      return tabIndex;
    }

    return 0;
  }, [documentApplicantType, tabIndex]);

  // Once the application is submitted, document upload/re-upload follows the
  // same restricted rules as the partner-started journey.
  const isRestrictedDocumentJourney =
    Boolean(partnerStartedJourney) ||
    fetchUserApplicationData?.status === "Application Submitted";

  const isPartnerJourneyCategoryEditable = useCallback(
    (categoryName?: string) => {
      if (!isRestrictedDocumentJourney) {
        return true;
      }

      const normalizedCategoryName = String(categoryName || "").trim();

      return (
        normalizedCategoryName === "Academic Documents" ||
        normalizedCategoryName === "Income Document"
      );
    },
    [isRestrictedDocumentJourney]
  );

  const isPartnerJourneyIncomeActionAllowed = useCallback((doc: any) => {
    return String(doc?.docName || "").trim() === "Bank Statement";
  }, []);

  const canManualUploadDocument = useCallback(
    (doc: any, categoryName?: string) => {
      if (!isPartnerJourneyCategoryEditable(categoryName)) {
        return false;
      }

      if (isRestrictedDocumentJourney && String(categoryName || "").trim() === "Income Document") {
        return isPartnerJourneyIncomeActionAllowed(doc);
      }

      return true;
    },
    [isPartnerJourneyCategoryEditable, isPartnerJourneyIncomeActionAllowed, isRestrictedDocumentJourney]
  );

  const canUseDigiLockerForDocument = useCallback(
    (doc: any, categoryName?: string) => {
      if (!isPartnerJourneyCategoryEditable(categoryName)) {
        return false;
      }

      if (isRestrictedDocumentJourney) {
        return String(categoryName || "").trim() === "Academic Documents";
      }

      return (
        String(doc?.uploadedVia || "").toLowerCase() === "digi_locker" ||
        String(doc?.docName || "").toLowerCase().includes("graduation marksheet")
      );
    },
    [isPartnerJourneyCategoryEditable, isRestrictedDocumentJourney]
  );

  const canUseAccountAggregatorDocument = useCallback(
    (doc: any, categoryName?: string) => {
      if (!isPartnerJourneyCategoryEditable(categoryName)) {
        return false;
      }

      if (isRestrictedDocumentJourney) {
        return (
          String(categoryName || "").trim() === "Income Document" &&
          isPartnerJourneyIncomeActionAllowed(doc)
        );
      }

      return String(doc?.uploadedVia || "").toLowerCase() === "account_agreegator";
    },
    [isPartnerJourneyCategoryEditable, isPartnerJourneyIncomeActionAllowed, isRestrictedDocumentJourney]
  );

  const coApplicantNums: number[] = useMemo(() => {
    return (applicants || [])
      .map((a: any) => {
        const match = String(a).match(/(\d+)/);
        return match ? Number(match[1]) : null;
      })
      .filter((n: number | null): n is number => typeof n === "number" && !Number.isNaN(n));
  }, [applicants]);

  const nextCoApplicantNumber: number = useMemo(() => {
    const max = coApplicantNums.length ? Math.max(...coApplicantNums) : 0;
    return max + 1;
  }, [coApplicantNums]);

  const totalCoApplicantCount: number = coApplicantNums.length;
  useEffect(() => {
    (async () => {
      if (isApplicant === false) {
        if (findCoApplicantNumber > 0) {
          try {
            const trackingId = applicationNumber;
            const coApplicantType = `Co-Applicant ${findCoApplicantNumber}`;
            const payload = {
              trackingId: trackingId,
              coApplicantType,
            };
            const response: any = await losServices.getCoApplicantDetails(
              payload
            );
            if (response?.status === 200 && response?.data?.data) {
              if (response?.data?.data?.applicantId != null) {
                localStorage.setItem(
                  "coAppId",
                  response?.data?.data?.applicantId
                );
              } else {
                localStorage.setItem("coAppId", "0");
              }
              if (response?.data?.data?.coApplicantConsentTime) {
                setCoApplicantConsentTimes((prev) => ({
                  ...prev,
                  [findCoApplicantNumber]: response.data.data.coApplicantConsentTime,
                }));
              }
            }
          } catch (error: any) {
            console.error("Failed to fetch co-applicant details:", error);
          }
        }
      }
    })();
  }, [isApplicant, findCoApplicantNumber]);
  const handleChange = async (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
    localStorage.removeItem("coAppId");
    dispatch(
      setDocumentApplicantType(
        newValue == 0 ? "Applicant" : applicants?.[newValue]
      )
    );
    setTabIndex(newValue);

    // Reset the aggregator push document tracking when switching tabs
    pushedAggregatorDocuments.current.clear();
    // Call getCoApplicantDetails API when switching to co-applicant tabs
    if (newValue > 0 && fetchUserApplicationData?.applicationId) {
      try {
        const trackingId = applicationNumber;
        const coApplicantType = applicants?.[newValue];
        const payload = {
          trackingId: trackingId,
          coApplicantType,
        };
        const response: any = await losServices.getCoApplicantDetails(payload);
        if (response?.status === 200 && response?.data?.data) {
          if (response?.data?.data?.applicantId != null) {
            localStorage.setItem("coAppId", response?.data?.data?.applicantId);
          } else {
            localStorage.setItem("coAppId", "0");
          }
          if (response?.data?.data?.coApplicantConsentTime) {
            setCoApplicantConsentTimes((prev) => ({
              ...prev,
              [newValue]: response.data.data.coApplicantConsentTime,
            }));
          }
          // dispatch(
          //   setCoApplicantDetails(
          //     response?.data?.data?.["Co-applicantDetails"]?.["co-applicants"]
          //   )
          // );
        }
      } catch (error: any) {
        console.error("Failed to fetch co-applicant details:", error);
        // Optionally show error message
        // dispatch(
        //   setStatusPopup({
        //     status: "error",
        //     message: error?.response?.data?.message || "Failed to load co-applicant details",
        //   })
        // );
      }
    }
  };
  useEffect(() => {
    if (formUserData) {
      const result = Object.keys(formUserData)
        .filter((key) => key.startsWith("coreExamID"))
        .map((key) => {
          const suffix = key.split("coreExamID")[1] || ""; // "" or "_7"
          const id = formUserData[key];
          const name = formUserData[`coreExamName${suffix}`];

          return {
            id: Number(id),
            value: name,
          };
        });
      const resultLanguage = Object.keys(formUserData)
        .filter((key) => key.startsWith("languageExamID"))
        .map((key) => {
          const suffix = key.split("languageExamID")[1] || ""; // "" or "_7"
          const id = formUserData[key];
          const name = formUserData[`languageExamName${suffix}`];

          return {
            id: Number(id),
            value: name,
          };
        });
      setCoreExamList(result);
      setLanguageExamList(resultLanguage);
    }
  }, [formUserData]);
  // The `dropdownData` prop is unreliable here: callers pass different shapes
  // (Summary.tsx passes a flat [{value,label,id}] array of system values, while the
  // stepper flow passes an unrelated keyed object), so the language exam serialId
  // lookup below has no consistent source to read from. Fetch system values directly
  // instead of depending on that prop.
  useEffect(() => {
    const fetchLanguageExamSystemValues = async () => {
      try {
        const systemValuesResponse = await eligibilityCheckServices.getSystemValues();
        if (systemValuesResponse?.data?.status === "success") {
          const systemValues = systemValuesResponse.data.data || [];
          const languageExamTypes = systemValues
            .filter((item: any) => item.name === "LANGUAGE_EXAM_TYPE" && item.active)
            .map((item: any) => ({
              value: item.code,
              label: item.value,
              id: item.serialId,
            }));
          
          const coreExamTypes = systemValues
            .filter((item: any) => item.name === "ENTRANCE_EXAM_TYPE" && item.active)
            .map((item: any) => ({
              value: item.code,
              label: item.value,
              id: item.serialId,
            }));
            
          setLanguageExamSystemValues(languageExamTypes);
          setCoreExamSystemValues(coreExamTypes);
        }
      } catch (error) {
        console.error("Error fetching system values:", error);
      }
    };
    fetchLanguageExamSystemValues();
  }, []);
  useEffect(() => {
    if (!isApplicant) {
      if (triggerData?.coApplicantType.includes("Co-Applicant")) {
        setTabIndex(
          Number(triggerData?.coApplicantType?.split?.("Co-Applicant")?.[1])
        );
      }
      if (triggerData?.coApplicantType.includes("coapplicant")) {
        setTabIndex(
          Number(triggerData?.coApplicantType?.split?.("coapplicant")?.[1])
        );
      }
    } else {
      if (documentApplicantType.split(" ")?.[1]) {
        setTabIndex(findApplicantIndex);
      } else {
        setTabIndex(0);
      }
    }
  }, [
    documentApplicantType,
    triggerData,
    isApplicant,
    applicants,
    findApplicantIndex,
  ]);

  // Refetch co-applicant consent time whenever tabIndex changes (handles page reload on co-applicant tab)
  useEffect(() => {
    if (tabIndex > 0 && applicationNumber) {
      const coApplicantType = applicants?.[tabIndex];
      if (!coApplicantType) return;
      (async () => {
        try {
          const payload = { trackingId: applicationNumber, coApplicantType };
          const response: any = await losServices.getCoApplicantDetails(payload);
          if (response?.status === 200 && response?.data?.data?.coApplicantConsentTime) {
            setCoApplicantConsentTimes((prev) => ({
              ...prev,
              [tabIndex]: response.data.data.coApplicantConsentTime,
            }));
          }
        } catch (error: any) {
          console.error("Failed to fetch co-applicant consent time:", error);
        }
      })();
    }
  }, [tabIndex, applicationNumber]);

  const formatApplicantType = (value: string) => {
    return value
      .toLowerCase() // normalize case
      .replace(/_/g, " ") // convert underscores
      .replace(/\b\w/g, (m) => m.toUpperCase()) // capitalize words
      .replace(/Co Applicant/i, "Co-Applicant"); // add hyphen (case-insensitive)
  };
 const examNames = Object.keys(formUserData)
  .filter((key) => {
    // Match:
    // - languageExamName
    // - languageExamName_1
    // - coreExamName
    // - coreExamName_1
    const match = key.match(
      /^(languageExamName|coreExamName)(?:_(\d+))?$/
    );

    if (!match) return false;

    const examType = match[1]; // languageExamName | coreExamName
    const index = match[2]; // undefined | "1" | "2" ...

    // Determine corresponding score field
    const scoreKey = index
      ? `${examType.replace("Name", "Score")}_${index}`
      : examType.replace("Name", "Score");

    const scoreValue =
      formUserData[
        scoreKey as keyof typeof formUserData
      ];

    // Include exam only if corresponding score exists
    return (
      scoreValue !== null &&
      scoreValue !== undefined &&
      scoreValue !== ""
    );
  })
  .map(
    (key) =>
      formUserData[
        key as keyof typeof formUserData
      ]
  )
  .filter(Boolean);

// Example:
// languageExamName = "TOEFL"
// languageExamScore = 100
// coreExamName_1 = "GRE"
// coreExamScore_1 = 320
//
// Result: ["TOEFL", "GRE"]
  let collateralTypeData=mapCollateral().filter((item:any)=>item.value === formUserData?.collateralType)?.[0]?.label || formUserData?.collateralType;
      
  const fetchMandatoryDocumentsForSummary = useCallback(async () => {
    try {
      const allDocsData: any[] = [];
      // Tracks whether every applicant's mandatory-documents fetch actually completed
      // (vs. being skipped because ids weren't ready yet, or returning a non-200), so
      // callers know whether it's safe to treat this result as the final, complete answer.
      let allSucceeded = true;
      const applicantsList = applicants && applicants.length > 0 ? applicants : ["Applicant"];
      
      if(applicantsList.length>0){
        for (let i = 0; i < applicantsList.length; i++) {
          const coApplicantDetail =
            i > 0
              ? (coApplicantDetails?.[
                  `coapplicant${i}` as keyof typeof coApplicantDetails
                ] as any)
              : null;
            let findcoappnumber=applicantsList[i];
            let coapp=findcoappnumber.split(" ");
            let coappnum=coapp[1] || 1;

          // Reuse the response getDocumentCategoriesViaAPI just fetched for this same
          // applicant (e.g. right after a document upload) instead of calling the API again.
          const cachedDocsForApplicant = lastFetchedApplicantDocsRef.current[i];
          if (cachedDocsForApplicant) {
            delete lastFetchedApplicantDocsRef.current[i];
            allDocsData.push({
              applicantIndex: i,
              applicantType: i === 0 ? "Applicant" : `Co-Applicant ${i}`,
              documents: cachedDocsForApplicant,
            });
            continue;
          }

          const payload: any = partnerStartedJourney
            ? {
                applicationId: fetchUserApplicationData?.applicationId,
                applicantId:
                  i === 0
                    ? fetchUserApplicationData?.applicantId
                    : String(coApplicantDetail?.coApplicantId ?? ""),
                trackingId: String(applicationNumber ?? ""),
                ...(tabIndex === 0 && {
                  isCollateral:
                    formUserData?.hasCollateral || "No",
                  isAppliedEntranceExam:
                    formUserData?.coreExamApplied==="Yes" || 
                    formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
                  collateralType: collateralTypeData?.toLowerCase(),
                  entranceExamNames: examNames,
                }),
                applicantType:
                  i === 0
                    ? "Applicant"
                    : formatApplicantType(String(coApplicantDetail?.coApplicantType ?? "")),
              }
            : {
                productType: formUserData?.product,
                typeOfApplicant: i === 0 ? "Applicant" : applicantsList[i],
                productCategory: formUserData?.courseCategory,
                typeOfIndividual: "Individual",
                employmentCategory:
                  i == 0 ? formUserData?.employmentType || formUserData?.applicantType : formUserData?.[`employmentCoApplicant${coappnum}employmentType`] || formUserData?.applicantType,
                trackingId: applicationNumber,
                ...(tabIndex === 0 && {
                  isCollateral:
                    formUserData?.collateral || "No",
                  isAppliedEntranceExam:
                    formUserData?.coreExamApplied==="Yes" || 
                    formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
                  collateralType:collateralTypeData?.toLowerCase()==="savings"?"saving":collateralTypeData? collateralTypeData?.toLowerCase() : "",
                  entranceExamNames: examNames,
                }),
                
              };

          let response;

          if (partnerStartedJourney === true) {
            const hasValidIds =
              Boolean(payload.applicationId) && Boolean(payload.applicantId);

            if (!hasValidIds) {
              allSucceeded = false;
              continue;
            }

            response = await eligibilityCheckServices.getDocuments(payload);
          } else {
            if (!payload?.typeOfApplicant) {
              allSucceeded = false;
              continue;
            }

            response = await eligibilityCheckServices.getMandatoryDocuments(payload);
          }

          if (response?.status === 200) {
            allDocsData.push({
              applicantIndex: i,
              applicantType: i === 0 ? "Applicant" : `Co-Applicant ${i}`,
              documents: response?.data?.data || [],
            });
          } else {
            allSucceeded = false;
          }
        }

        return { allDocsData, success: allSucceeded };
      }
      return { allDocsData, success: true };
    } catch (error) {
      console.error("Error fetching mandatory documents:", error);
      return { allDocsData: [], success: false };
    }
  }, [
    JSON.stringify(applicants),
    applicationNumber,
    JSON.stringify(coApplicantDetails),
    fetchUserApplicationData?.applicantId,
    fetchUserApplicationData?.applicationId,
    formUserData?.applicantType,
    formUserData?.courseCategory,
    formUserData?.employmentType,
    formUserData?.product,
    partnerStartedJourney,
  ]);
  
  useEffect(() => {
    if (!isAdditional) return;
    if (partnerStartedJourney === null) return;

    let isCancelled = false;

    const syncAdditionalSummaryDocuments = async () => {
      dispatch(setAdditionalSummaryDocumentsComplete(false));
      const { allDocsData, success } = await fetchMandatoryDocumentsForSummary();
      
      if (isCancelled) return;

      const { allUploaded } = await checkAllMandatoryDocumentsUploaded(allDocsData,formUserData);
      //allDocsData.length > 1 && 
      dispatch(
        setAdditionalSummaryDocumentsComplete(
           allUploaded,
        ),
      );
    if (!isHasCheckedInitialSummary && allDocsData.length > 1) {
      // 3. Lock the gate in Redux immediately so tab switches or subsequent uploads are ignored
        dispatch(setHasCheckedInitialSummary(true));
        if(allUploaded===true &&  allDocsData.length > 1 && activeHorizontalIndex===3 && activeVerticalIndex===4){
          dispatch(setAdditionalSummaryActiveTab(0));
          // navigate(ROUTES.Application.loanSummary.locationPath);
        }
      }
       hasCompletedInitialMandatoryDocumentsCheckRef.current = true;
          onMandatoryDocumentsCheckStateChange?.(false);

      // Only clear the parent's skeleton once every applicant's fetch has actually
      // succeeded — a partial/failed check (ids not ready yet, non-200 response) leaves
      // it up, and this effect will retry once the relevant data (e.g. applicantId)
      // becomes available and fetchMandatoryDocumentsForSummary's identity changes.
      if (success) {
       
      }
    };
    void syncAdditionalSummaryDocuments();

    return () => {
      isCancelled = true;
    };
  }, [
    JSON.stringify(applicants),
    JSON.stringify(coApplicantDetails),
    dispatch,
    documentsMutationTick,
    fetchMandatoryDocumentsForSummary,
    isAdditional,
    onMandatoryDocumentsCheckStateChange,
    partnerStartedJourney,
  ]);

  const getDocumentCategoriesViaAPI = async () => {
    try {
      if (tabIndex < 0) return;
      // Prevent any API call when we still don’t know the status
      if (partnerStartedJourney === null) {
        return;
      }

      setIsLoading(true);

      setIsLoadingDoc(true);
      const coApplicantDetail = coApplicantDetails?.[
        `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
      ] as any;

      let findcoappnumber=applicants?.[findApplicantIndex];
      let coapp=String(findcoappnumber || "").split(" ");
      let coappnum=coapp[1] || 1;
      const payload:any = partnerStartedJourney
        ? {
          applicationId: fetchUserApplicationData?.applicationId,
          applicantId:
            tabIndex === 0
              ? fetchUserApplicationData?.applicantId
              : String(
                coApplicantDetails?.[
                  `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
                ]?.coApplicantId ?? ""
              ),
          trackingId: String(applicationNumber ?? ""),
          ...(tabIndex === 0 && {
            isCollateral:
              formUserData?.collateral || "No",
            isAppliedEntranceExam:
              formUserData?.coreExamApplied==="Yes" || 
              formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
            collateralType:  collateralTypeData?.toLowerCase(),
            entranceExamNames: examNames,
          }),
          applicantType:
            tabIndex === 0
              ? "Applicant"
              : formatApplicantType(
                String(
                  coApplicantDetails?.[
                    `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
                  ]?.coApplicantType ?? ""
                )
              ),
          
        }
        : {
          productType: formUserData?.product,
          typeOfApplicant:
            tabIndex == 0
              ? "Applicant"
              : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
          productCategory: formUserData?.courseCategory,
          typeOfIndividual: "Individual",
          employmentCategory: tabIndex == 0 ? formUserData?.employmentType || formUserData?.applicantType : formUserData?.[`employmentCoApplicant${coappnum}employmentType`] || formUserData?.applicantType,
          trackingId: applicationNumber,
          ...(tabIndex === 0 && {
            isCollateral:
              formUserData?.collateral || "No",
            isAppliedEntranceExam:
              formUserData?.coreExamApplied==="Yes" || 
              formUserData?.languageExamApplied==="Yes" ?"Yes":"No",
            collateralType:collateralTypeData?.toLowerCase()==="savings"?"saving":collateralTypeData? collateralTypeData?.toLowerCase() : "",
            entranceExamNames: examNames,
          }),
        };

      let response;

      if (partnerStartedJourney === true) {
        const hasValidIds =
          Boolean(payload.applicationId) && Boolean(payload.applicantId);

        if (!hasValidIds) {
          return;
        }

        // Guaranteed: only this API will ever run when partnerStartedJourney = true
        response = await eligibilityCheckServices.getDocuments(payload);
      } else {
        // partnerStartedJourney === false
        if (payload.typeOfApplicant) {
          response = await eligibilityCheckServices.getMandatoryDocuments(
            payload
          );
        }
        setAllDocumentsData(response?.data?.data);
      }
      if (response?.status == 200) {
        let respData = response?.data?.data;
        let arrayOfData: any[] = [];
        let hasNotRequiredDocumentData: any[] = [];
        respData.forEach((item: any) => {
          const documentList = item?.documents;
          if (tabIndex > 0) {
            if (item?.name == "Academic Documents" || item?.name == "Entrance Exam Documents" || item?.name == "Proof of Admission") {
              item.isMand = false;
            }
            
            // Process documents based on employment type in a single loop
            documentList?.forEach((doc: any) => {
              // Helper function to update document properties
             const updateDocument = (doc: any, isMatch: boolean, isMandatory: boolean) => {
                if (isMatch) {
                  doc.byDefault = true;
                  doc.isMandatory = isMandatory;
                }
              };
               let findcoappnumber=applicants?.[findApplicantIndex];
              let coapp=String(findcoappnumber || "").split(" ");
              let coappnum=coapp[1] || 1;
              let coapplicantEmploytype=formUserData?.[`employmentCoApplicant${coappnum}employmentType`];
              let basicCoAppPayparty=formUserData?.[`basicCoApplicant${coappnum}PayParty`];
              
              // Handle passport documents
              if (doc?.docNameDms === "passport") {
                doc.isMandatory = false;
                doc.byDefault = false;
                return;
              }
              if (basicCoAppPayparty == "Yes") {
                const isBankStatement = doc?.docName.includes("Bank Statement") || doc?.docNameDms == "account_statement";

                updateDocument(doc, isBankStatement, true);
              } 
              if (doc?.docNameDms === "offer_letter" && (formUserData?.admissionStatus?.toLowerCase()==="confirmed" || formUserData?.admissionStatus?.toLowerCase()==="applied")) {
                doc.isMandatory = false;
                doc.byDefault = true;
                return;
              }
              else {
                updateDocument(doc, false, false);
              }

              // Handle documents based on employment type
              if (coapplicantEmploytype == "Salaried") {
                const isSalarySlip = doc?.docName.includes("Salary Slips") || doc?.docNameDms == "salary_slip";
                updateDocument(doc, isSalarySlip, basicCoAppPayparty == "Yes" ? true : false);
              } else if (coapplicantEmploytype == "SENP") {
                const isItrOrGst = (doc?.docName.includes("ITR") || doc?.docNameDms == "itr") ||
                  (doc?.docName.includes("GST") || doc?.docNameDms == "business_proof");
                updateDocument(doc, isItrOrGst, basicCoAppPayparty == "Yes" ? true : false);
              } else if (coapplicantEmploytype == "SEP") {
                const isItr = doc?.docName.includes("ITR") || doc?.docNameDms == "itr";
                updateDocument(doc, isItr, basicCoAppPayparty == "Yes" ? true : false);
              } else if (coapplicantEmploytype == "Farmer" || coapplicantEmploytype == "Others") {
                const isBankStatement = doc?.docName.includes("Bank Statement") || doc?.docNameDms == "account_statement";
                if (basicCoAppPayparty == "Yes") {
                  updateDocument(doc, isBankStatement, true);
                } else {
                  updateDocument(doc, isBankStatement, false);
                }
              }
            });

          }
          if (tabIndex === 0) {
            // Process documents based on employment type in a single loop
            documentList?.forEach((doc: any) => {
              // Helper function to update document properties
              const updateDocument = (doc: any, isMatch: boolean, isMandatory: boolean) => {
                if (isMatch) {
                  doc.byDefault = true;
                  doc.isMandatory = isMandatory;
                }
              };
              if (doc?.docNameDms === "offer_letter" && (formUserData?.admissionStatus?.toLowerCase()==="undecided" || formUserData?.admissionStatus?.toLowerCase()==="applied")) {
                doc.isMandatory = false;
                doc.byDefault = false;
              } 
              if(formUserData?.admissionStatus?.toLowerCase()==="confirmed" && doc?.docName === "I-20"){
                doc.isMandatory = false;
                doc.byDefault = true;
              }
              else if (formUserData?.employmentType == "Salaried" && doc?.docNameDms == "salary_slip") {
                const isSalarySlip = doc?.docName.includes("Salary Slips") || doc?.docNameDms == "salary_slip" ;
                updateDocument(doc, isSalarySlip, true);
              } else if ((formUserData?.employmentType == "Salaried" || formUserData?.employmentType === "SEP" || formUserData?.employmentType === "SENP"|| formUserData?.employmentType === "Others" || formUserData?.employmentType === "Farmer") && doc?.docName === "Bank Statement") {
                updateDocument(doc, true, true);
              }
              else if (formUserData?.employmentType == "SENP" && (doc?.docNameDms == "salary_slip" || doc?.docNameDms == "business_proof")) {
               updateDocument(doc, true, true);
              } else if (formUserData?.employmentType == "SEP" && doc?.docNameDms == "salary_slip") {
                const isItr = doc?.docName.includes("Proof of Income (Salary Slips/ITR)") || doc?.docNameDms == "salary_slip";
                //isPayPartyValue == "Yes" ? true : false
                updateDocument(doc, isItr, true);
              } else if (formUserData?.employmentType == "Farmer" || formUserData?.employmentType == "Others") {
                const isBankStatement = doc?.docName.includes("Bank Statement") || doc?.docNameDms == "account_statement";
                if (isPayPartyValue == "Yes") {
                  updateDocument(doc, isBankStatement, true);
                } else {
                  updateDocument(doc, isBankStatement, false);
                }
              }
              // if(doc?.docName === "Bank Statement"){
              //   doc.isMandatory = true;
              //   doc.byDefault = true;
              // }

              
            });

          }
          const hasRequiredDocument: any[] = documentList?.filter((doc: any) => {
                return (
                  doc?.byDefault || doc?.isMandatory || doc?.userDocs?.length > 0
                );
              });

          const hasNotRequiredDocument: any[] = documentList?.filter((doc: any) => {
                return !doc?.byDefault && !doc?.isMandatory;
              });
          item.documents = hasRequiredDocument;

          if (partnerStartedJourney) {
            if (item?.documents?.length > 0) {
              arrayOfData.push(item);
            }
          } else if (tabIndex > 0) {
            if (item?.isMand) {
              arrayOfData.push(item);
            }
          } else {
            arrayOfData.push(item);
          }

          if (hasNotRequiredDocument.length > 0) {
            hasNotRequiredDocumentData.push(...hasNotRequiredDocument);
          }
        });

        // Check for Address Proof and Academic Documents with decentroConsentStatus as "Request"
        // and Income Document with aaConsentStatus as "Request"
        arrayOfData.forEach((item: any) => {
          if (
            item?.name === "Address Proof" ||
            item?.name === "Academic Documents"
          ) {
            const matchedDoc = item?.documents?.find(
              (doc: any) => doc?.decentroConsentStatus === "Requested"
            );

            if (matchedDoc?.decentroConsentStatus === "Requested") {
              // Store document in localStorage
              localStorage.setItem(
                "docIdAggregator",
                matchedDoc?.id.toString()
              );
              localStorage.setItem(
                "docItemDigiLocker",
                JSON.stringify(matchedDoc)
              );
              setApiCallDigi(true);
            }
          }

          if (item?.name === "Income Document") {
            const matchedDocone = item?.documents?.find(
              (doc: any) => doc?.aaConsentStatus === "Requested"
            );
            if (matchedDocone?.aaConsentStatus === "Requested") {
              // Store document in localStorage
              localStorage.setItem(
                "docIdAggregator",
                matchedDocone?.id.toString()
              );
              localStorage.setItem(
                "docItemAggregator",
                JSON.stringify(matchedDocone)
              );
              setApiCallAgg(true);
            }
          }
        });

        setDocumentData(arrayOfData);
        setHasNotRequiredDocument(hasNotRequiredDocumentData);

        const cacheApplicantIndex = tabIndex === 0 ? 0 : (isApplicant ? tabIndex : findApplicantIndex);
        lastFetchedApplicantDocsRef.current[cacheApplicantIndex] = respData;
      }
    } catch (error: any) {
      console.log(error, "error");
    } finally {
      setIsLoadingDoc(false);
      setIsLoading(false);
    }
  };

  // To fetch aaConsentDuration data and show it in from and to date with initial value
  const getAAConsentDuration = async () => {
    try {
      const response: any = await eligibilityCheckServices.getConsentDurationData(
        submissionTrackingId
      );
      if (
        response &&
        response.status === 200 &&
        response?.data.status === "success"
      ) {
        const data = {
          applicant: response?.data?.data.applicant,
          coApplicants: response?.data?.data.coApplicants,
          trackingId: response?.data?.data?.trackingId,
        };
        const {
          fromDate,
          toDate,
          consentDuration,
          consentDurationValue,
          consentType,
          dataType,
          updatedAt
        }: {
          fromDate: string;
          toDate: string;
          consentDuration: string;
          consentDurationValue: string;
          consentType: string;
          dataType: string;
          updatedAt: string;
        } = getInitialFromAndToData(data);
        applyConsentDates(fromDate, toDate, consentType, updatedAt);
        setConsentDurData({
          consentDuration,
          consentDurationValue,
          consentType,
        });
        setDataType(dataType || dataTypeOptions[0].value);
        setUpdatedAt(updatedAt);
      }
    } catch (err) {
      console.error("Error while getting getAAConsentDuration", err);
    }
  };

  function getInitialFromAndToData(consentDurationData: any) {
    let consentType = "periodic";
    let dataType = dataTypeOptions[0].value;
    let { fromDate, toDate } = getConsentDefaults(consentType);
    let consentDuration = CONSENT_DURATION_UNIT;
    let consentDurationValue = getDerivedConsentDurationValue(fromDate, toDate);
    let updatedAt;

    if (Object.keys(consentDurationData)?.length) {
      if (tabIndex === 0) {
        consentType = consentDurationData.applicant?.aaConsentType;
        dataType = consentDurationData.applicant?.aaBankingDataType;
        const defaults = getConsentDefaults(consentType);
        if(new Date(defaults.fromDate)> new Date(formatDateAndTime(consentDurationData.applicant.aaFromDate))){
          // Get FROM and TO date from applicant
          fromDate = defaults.fromDate;
          toDate = defaults.toDate;
        }else {
          // Get FROM and TO date from applicant
          fromDate = consentDurationData.applicant?.aaFromDate
            ? formatDateAndTime(consentDurationData.applicant.aaFromDate)
            : defaults.fromDate;
          toDate = consentDurationData.applicant?.aaToDate
            ? formatDateAndTime(consentDurationData.applicant.aaToDate)
            : defaults.toDate;
        }
        updatedAt = consentDurationData.applicant?.aaConsentCreationDate;
      } else if (tabIndex >= 1) {
        // Get FROM and TO date from coApplicants
        const coApplicant: any = consentDurationData?.coApplicants?.find(
          (item: any) => {
            if (tabIndex === parseInt(item?.coApplicantType.match(/\d+/)[0])) {
              return item;
            }
          }
        );
        consentType = coApplicant?.aaConsentType || "periodic";
        dataType = coApplicant?.aaBankingDataType;
        const defaults = getConsentDefaults(consentType);
        if(new Date(defaults.fromDate)> new Date(formatDateAndTime(coApplicant.aaFromDate))){
          // Get FROM and TO date from applicant
          fromDate = defaults.fromDate;
          toDate = defaults.toDate;
        }else {
          fromDate = coApplicant?.aaFromDate
            ? formatDateAndTime(coApplicant.aaFromDate)
            : defaults.fromDate;
          toDate = coApplicant?.aaToDate
            ? formatDateAndTime(coApplicant.aaToDate)
            : defaults.toDate;
        }
        updatedAt = coApplicant?.aaConsentCreationDate;
      }
    }

    consentDurationValue = getDerivedConsentDurationValue(fromDate, toDate);
    return {
      fromDate,
      toDate,
      consentDuration,
      consentDurationValue,
      consentType: consentType,
      dataType: dataType,
      updatedAt
    };
  }

  useEffect(() => {
    if (submissionTrackingId) {
      getAAConsentDuration();
    }
  }, [tabIndex]);

  useEffect(() => {
    if (documentApplicantType === "") {
      dispatch(setDocumentApplicantType("Applicant"));
    }
  }, []);

  // API call when component mounts
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // let payload = {
        //   trackingId: submissionTrackingId,
        // };
        // // Uncomment below when real API is ready
        // const response = await eligibilityCheckServices.getApplicantDetails(
        //   payload
        // );
        // if (response?.status === 200) {
        //   setApplicantDetails(response.data?.data || []);
        // }
        // Call bulk document count API if trackingId is available
        if (submissionTrackingId) {
          handleDocCount(submissionTrackingId);
        }
      } catch (error: any) {
        console.error("API call failed:", error);
        // Handle error - you might want to show a toast or dispatch an error action
        dispatch(
          setStatusPopup({
            isOpen: true,
            status: "error",
            message:
              error?.response?.data?.message || "Failed to load initial data",
          })
        );
      }
    };

    fetchInitialData();
  }, []); // Empty dependency array means this runs only on component mount

  // Reset aggregator push document tracking on component mount
  useEffect(() => {
    pushedAggregatorDocuments.current.clear();
  }, []); // Runs once on component mount
const isMdOrBelow = useMediaQuery(theme.breakpoints.down("md")); // xs, sm, md
  // Direct file upload handler
  const handleUploadDocument = (
    docId: number,
    item: any,
    bankName?: any,
    categoryName?: string
  ) => {
    if (!canManualUploadDocument(item, categoryName)) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: "This document cannot be uploaded for the selected applicant in partner journey.",
        })
      );
      return;
    }

    pendingScrollSectionRef.current = categoryName || null;

    if (item.uploadedVia === "account_agreegator") {
      setUploadedVia(UploadVia.Account_Aggregator_Manual);
    } else {
      setUploadedVia(UploadVia.Manual);
    }
    if (bankName) {
      setBankName(bankName);
    }
    // Check if this is a Bank Statement with multiple uploads
    const isBankStatement = item?.docName
      ?.toLowerCase()
      .includes("bank statement");
    const hasMultipleUploads = item?.userDocs && item?.userDocs?.length > 1;

    if (isBankStatement && hasMultipleUploads) {
      // Show confirmation modal for bank statements with multiple documents
      setPendingUploadDocId(docId);
      setPendingUploadItem(item);
      // setIsBankStatementConfirmModalOpen(true);
      handleConfirmBankStatementUpload(docId, item);
    } else {
      // Proceed with direct upload
      proceedWithUpload(docId, item);
    }
  };

  const proceedWithUpload = (docId: number, item: any) => {
    // Trigger file input directly
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
    setDocId(docId);
    setDocTypeItem(item);
    setDocType(item?.docNameDms || "");
    setDocName(item?.docName?.replace(/\s+/g, "").toUpperCase() || "");
  };

  const handleConfirmBankStatementUpload = (
    penUploadDocId?: any,
    penUploadItem?: any
  ) => {
    if (penUploadDocId) {
      penUploadDocId = penUploadDocId;
    } else {
      penUploadDocId = pendingUploadDocId;
    }
    if (penUploadItem) {
      penUploadItem = penUploadItem;
    } else {
      penUploadItem = pendingUploadItem;
    }
    setIsBankStatementConfirmModalOpen(false);
    proceedWithUpload(penUploadDocId, penUploadItem);
    setPendingUploadDocId(0);
    setPendingUploadItem(null);
  };

  const handleCancelBankStatementUpload = () => {
    setIsBankStatementConfirmModalOpen(false);
    setPendingUploadDocId(0);
    setPendingUploadItem(null);
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fileExtension = file.name.split(".").pop()?.toLowerCase() || "";
      const fileType = file.type.toLowerCase();

      // Validate file size (optional - 5MB limit)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        dispatch(
          setStatusPopup({
            status: "error",
            message: "File size must be less than 5MB.",
          })
        );
        return;
      }

      // Check if file is PDF (by extension - PDF validation can be added later if needed)
      const isPdf = fileExtension === "pdf" || fileType === "application/pdf";

      // For images, validate using magic bytes (file signature)
      // SECURITY: We do NOT trust file.name extension or file.type MIME type
      if (!isPdf) {
        const validationResult = await validateImageFile(file);

        if (!validationResult.isValid) {
          // File is not a valid image - reject it
          dispatch(
            setStatusPopup({
              status: "error",
              message: "File is not a valid image format. Only PNG, JPEG, WEBP, and GIF are allowed.",
            })
          );
          // Reset the input value
          if (event.target) {
            event.target.value = "";
          }
          return;
        }

        // File is valid - use detected image type
        const detectedImageType = validationResult.type!;

        // Convert file to base64
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64String = e.target?.result as string;

          // Ensure we have a valid base64 string
          if (!base64String || !base64String.startsWith("data:")) {
            dispatch(
              setStatusPopup({
                status: "error",
                message: "Failed to process the file. Please try again.",
              })
            );
            return;
          }

          // Remove the data URL prefix for images
          const base64Data = base64String.split(",")[1];
          const processedBase64String = base64Data || base64String;

          // Use detected image type instead of MIME type
          const fileFormat = detectedImageType;

          // Call upload function with base64 data
          handleUploadDocumentSubmit(processedBase64String, fileFormat);
        };

        reader.onerror = () => {
          dispatch(
            setStatusPopup({
              status: "error",
              message: "Error reading the file. Please try again.",
            })
          );
        };

        reader.readAsDataURL(file);
      } else {
        // Handle PDF files (no magic byte validation for PDFs in this implementation)
        // Convert file to base64
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64String = e.target?.result as string;

          // Ensure we have a valid base64 string
          if (!base64String || !base64String.startsWith("data:")) {
            dispatch(
              setStatusPopup({
                status: "error",
                message: "Failed to process the file. Please try again.",
              })
            );
            return;
          }

          // For PDFs, remove the data URL prefix as well
          const base64Data = base64String.split(",")[1];
          const processedBase64String = base64Data || base64String;

          // Use PDF as file format
          const fileFormat = "pdf";

          // Call upload function with base64 data
          handleUploadDocumentSubmit(processedBase64String, fileFormat);
        };

        reader.onerror = () => {
          dispatch(
            setStatusPopup({
              status: "error",
              message: "Error reading the file. Please try again.",
            })
          );
        };

        reader.readAsDataURL(file);
      }
    }
    // Reset the input value to allow selecting the same file again
    if (event.target) {
      event.target.value = "";
    }
  };

  const handleUploadDocumentSubmit = async (
    base64Data: string,
    fileFormat: string
  ) => {
    try {
      setUploadDocumentLoading(true);
      setIsLoading(true);
      const oldUploadDocumentLoader = [...uploadDocumentLoader];
      if(docId!==0){
        const payload: any = {
          formSubmissionTrackingId: submissionTrackingId,
          userId: Number(decrypt(userProfile?.id)),
          documentId: String(docId),
          uploadedVia: uploadedVia,
          fileFormat: fileFormat,
          userType:
            tabIndex == 0
              ? "Applicant"
              : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
          base64Data: base64Data,
        };

        if (bankName) {
          payload.bankName = bankName;
        }

        oldUploadDocumentLoader.push(docId);
        setUploadDocumentLoader(oldUploadDocumentLoader);
        const response: any = await eligibilityCheckServices.uploadDocument(
          payload
        );
        if (response?.status == 201 || response?.status == 200) {
          // Call push document API after successful upload
          try {
            // Sanitize docName: remove parentheses and replace forward slashes with underscores
            const sanitizedDocName = docName.replace(/[()]/g, '').replace(/\//g, '_');
            let pushPayload: any = {
              eventName:
                tabIndex === 0
                  ? `APPLICANT_${sanitizedDocName}_PUSH_DOCUMENT`
                  : `COAPPLICANT${findCoApplicantNumber}_${sanitizedDocName}_PUSH_DOCUMENT`,
              userApplicantType:
                tabIndex === 0
                  ? "Applicant"
                  : `Co-Applicant ${findCoApplicantNumber}`,
              trackingId: submissionTrackingId,
              docType: docType,
              applicantId:
                tabIndex === 0
                  ? Number(fetchUserApplicationData?.applicantId)
                  : partnerStartedJourney
                    ? Number(
                      coApplicantDetails?.[
                        `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
                      ]?.coApplicantId ?? ""
                    )
                    : tabIndex === 0
                      ? Number(fetchUserApplicationData?.applicantId)
                      : Number(localStorage.getItem("coAppId")),
              applicationId: applicationId
                ? Number(applicationId)
                : Number(fetchUserApplicationData?.applicationId),
              documentFilePath: response?.data?.data?.url || "",
            };

            if (docTypeItem?.docName === "Class X Marksheet") {
              pushPayload.appEducationId = 283;
            } else if (docTypeItem?.docName === "Class XII Marksheet") {
              pushPayload.appEducationId = 284;
            } else if (docTypeItem?.docName === "Graduation Marksheets") {
              pushPayload.appEducationId = 286;
            } else if (docTypeItem?.docName === "Diploma") {
              pushPayload.appEducationId = 285;
            }
            if (
              docTypeItem?.docType === "PANCR" ||
              docTypeItem?.docName === "PAN"
            ) {
              pushPayload.applicantHasPanCardFlag = true;
            }
            // extract exam name after '-'
            const examNameFrom = docTypeItem?.docName.split("-").pop().trim();
            const matchcoreExam = coreExamList?.find(
              (item: any) => item.value === examNameFrom
            );
            const matchLanguageExam: any = languageExamSystemValues?.find(
              (item: any) => item.value === examNameFrom
            );
            const matchCoreexam:any=coreExamSystemValues?.find(
              (item: any) => item.value === examNameFrom
            );
            if (
              matchLanguageExam != undefined &&
              matchLanguageExam != null &&
              matchLanguageExam != ""
            ) {
              pushPayload.serialId = matchLanguageExam?.id;
            }
            if (
              matchCoreexam != undefined &&
              matchCoreexam != null &&
              matchCoreexam != ""
            ) {
              pushPayload.serialId = matchCoreexam?.id;
            }
            if (
              docType &&
              ((tabIndex == 0 &&
                pushPayload.applicantId > 0 &&
                pushPayload.applicationId > 0) ||
                (tabIndex > 0 && pushPayload.applicationId > 0))
            ) {
              await eligibilityCheckServices.pushDocument(pushPayload);
            }
          } catch (pushError: any) {
            console.error("Push document failed:", pushError);
            // Continue with the flow even if push fails
          }

          setDocId(0);
          getDocumentCategoriesViaAPI();
          setDocumentsMutationTick((t) => t + 1);
          oldUploadDocumentLoader.splice(
            oldUploadDocumentLoader.indexOf(docId),
            1
          );
          setUploadDocumentLoader(oldUploadDocumentLoader);
        }
      }
    } catch (error: any) {
      const oldUploadDocumentLoader = [...uploadDocumentLoader];
      oldUploadDocumentLoader.splice(oldUploadDocumentLoader.indexOf(docId), 1);
      setUploadDocumentLoader(oldUploadDocumentLoader);
      dispatch(
        setStatusPopup({
          status: "error",
          message: error?.response?.data?.message ?? 
            "Document format must be either jpg, jpeg, png, or pdf or Please try again.",
        })
      );
    } finally {
      setIsLoading(false);
      setUploadDocumentLoading(false);
    }
  };

  const handlePreviewDocument = async (docPath: string) => {
    try {
      const payload = {
        key: docPath,
      };

      setIsLoadingButton(true);
      const response = await eligibilityCheckServices.previewDocument(payload);
      setIsLoadingButton(false);
      if (response?.status == 200) {
        setViewDocUrl(response?.data?.data?.downloadUrl);
        setIsModalOpen(true);
      }
    } catch (error) {
      setIsLoadingButton(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message: "Failed to load document preview. Please try again.",
        })
      );
    }
  };

  const handlePreviewDownloadDocument = async (
    uuid: string,
    s3Location: string
  ) => {
    let payload: any = {
      trackingId: applicationNumber,
    };
    if (uuid) {
      payload.uuid = uuid;
    }
    if (s3Location) {
      payload.s3location = s3Location;
    }
    if (uuid == null && s3Location == null) {
      setViewDocUrl("");
      setViewDocMimeType("pdf");
      setIsModalOpen(true);
      return;
    }
    try {
      setIsLoadingButton(true);
      const response = await eligibilityCheckServices.downloadDocument(payload);
      setIsLoadingButton(false);
      if (response?.status === 200) {
        const base64Data = response?.data?.data?.data ?? response?.data?.data;
        if (s3Location) {
          setViewDocUrl(base64Data);
        } else {
          const { url, mimeType } = decodeBase64FileToUrl(base64Data);
          setViewDocUrl(url);
          setViewDocMimeType(mimeType);
        }
        setIsModalOpen(true);
      }
    } catch (error) {
      setIsLoadingButton(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message: "Failed to load document preview. Please try again.",
        })
      );
    }
  };

  const handlePreviewAggregateDocument = async (docPath: string) => {
    try {
      const payload = {
        key: docPath,
      };
      const response = await eligibilityCheckServices.previewAggregateDocument(
        payload
      );
      if (response?.status == 200) {
        setViewDocUrl(response?.data?.data?.downloadUrl);
        setIsModalOpen(true);
      }
    } catch (error) {
      setIsLoadingButton(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message: "Failed to load document preview. Please try again.",
        })
      );
    }
  };
  
  useEffect(() => {
    if (formUserData?.product) {
      getDocumentCategoriesViaAPI();
    }
    // handleGetDocumentList();
  }, [
    tabIndex,
    formUserData?.product,
    partnerStartedJourney,
    isPayPartyValue,
    formUserData?.employmentType,
    location?.pathname==="/application/upload-document",
    triggerData?.toUser===false,
    JSON.stringify(applicants),
  ]);

  useEffect(() => {
    const sectionName = pendingScrollSectionRef.current;
    if (!sectionName || isLoading || isLoadingDoc) return;

    const section = Array.from(
      document.querySelectorAll<HTMLElement>("[data-document-section]")
    ).find((element) => element.dataset.documentSection === sectionName);
    if (!section) return;

    pendingScrollSectionRef.current = null;
    requestAnimationFrame(() => {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [documentData, isLoading, isLoadingDoc]);

  const handleShowAddMoreDocument = (id: number) => {
    setIsAddMoreModalOpen(true);
    handleGetCategoryList(id);
    setModelType("addSubDocument");
  };

  const handleGetCategoryList = async (id: number) => {
    setDocumentCategoryId(id);
    try {
      const response =
        await eligibilityCheckServices.getDocumentCategoriesApi();
      if (response?.status == 200) {
        const arrayOfObject: any[] = [];
        arrayOfObject.unshift({
          value: "",
          label: "Select Document Category",
        });
        response?.data?.data?.forEach((item: any) => {
          arrayOfObject.push({
            value: item?.id,
            label: item?.name,
          });
        });
        setDocumentCategories(arrayOfObject);
        if (id != 0) {
          handleGetMasterDocumentList(id);
        }
      }
    } catch (error: any) {
      console.log(error, "error");
    }
  };

  const handleGetMasterDocumentList = async (documentCategoryId: number) => {
    try {
      const payload = {
        productType: formUserData?.product,
        typeOfApplicant: tabIndex == 0 ? "Applicant" : applicants?.[tabIndex],
        status: "active",
        documentCategoryId: documentCategoryId,
        employmentCategory: tabIndex == 0 ? formUserData?.employmentType || formUserData?.applicantType : formUserData?.[`employmentCoApplicant${applicants?.[tabIndex]?.split(" ")?.[1]}employmentType`] || formUserData?.applicantType,
      };

      const response = await eligibilityCheckServices.getDocumentList(payload);
      if (response?.status == 200) {
        const arrayOfObject: any[] = [];
        arrayOfObject.unshift({
          value: "",
          label: "Select Document",
        });
        response?.data?.data?.forEach((item: any) => {
          arrayOfObject.push({
            value: item?.id,
            label: item?.docName,
          });
        });
        arrayOfObject.push({
          value: "Others",
          label: "Others",
        });
        setMasterDocumentList(arrayOfObject);
      }
    } catch (error: any) {
      console.log(error, "error");
    }
  };

  const getAppCoApplicantDetails = (type: any) => {
    // TAB 0 → Primary applicant
    if (type === "name") {
      if (tabIndex === 0) {
        if (!partnerStartedJourney) {
          return `${formUserData?.firstName} ${formUserData?.lastName}`;
        }

        if (!mainApplicantDetails) {
          return "";
        }

        const firstName = mainApplicantDetails.find(
          (item: any) => item.name === "firstName"
        )?.value;

        const lastName = mainApplicantDetails.find(
          (item: any) => item.name === "lastName"
        )?.value;

        const fullName = [firstName, lastName].filter(Boolean).join(" ");

        return `${fullName || "-"}`;
      }
      // TAB ≠ 0 → Co-applicant
      if (partnerStartedJourney) {
        const key: any = `coapplicant${findCoApplicantNumber}`;
        const co = coApplicantDetails?.[key];
        return co?.coApplicantName || "";
      }
      const key: any = `coapplicant${findCoApplicantNumber}`;
      const co = coApplicantDetails?.[key];
      const first = co?.FirstName || "";
      const last = co?.LastName ? ` ${co.LastName}` : "";
      const fullName = `${first}${last}`.trim();
      return fullName || co?.coApplicantName || "";
    }
    if (type === "email") {
      // TAB ≠ 0 → Co-applicant
      if (tabIndex === 0) {
        if (partnerStartedJourney) {
          if (!mainApplicantDetails) return "NA";

          const email = mainApplicantDetails.find(
            (item: any) => item.name === "email"
          )?.value;

          return email && email !== "" ? email : "";
        }

        const email = formUserData?.email;
        return email && email !== "" ? email : "";
      }
      const keyone: any = `coapplicant${findCoApplicantNumber}`;
      const co = coApplicantDetails?.[keyone];

      if (!co) return "";

      if (partnerStartedJourney) {
        const email = co?.coApplicantEmail;
        return email && email !== "" ? email : "";
      }

      const email = co?.Email;
      return email && email !== "" ? email : co?.coApplicantEmail;
    }
    if (type === "phone") {
      if (tabIndex === 0) {
        if (partnerStartedJourney) {
          if (!mainApplicantDetails) return "";
          const phone = mainApplicantDetails.find(
            (item: any) => item.name === "phone_number"
          )?.value;

          return phone && phone !== "" ? phone : "";
        }

        const phone = formUserData?.phone_number;
        return phone && phone !== "" ? phone : "";
      }
      // TAB ≠ 0 → Co-applicant
      const key: any = `coapplicant${findCoApplicantNumber}`;
      const co = coApplicantDetails?.[key];
      if (!co) return "";

      if (partnerStartedJourney) {
        const phone = co?.coApplicantPhone;
        return phone && phone !== "" ? phone : "";
      }

      const phone = co?.PhoneNumber;
      return phone && phone !== "" ? phone : co?.coApplicantPhone;
    }
  };

  const handleAccountAggregatorRequest = async (
    id: number,
    type: string,
    item: any
  ) => {

    try {
      dispatch(
        setDocumentApplicantType(
          tabIndex == 0
            ? "Applicant"
            : applicants?.[isApplicant ? tabIndex : findApplicantIndex]
        )
      );
      setAggregatorLoader(true);
      const accountAggregatorMobileFromRedux =
        localStorage.getItem("accountAggregatorMobile") || "";
      const requestDates = getRequestConsentDates(type);
      const derivedConsentDuration = CONSENT_DURATION_UNIT;
      const derivedConsentDurationValue = getDerivedConsentDurationValue(
        requestDates.fromDate,
        requestDates.toDate,
      );
      let payload: any;
       const payloadD = {
        trackingId: applicationNumber,
        coApplicantType:  tabIndex == 0
              ? "Applicant"
              : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
        consentType: consentDurData?.consentType || "periodic",
              consentDuration: consentDurData?.consentType==="one_time"?CONSENT_DURATION_UNIT_ONE:derivedConsentDuration,
              consentDurationValue:consentDurData?.consentType==="one_time"?"1": derivedConsentDurationValue,
        fromDate: new Date(requestDates.fromDate).toISOString().split("T")[0] + "T00:00:00Z",
        toDate: new Date(requestDates.toDate).toISOString().split("T")[0] + "T00:00:00Z",
        bankingDataType: dataType,
      };

      await eligibilityCheckServices.saveConsentDuration(payloadD);
      if (type !== "button") {
        applyConsentDates(requestDates.fromDate, requestDates.toDate, consentDurData?.consentType || "periodic", updatedAt || "");
      }
      if (type === "button") {
        const currentDate = new Date();
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(currentDate.getMonth() - 6);

        payload = {
          applicationNo: applicationNumber,
          name: getAppCoApplicantDetails("name"),
          mobile: getAppCoApplicantDetails("phone"),
          aaConsentMobileNo: getAppCoApplicantDetails("phone"),
          email: getAppCoApplicantDetails("email"),
          consentDuration: consentDurData?.consentType==="one_time"?CONSENT_DURATION_UNIT_ONE:derivedConsentDuration,
          consentDurationValue:consentDurData?.consentType==="one_time"?"1": derivedConsentDurationValue,
          consentType: consentDurData?.consentType || "periodic",
          bankingDataType: dataTypeOptions[0].value,
          // fromDate:
          //   new Date(sixMonthsAgo).toISOString().split("T")[0] + "T00:00:00Z",
          // toDate:
          //   new Date(currentDate).toISOString().split("T")[0] + "T00:00:00Z",
          fromDate: new Date(requestDates.fromDate).toISOString().split("T")[0] + "T00:00:00Z",
          toDate: new Date(requestDates.toDate).toISOString().split("T")[0] + "T00:00:00Z",
          // redirectUrl:`${window.location.origin}/application/apply-now`,
          redirectUrl: window.location.href,
          applicantType:
            tabIndex == 0
              ? "Applicant"
              : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
        };
      } else {
        payload = {
          applicationNo: applicationNumber,
          name: getAppCoApplicantDetails("name"),
          mobile: getAppCoApplicantDetails("phone"),
          aaConsentMobileNo:
            accountAggregatorMobileNumber ?? accountAggregatorMobileFromRedux,
          email: getAppCoApplicantDetails("email"),
          fromDate:
            new Date(requestDates.fromDate).toISOString().split("T")[0] + "T00:00:00Z",
          toDate: new Date(requestDates.toDate).toISOString().split("T")[0] + "T00:00:00Z",
          consentDuration: consentDurData?.consentType==="one_time"?CONSENT_DURATION_UNIT_ONE:derivedConsentDuration,
          consentDurationValue:consentDurData?.consentType==="one_time"?"1": derivedConsentDurationValue,
          consentType: consentDurData?.consentType || "periodic",
          bankingDataType: dataType,
          // redirectUrl: `${window.location.origin}/application/apply-now`,
          redirectUrl: window.location.href,
          applicantType:
            tabIndex == 0
              ? "Applicant"
              : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
        };
      }

      const response = await eligibilityCheckServices.accountAggregatorRequest(
        payload
      );
      if (response?.status == 200) {

        dispatch(
          setConsentApplicationNo(
            response?.data?.data?.data?.consentApplicationNo
          )
        );
        dispatch(setDocumentUploadId(id));
        localStorage.setItem("docIdAggregator", id.toString());
        localStorage.setItem("docItemAggregator", JSON.stringify(item));
        let url = response?.data?.data?.data?.link;
        if (url && !/^https?:\/\//i.test(url)) {
          // If no protocol, add https:// (or http:// depending on your case)
          url = "https://" + url;
        }

        await trackCustomerJourneyEventAndWait(
          tabIndex == 0 ? `APPLICANT_ACCOUNTAGGREGATOR` : `COAPPLICANT${findCoApplicantNumber}_ACCOUNTAGGREGATOR_DIGILOCKER`,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: tabIndex == 0 ? `APPLICANT_ACCOUNTAGGREGATOR` : `COAPPLICANT${findCoApplicantNumber}_ACCOUNTAGGREGATOR_DIGILOCKER`,
            category: tabIndex == 0 ? `APPLICANT_ACCOUNTAGGREGATOR` : `COAPPLICANT${findCoApplicantNumber}_ACCOUNTAGGREGATOR_DIGILOCKER`,
            action: tabIndex == 0 ? `APPLICANT_ACCOUNTAGGREGATOR` : `COAPPLICANT${findCoApplicantNumber}_ACCOUNTAGGREGATOR_DIGILOCKER`,
            page: tabIndex == 0 ? "Applicant Account Aggregator" : `Co-Applicant ${findCoApplicantNumber} Account Aggregator`,
          }
        , 500);

        window.location.href = url;
      }
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: error?.response?.data?.message,
        })
      );
    } finally {
      setAggregatorLoader(false);
    }
  };

  const handleAccountAggregatorRequestConsent = async () => {
    if (tabIndex < 0) return;

    let docItem: any = JSON.parse(
      localStorage.getItem("docItemAggregator") || "{}"
    );
    setIsAggregateVerify(true);
    setAggregatorLoader(true);
   const derivedConsentDuration = CONSENT_DURATION_UNIT;
      const derivedConsentDurationValue = getDerivedConsentDurationValue(
        fromDate,
        toDate,
      );
    try {
      const payload = {
        docId: localStorage.getItem("docIdAggregator") || "",
        typeOfApplicant: tabIndex == 0 ? "Applicant" : applicants?.[tabIndex],
        applicationId: consentApplicationNo || docItem?.utilityAaAppNo || "",
        aaConsentMobileNo: accountAggregatorMobileFromRedux || docItem?.aaConsentMobileNo || "",
        mobile: getAppCoApplicantDetails("phone"),
      };

      const currentSearch = location?.search || "";
      const consentCleanupPaths = [
        "/application/apply-now",
        "/application/upload-document",
        "/application/summary",
        "/application/loan-summary",
      ];
      if (currentSearch.includes("consent=true") && consentCleanupPaths.includes(window.location.pathname)) {
        const newSearch = currentSearch.replace(/[?&]consent=true/g, "");
        const cleanSearch = newSearch.replace(/^\?&/, "?").replace(/^&/, "?");
        const newUrl = `${window.location.pathname}${cleanSearch}`;
        navigate(newUrl, { replace: true });
      }

      // Retry logic: Try every 10 seconds for up to 30 seconds (3 attempts total)
      const MAX_ATTEMPTS = 3;
      const RETRY_DELAY = 10000; // 10 seconds
      let response: any = null;
      let documentsFound = false;

      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        try {
          response =
            await eligibilityCheckServices.accountAggregatorRequestConsent(
              payload
            );

          if (response?.status === 200) {
            const userDocs = response?.data?.data?.userDocs || [];

            // Check if documents were found
            if (userDocs.length > 0) {
              documentsFound = true;
              break; // Exit loop as documents are found
            } else {

              // If not the last attempt, wait before retrying
              if (attempt < MAX_ATTEMPTS) {
                await new Promise((resolve) =>
                  setTimeout(resolve, RETRY_DELAY)
                );
              }
            }
          }
        } catch (apiError: any) {
          console.error(`API call failed on attempt ${attempt}:`, apiError);

          // If not the last attempt, wait before retrying
          if (attempt < MAX_ATTEMPTS) {
            await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
          }
        }
      }

      // After all attempts, check if documents were found
      if (!documentsFound) {
        const cleanUrl = window.location.origin + window.location.pathname;
    
        // History state replace karein bina page refresh kiye
        window.history.replaceState(null, '', cleanUrl);
        dispatch(
          setStatusPopup({
            status: "error",
            message:
              "Not able to get data from account aggregator after multiple attempts",
          })
        );
        setIsAggregateVerify(false);
        setAggregatorLoader(false);
        return;
      }

      // Process the successful response with documents
      if (response?.status === 200 && documentsFound) {
        const cleanUrl = window.location.origin + window.location.pathname;
    
        // History state replace karein bina page refresh kiye
        window.history.replaceState(null, '', cleanUrl);
        const fiDetailsVal = response?.data?.data?.userDocs || [];
        const docNamed = docItem?.docName?.replace(/\s+/g, "").toUpperCase();
        // Loop through each document in fiDetailsVal
        for (const fiDetail of fiDetailsVal) {
          const documentPath = fiDetail?.url;
          // Only push if path exists and hasn't been pushed before
          if (
            documentPath
          ) {
            const pushPayload: any = {
              eventName:
                tabIndex === 0
                  ? `APPLICANT_${docNamed}_PUSH_DOCUMENT`
                  : `COAPPLICANT${findCoApplicantNumber}_${docNamed}_PUSH_DOCUMENT`,
              trackingId: submissionTrackingId,
              docType: docType || docItem?.docNameDms || "",
              applicantId:
                tabIndex === 0
                  ? Number(fetchUserApplicationData?.applicantId)
                  : partnerStartedJourney
                    ? Number(
                      coApplicantDetails?.[
                        `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
                      ]?.coApplicantId ?? ""
                    )
                    : tabIndex === 0
                      ? Number(fetchUserApplicationData?.applicantId)
                      : Number(localStorage.getItem("coAppId")),
              applicationId: applicationId
                ? Number(applicationId)
                : Number(fetchUserApplicationData?.applicationId),
              documentFilePath: documentPath,
              userApplicantType:
                tabIndex === 0
                  ? "Applicant"
                  : `Co-Applicant ${findCoApplicantNumber}`,
            };

            if (
              pushPayload.docType &&
              ((tabIndex == 0 &&
                pushPayload.applicantId > 0 &&
                pushPayload.applicationId > 0) ||
                (tabIndex > 0 && pushPayload.applicationId > 0))
            ) {
              try {
                await eligibilityCheckServices.pushDocument(pushPayload);
                // Mark this document path as pushed after successful push
                //pushedAggregatorDocuments.current.add(documentPath);
              } catch (pushError: any) {
                console.error("Push document failed:", pushError);
                // Don't add to pushed set on error, allow retry
              }
            }
          }
        }

        // Success - refresh and show message
        setTimeout(() => {
          getDocumentCategoriesViaAPI();
          setDocumentsMutationTick((t) => t + 1);
          dispatch(
            setStatusPopup({
              status: "success",
              message: "Document shared via Account Aggregator successfully",
            })
          );
          setAggregatorLoader(false);
        }, 5000);
      }
    } catch (error: any) {
      setIsAggregateVerify(false);
      setAggregatorLoader(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            error?.response?.data?.message ||
            "An error occurred while fetching documents",
        })
      );
    } finally {
      setIsAggregateVerify(false);
      setAggregatorLoader(false);
      localStorage.removeItem("docItemAggregator");
      // Note: We don't clear pushedAggregatorDocuments here to prevent duplicate pushes
      // It will be cleared on tab change or component mount
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    const consentStatus = params.get("consent");

     if (
      consentStatus == "true" &&
      tabIndex != -1 &&
      applicants?.[tabIndex] &&
      !hasCalledConsentAPI.current
    ) {
      hasCalledConsentAPI.current = true;
      handleAccountAggregatorRequestConsent();
    }
  }, [location?.search, tabIndex, applicants]);

  // Reset the consent API call flag when location changes (user navigates away and back)
  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    const consentStatus = params.get("consent");

    // Reset flag when consent parameter is removed or changed
    if (consentStatus !== "true") {
      hasCalledConsentAPI.current = false;
    }
  }, [location?.search]);

  const handleShowImageMList = () => {
    return (
      <>
        <div>
          <Grid container spacing={2} sx={{ paddingBottom: "20px" }}>
            <Grid item xs={12}>
              <div
                className="image-container"
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  minWidth: isXsOrSm ? "300px" : "100%",
                  height: isXsOrSm ? "320px" : "80vh",
                  overflow: "auto",
                  marginTop: "39px",
                }}
              >
                {viewDocUrl ? (
                  viewDocMimeType?.includes("pdf") ||
                    viewDocUrl.includes("pdf") ? (
                    <PDFViewer
                      pdfUrl={viewDocUrl}
                      partnerStartedJourney={partnerStartedJourney}
                    />
                  ) : (
                    <img src={viewDocUrl} alt="sample" />
                  )
                ) : (
                  <div>No preview available</div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </>
    );
  };
  const handleDocCount = async (submissionTrackingId: any) => {
    try {
      let result = await eligibilityCheckServices.bulkDocumentCount({
        trackingId: submissionTrackingId,
      });
      if (result?.status === 200) {
        setCountBulkUpload(result?.data?.data?.count ?? 0);
      }
    } catch (error) {
      console.error("Error fetching bulk document count:", error);
    }
  };

  const handleDeleteDocument = async (docId: string) => {
    try {
      const payload = {
        deleteType: "userDoc",
        docId: [docId],
      };
      const response = await eligibilityCheckServices.deleteUserDocument(
        payload
      );
      if (response?.status == 200) {
        getDocumentCategoriesViaAPI();
        setDocumentsMutationTick((t) => t + 1);
      }
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: error?.response?.data?.message,
        })
      );
    }
  };

  const handleViewMandatoryDocuments = () => {
    navigate("/application/mandatory-documents", { state: { tabIndex } });
  };
  const handleViewBulkDocuments = () => {
    navigate("/application/bulk-documents", { state: { tabIndex } });
  };

  const handleBulkUploadModal = () => {
    setIsBulkUploadModalOpen(true);
  };

  const handleCloseBulkUploadModal = () => {
    handleDocCount(submissionTrackingId);
    setIsBulkUploadModalOpen(false);
  };

  const handleContinueBulkUpload = (files: any[]) => {
    handleDocCount(submissionTrackingId);
    setIsBulkUploadModalOpen(false);
  };

  const handleAddMoreDocumentSubmit = (values: any) => {
    // Here you can add the API call to submit the document
    // For now, just close the modal
    setIsAddMoreModalOpen(false);
    setModelType("");
  };

  const applicationSource = useSelector((state: RootState) => state?.stepper?.applicationSource);

  const handleGAProvisionalOfferStatments = useMemo(
    () => getGAProvisionalOfferStatements(applicationSource || ""),
    [applicationSource]
  );

  const handleTriggerLinkToCollectDocuments = async (
    findCoApplicantNumber: number,
    type: string
  ) => {
    try {
      let coappNumber: any = `coapplicant${findCoApplicantNumber}`;
      const payload = partnerStartedJourney
        ? {
          email: getAppCoApplicantDetails("email"),
          name: getAppCoApplicantDetails("name"),
          mobileNumber: getAppCoApplicantDetails("phone"),
          submissionTrackingId: submissionTrackingId,
          toUser: type == "applicant" ? true : false,
        }
        : {
          email: getAppCoApplicantDetails("email"),
          name: getAppCoApplicantDetails("name"),
          mobileNumber: getAppCoApplicantDetails("phone"),
          submissionTrackingId: submissionTrackingId,
          toUser: type == "applicant" ? true : false,
        };
      const response =
        await eligibilityCheckServices.triggerLinkToCollectDocuments(payload);
      if (response?.status == 200) {

        trackCustomerJourneyEvent(
          `COAPPLICANT${findCoApplicantNumber}_SEND_LINK_TO_COAPP`,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: `COAPPLICANT${findCoApplicantNumber}_SEND_LINK_TO_COAPP`,
            category: `COAPPLICANT${findCoApplicantNumber}_SEND_LINK_TO_COAPP`,
            action: `COAPPLICANT${findCoApplicantNumber}_SEND_LINK_TO_COAPP`,
            page: `Co-Applicant (${findCoApplicantNumber}) Send Link to Co-applicant`,
          }
        );

        // trackCustomerJourneyEvent(
        //   `${handleGAProvisionalOfferStatments}_LOANDETAILS_PROVISIONALOFFER_PAGE10`,
        //   decrypt(userProfile?.id) ?? "",
        //   applicationNumber,
        //   {
        //     label: `${handleGAProvisionalOfferStatments}_LOANDETAILS_PROVISIONALOFFER_PAGE10`,
        //     category: `${handleGAProvisionalOfferStatments}_LOANDETAILS_PROVISIONALOFFER_PAGE10`,
        //     action: `${handleGAProvisionalOfferStatments}_LOANDETAILS_PROVISIONALOFFER_PAGE10`,
        //     page: "Send Link to Customer",
        //   }
        // );

        dispatch(
          setStatusPopup({
            status: "success",
            message: response?.data?.message,
          })
        );
      }
    } catch (error: any) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: error?.response?.data?.message,
        })
      );
    }
  };

  const handluiStreamValue = (value: string) => {
    switch (value) {
      case "PAN":
        return "DIGILOCKER_PAN_CERTIFICATE";
      case "AADHAAR":
        return "DIGILOCKER_AADHAAR";
      case "10th Marksheet":
        return "DIGILOCKER_CLASS_X_MARKSHEET";
      case "12th Marksheet":
        return "DIGILOCKER_CLASS_XII_MARKSHEET";
      case "Graduation Marksheets":
        return "DIGILOCKER_DEGREE_MARKSHEET";
      default:
        return "DIGILOCKER_AADHAAR";
    }
  };

  const isAuthenticated = useSelector(authSelector)?.isAuthenticated;


  const handleDigiLockerDocument = async (
    docId: number,
    value: string,
    docType: string,
    item: any,
    categoryName?: string
  ) => {
    if (!canUseDigiLockerForDocument(item, categoryName)) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: "DigiLocker is not available for this document in partner journey.",
        })
      );
      return;
    }

    try {
      // Add document ID to loading state
      // const oldUploadDocumentLoader = [...uploadDocumentLoader];
      // oldUploadDocumentLoader.push(docId);
      // setUploadDocumentLoader(oldUploadDocumentLoader);


      let eventName = "";
      let paramValues = "";

      switch (docType) {
        case "PANCR":
          eventName = tabIndex == 0 ? "APPLICANT_PAN_DIGILOCKER" : `COAPPLICANT(${findApplicantIndex})_PAN_DIGILOCKER`;
          paramValues = tabIndex == 0 ? "Applicant PAN Digilocker" : `Co-Applicant (${findApplicantIndex}) PAN Digilocker`;
          break;
        case "ADHAR":
          eventName = tabIndex == 0 ? "APPLICANT_AADHAAR_DIGILOCKER" : `COAPPLICANT(${findApplicantIndex})_AADHAAR_DIGILOCKER`;
          paramValues = tabIndex == 0 ? "Applicant AADHAAR Digilocker" : `Co-Applicant (${findApplicantIndex}) AADHAAR Digilocker`;
          break;
        case "SSCER":
          eventName = "APPLICANT_XMARKSHEET_DIGILOCKER"
          paramValues = "Applicant 10th Marksheet Digilocker";
          break;
        case "HSCER":
          eventName = "APPLICANT_XIIMARKSHEET_DIGILOCKER";
          paramValues = "Applicant 12th Marksheet Digilocker";
          break;
        default:
          break
      }

      

      dispatch(setDigiLockerLoaderId(docId));
      dispatch(
        setDocumentApplicantType(
          tabIndex == 0
            ? "Applicant"
            : applicants?.[isApplicant ? tabIndex : findApplicantIndex]
        )
      );
      let docTypeList = ["ADHAR", "PANCR", "HSCER", "SSCER", "DRVLC","DGMST"];
      const aadhaarPayload: any = {
        applicantEmail: getAppCoApplicantDetails("email"),
        applicantName: getAppCoApplicantDetails("name"),
        applicantMobile: getAppCoApplicantDetails("phone"),
        // redirectUrl: `${window.location.origin}/application/apply-now`,
        redirectUrl: window.location.href,
        landingPageNotRequired: true,
        trackingId: applicationNumber,
        docs: docTypeList,
        typeOfApplicant:
          tabIndex == 0
            ? "Applicant"
            : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
        // uiStream: handluiStreamValue(value),
      };
      const resp = await applicantDetailsServices.digilockerApplication(
        aadhaarPayload
      );
      if (resp.data?.status === "success" && resp.data.data?.link) {
        dispatch(removeDigiLockerLoaderId());
        localStorage.setItem("docItemDigiLocker", JSON.stringify(item));
        let link = resp.data.data.link;
        const applicationNo = resp.data.data.applicationNo;
        localStorage.setItem("applicationNo", applicationNo);
        dispatch(setAadhaarApplicationNo(applicationNo));
        if (!/^https?:\/\//i.test(link)) {
          link = "https://" + link;
        }

        await trackCustomerJourneyEventAndWait(
          eventName,
          decrypt(userProfile?.id) ?? "",
          applicationNumber,
          {
            label: eventName,
            category: eventName,
            action: eventName,
            page: paramValues,
          }
        , 500);


        window.location.replace(link);
      } else {
        dispatch(removeDigiLockerLoaderId());
        const oldUploadDocumentLoader = [...uploadDocumentLoader];
        oldUploadDocumentLoader.splice(
          oldUploadDocumentLoader.indexOf(docId),
          1
        );
        setUploadDocumentLoader(oldUploadDocumentLoader);
        setSnackbar({
          open: true,
          message: resp.data?.message,
          severity: "success",
        });
        // dispatch(
        //   setStatusPopup({
        //     status: "info",
        //     message: resp.data?.message,
        //   })
        // );
      }
    } catch (err: any) {
      const oldUploadDocumentLoader = [...uploadDocumentLoader];
      oldUploadDocumentLoader.splice(oldUploadDocumentLoader.indexOf(docId), 1);
      setUploadDocumentLoader(oldUploadDocumentLoader);
      dispatch(removeDigiLockerLoaderId());
      dispatch(
        setStatusPopup({
          status: "error",
          message:
            err?.response?.data?.message ||
            "An error occurred while processing DigiLocker request",
        })
      );
    }
  };

  const handleGetIssuedFiles = async (transactionId: string) => {
    await applicantDetailsServices
      .applicantIssueFile(transactionId)
      .then((response: any) => {
      })
      .catch((err: any) => {
        dispatch(
          setStatusPopup({
            status: "error",
            message: err?.response?.data?.message,
          })
        );
      });
  };

  const handleVerifyViaDigiLocker = async () => {
    try {
      if (
        tabIndex < 0 ||
        !applicants?.[isApplicant ? tabIndex : findApplicantIndex]
      )
        return;

      setAggregatorLoader(true);
      const docItemDigiLoc = localStorage.getItem("docItemDigiLocker");
      let item: any = JSON.parse(docItemDigiLoc || "{}");
      const payload = {
        userType: "applicant",
        documentId: aadhaarApplicationNo || item?.utilityDecentroAppNo || "",
        employmentCategory: tabIndex == 0 ? formUserData?.employmentType || formUserData?.applicantType : formUserData?.[`employmentCoApplicant${applicants?.[tabIndex]?.split(" ")?.[1]}employmentType`] || formUserData?.applicantType,
        typeOfApplicant:
          tabIndex == 0
            ? "Applicant"
            : applicants?.[isApplicant ? tabIndex : findApplicantIndex],
        formSubmissionTrackingId: submissionTrackingId,
        isListingPage: true,
      };
      const response = await applicantDetailsServices.verifyAadhaarApplication(
        payload
      );
      if (response?.status === 200) {
        // Clear document_verified parameter from URL
        const currentSearch = location?.search || "";
        const newSearch = currentSearch.replace(
          /[?&]document_verified=true/g,
          ""
        );
        const cleanSearch = newSearch.replace(/^\?&/, "?").replace(/^&/, "?");
        const newUrl = `${window.location.pathname}${cleanSearch}`;
        navigate(newUrl, { replace: true });

        if (response?.data?.data?.uploadedDocuments.length == 0) {
          // Call handleGetIssuedFiles 3 times with 2-second intervals
          const transactionId = response?.data?.data?.transactionId;
          handleGetIssuedFiles(transactionId);

          setTimeout(() => {
            handleGetIssuedFiles(transactionId);
          }, 2000);

          setTimeout(() => {
            handleGetIssuedFiles(transactionId);
          }, 4000);

          setTimeout(() => {
            dispatch(removeDigiLockerLoaderId());
          }, 6000);

          setTimeout(() => {
            getDocumentCategoriesViaAPI();
            setDocumentsMutationTick((t) => t + 1);
          }, 7000);

          setTimeout(() => {
            setAggregatorLoader(false);
          }, 8000);

          return;
        } else {
          dispatch(removeDigiLockerLoaderId());
          const uploadedDocuments =
            response?.data?.data?.uploadedDocuments || [];
          // Loop through each uploaded document and call push document API
          uploadedDocuments.forEach((document: any) => {
            const docNamed = document?.docName
              ?.replace(/\s+/g, "")
              .toUpperCase();
            if (document?.docNameDms) {
              let pushPayload: any = {
                eventName:
                  tabIndex === 0
                    ? `APPLICANT_${docNamed}_PUSH_DOCUMENT`
                    : `COAPPLICANT${findCoApplicantNumber}_${docNamed}_PUSH_DOCUMENT`,
                trackingId: submissionTrackingId,
                docType: document?.docNameDms || "",
                applicantId:
                  tabIndex === 0
                    ? Number(fetchUserApplicationData?.applicantId)
                    : partnerStartedJourney
                      ? Number(
                        coApplicantDetails?.[
                          `coapplicant${findCoApplicantNumber}` as keyof typeof coApplicantDetails
                        ]?.coApplicantId ?? ""
                      )
                      : tabIndex === 0
                        ? Number(fetchUserApplicationData?.applicantId)
                        : Number(localStorage.getItem("coAppId")),
                applicationId: applicationId
                  ? Number(applicationId)
                  : Number(fetchUserApplicationData?.applicationId),
                documentFilePath: document?.key || "",
                userApplicantType:
                  tabIndex === 0
                    ? "Applicant"
                    : `Co-Applicant ${findCoApplicantNumber}`,
              };
              if (document?.docType === "PANCR") {
                pushPayload.applicantHasPanCardFlag = true;
              }
              if (document?.docType === "SSCER") {
                pushPayload.appEducationId = 283;
              } else if (document?.docType === "HSCER") {
                pushPayload.appEducationId = 284;
              } else if (document?.docType === "Graduation Marksheets") {
                pushPayload.appEducationId = 286;
              } else if (document?.docType === "Diploma") {
                pushPayload.appEducationId = 285;
              }
              if (
                (tabIndex == 0 &&
                  pushPayload.applicantId > 0 &&
                  pushPayload.applicationId > 0) ||
                (tabIndex > 0 && pushPayload.applicationId > 0)
              ) {
                eligibilityCheckServices
                  .pushDocument(pushPayload)
                  .catch((pushError: any) => {
                    console.error(
                      "Push document failed for document:",
                      document,
                      pushError
                    );
                  });
              }
            }
          });
          setAggregatorLoader(false);
          getDocumentCategoriesViaAPI();
          setDocumentsMutationTick((t) => t + 1);
        }

        setSnackbar({
          open: true,
          message: "Document Fetched successfully",
          severity: "success",
        });
        // dispatch(
        //   setStatusPopup({
        //     status: "success",
        //     message: "Document Fetched successfully",
        //   })
        // );
      }
    } catch (error: any) {
      dispatch(setDigiLockerLoaderId([]));
      setAggregatorLoader(false);
      dispatch(removeDigiLockerLoaderId());
      setSnackbar({
        open: true,
        message: "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
        // message: error?.response?.data?.message || "Uh-oh! We are experiencing some technical issues fetching Aadhaar details. Please try again later.",
        severity: "error",
      });

      // dispatch(
      //   setStatusPopup({
      //     status: "error",
      //     message: error?.response?.data?.message,
      //   })
      // );

      // Clear document_verified parameter from URL
      const currentSearch = location?.search || "";
      const newSearch = currentSearch.replace(
        /[?&]document_verified=true/g,
        ""
      );
      const cleanSearch = newSearch.replace(/^\?&/, "?").replace(/^&/, "?");
      const newUrl = `${window.location.pathname}${cleanSearch}`;
      navigate(newUrl, { replace: true });
    } finally {
      setAggregatorLoader(false);
      localStorage.removeItem("docItemDigiLocker");
    }
  };

  useEffect(() => {
    // Only proceed if location.search actually contains document_verified parameter
    if (!location.search || !location.search.includes("document_verified")) {
      return;
    }

    const urlParams = new URLSearchParams(location.search);
    const documentVerified = urlParams.get("document_verified");
    // If this DigiLocker round-trip was started from the Consent page (ConsentDetails
    // sets this flag before redirecting), let ConsentDetails handle the callback and
    // skip it here — otherwise this document-upload flow races it and consumes the
    // callback using unrelated state.
    const inFlightFromConsent = Boolean(
      submissionTrackingId && localStorage.getItem(`consentAadhaarType:${submissionTrackingId}`)
    );
    // Double check the parameter exists and is true
    if (documentVerified === "true" && tabIndex !== -1 && !inFlightFromConsent) {
      handleVerifyViaDigiLocker();
    }
  }, [
    submissionTrackingId,
    aadhaarApplicationNo,
    location.search,
    tabIndex,
    applicants,
    isApplicant,
    findApplicantIndex,
  ]);

  // Function to render skeleton loading content
  const renderSkeletonContent = () => {
    return (
      <TabPanel value={tabIndex} index={tabIndex}>
        {/* Applicant Info Box Skeleton */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            mb: 2,
            bgcolor: "#fff3cf",
            borderRadius: "8px",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="80%" height={20} />
          </Box>
          <Skeleton
            variant="rectangular"
            width={200}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        </Box>

        <Skeleton
          variant="text"
          width="40%"
          height={28}
          sx={{ mt: 3, mb: 1 }}
        />

        <List sx={{ p: 0 }}>
          {/* Document 1 Skeleton */}
          <ListItem
            sx={{
              mb: 1,
              bgcolor: "#fff",
              border: "1px solid #eee",
              borderRadius: "8px",
              py: 1.5,
              px: 2,
              display: "flex",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* LEFT: Text Skeleton */}
            <Box
              sx={{
                flex: "1 1 auto",
                minWidth: "180px",
                pr: 2,
              }}
            >
              <Skeleton
                variant="text"
                width="40%"
                height={20}
                sx={{ mb: 0.5 }}
              />
              <Skeleton variant="text" width="70%" height={20} />
            </Box>

            {/* RIGHT: Button + Chip + Digi/Aggregator Skeleton */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
                width: { xs: "100%", sm: "auto" },
                mt: { xs: 1, sm: 0 },
                flexWrap: "nowrap",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={70}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />

              <Skeleton
                variant="rectangular"
                width={80}
                height={32}
                sx={{ borderRadius: 1 }}
              />

              <Skeleton
                variant="rectangular"
                width={100}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </ListItem>

          {/* Document 2 Skeleton */}
          <ListItem
            sx={{
              mb: 1,
              bgcolor: "#fff",
              border: "1px solid #eee",
              borderRadius: "8px",
              py: 1.5,
              px: 2,
              display: "flex",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* LEFT: Text Skeleton */}
            <Box
              sx={{
                flex: "1 1 auto",
                minWidth: "180px",
                pr: 2,
              }}
            >
              <Skeleton
                variant="text"
                width="45%"
                height={20}
                sx={{ mb: 0.5 }}
              />
              <Skeleton variant="text" width="75%" height={20} />
            </Box>

            {/* RIGHT: Button + Chip + Digi/Aggregator Skeleton */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
                width: { xs: "100%", sm: "auto" },
                mt: { xs: 1, sm: 0 },
                flexWrap: "nowrap",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={70}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />

              <Skeleton
                variant="rectangular"
                width={80}
                height={32}
                sx={{ borderRadius: 1 }}
              />

              <Skeleton
                variant="rectangular"
                width={120}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </ListItem>
        </List>

        {/* Add More Button Skeleton */}
        <Skeleton
          variant="rectangular"
          width={120}
          height={40}
          sx={{ mt: 2, borderRadius: 1 }}
        />

        {/* Uploaded Documents Section Skeleton */}
        <Skeleton
          variant="text"
          width="35%"
          height={28}
          sx={{ mt: 3, mb: 1 }}
        />

        <List sx={{ p: 0 }}>
          {/* Uploaded Document 1 Skeleton */}
          <ListItem
            sx={{
              mb: 1,
              bgcolor: "#fff",
              border: "1px solid #eee",
              borderRadius: "8px",
              py: 1.5,
              px: 2,
              display: "flex",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Left: Document name and description Skeleton */}
            <Box
              sx={{
                flex: "1 1 auto",
                minWidth: "180px",
                pr: 2,
              }}
            >
              <Skeleton
                variant="text"
                width="35%"
                height={20}
                sx={{ mb: 0.5 }}
              />
              <Skeleton variant="text" width="60%" height={20} />
            </Box>

            {/* Right: Chip + View Button Skeleton */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
                width: "auto",
                mt: { xs: 1, sm: 0 },
              }}
            >
              <Skeleton
                variant="rectangular"
                width={70}
                height={24}
                sx={{ borderRadius: 0.5 }}
              />
              <Skeleton
                variant="rectangular"
                width={60}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </ListItem>
        </List>
      </TabPanel>
    );
  };

  // Verification Logic for Applicant (tabIndex 0) and Co-Applicants (tabIndex > 0)
  const { shouldShowEmailVerifiedConsent, shouldShowPhoneVerifiedConsent } = useMemo(() => {
    // getting current status for the active tab
    let isEmailDone = false;
    let isPhoneDone = false;

    if (tabIndex === 0) {
      // Main Applicant - use consentTime from fetched application data (stored in Redux)
      const hasConsent = !!stepper.customerConsentTime;
      isEmailDone = hasConsent;
      isPhoneDone = hasConsent;
    } else {
      // Co-Applicant - use consentTime from getCoApplicantDetails API response
     
      const hasConsent = !!coApplicantConsentTimes[tabIndex];
      isEmailDone = hasConsent;
      isPhoneDone = hasConsent;
    }

    const nothingVerified = !isEmailDone && !isPhoneDone;

    return {
      shouldShowEmailVerifiedConsent: nothingVerified,
      shouldShowPhoneVerifiedConsent: nothingVerified
    };
  }, [tabIndex, stepper.customerConsentTime, coApplicantConsentTimes]);
  const handleOpenAddCoApplicantModal = async () => {
    if (partnerStartedJourney) return;
    if (!submissionTrackingId) {
      setSnackbar({
        open: true,
        message: "Tracking ID not available. Please try again.",
        severity: "error",
      });
      return;
    }

    try {
      setIsAddCoApplicantLoading(true);
      setApiNextCoApplicantNumber(null);
      setPreloadedRelationshipOptions([]);
      setPreloadedSalutationOptions([]);
      setPreloadedNationalityOptions([]);
      setPreloadedMaritalStatusOptions([]);
      setPreloadedCountryOptions([]);

      // 1) Fetch current co-applicant count
      // 2) Fetch application status
      // 3) Fetch relation master
      // 4) Fetch salutations
      const [countResp, _, relationResp, salutationResp, nationalityResp, maritalStatusResp, countryResp]: any = await Promise.all([
        postsServices.addPost("api/v1/applicant/get-coapplicant-count", {
          trackingId: submissionTrackingId,
        }),
        axiosInstance.get(
          `api/v1/user-lead/application-status/${submissionTrackingId}`
        ),
        losServices.relationMaster(),
        dropdownService.getSalutations(),
        dropdownService.getNationalityList(),
        dropdownService.getMaritalStatusMaster(),
        dropdownService.getCountries(),
      ]);

      const apiCount = countResp?.data?.data?.count;
      if (typeof apiCount !== "number") {
        throw new Error("Unable to fetch co-applicant count.");
      }
      const nextNum = apiCount + 1;

      const relationOptions =
        relationResp?.data?.data?.map((item: any) => ({
          label: item?.descInPennant,
          value: item?.codeInPennant,
        })) || [];

      const salutationOptions =
        salutationResp?.data?.map((sal: any) => ({
          value: sal?.salutationCode,
          label: sal?.salutationDesc,
        })) || [];

      const nationalityOptions = Array.isArray(nationalityResp)
        ? nationalityResp
        : [];

      const maritalStatusOptions =
        maritalStatusResp?.data
          ?.map((item: any) => ({
            value: String(item?.maritalStatusCode ?? ""),
            label: String(
              item?.maritalStatusName ?? item?.maritalStatusDesc ?? ""
            ),
          }))
          ?.filter((opt: any) => opt.value && opt.label) || [];

      const countryOptions =
        countryResp?.data
          ?.map((item: any) => ({
            value: String(item?.countryId ?? ""),
            label: String(item?.countryDesc ?? ""),
          }))
          ?.filter((opt: any) => opt.value && opt.label) || [];

      setApiNextCoApplicantNumber(nextNum);
      setPreloadedRelationshipOptions(relationOptions);
      setPreloadedSalutationOptions(salutationOptions);
      setPreloadedNationalityOptions(nationalityOptions);
      setPreloadedMaritalStatusOptions(maritalStatusOptions);
      setPreloadedCountryOptions(countryOptions);
      setIsAddCoApplicantModalOpen(true);
    } catch (err: any) {
      dispatch(
        setStatusPopup({
          status: "error",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load co-applicant prerequisites.",
        })
      );
    } finally {
      setIsAddCoApplicantLoading(false);
    }
  };

  const isAddressProofMandetory = (documents: any[]): boolean => {
    return true;
    // As discussed, For now removing this check
    // return (
    //   documents?.some((elem) => elem?.byDefault === true && elem?.isMandatory === true) ?? false
    //   )
  };

  return (
    <>
      <Paper sx={{ p: isXsOrSm ? 2 : 3, mb: 3 }}>
        {/* Header Actions */}
        {aggregatorLoader && <LoaderBackdrop open={aggregatorLoader} />}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ fontWeight: 600, fontSize: "16px", color: "#5d586c" }}
          >
            <>{isXsOrSm && isAdditional===false ? "Upload Documents" : !isXsOrSm && isAdditional===false ? "Documents" : "Please upload pending documents"}</>
          </Typography>

          {isApplicant && (
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              {location.pathname==="/application/summary" && 
                <UploadButton
                  type="button"
                  customHeight={"38px"}
                  onClick={handleOpenAddCoApplicantModal}
                  disabled={partnerStartedJourney || isAddCoApplicantLoading || fetchUserApplicationData?.status==="Application Submitted" || totalCoApplicantCount >= 9}
                  startIcon={<AddIcon />}
                  sx={{ mb: 1, width: isXsOrSm ? "100% !important" : "auto" }}
                >
                  {isAddCoApplicantLoading ? (
                    <>
                      <CircularProgress size={16} sx={{ color: "#fff", mr: 1 }} />
                      Loading...
                    </>
                  ) : (
                    "Add New Co-Applicant"
                  )}
                </UploadButton>
              }

              {!partnerStartedJourney && isAdditional===false && location.pathname==="/application/summary" && (
                <>
                  {/* <PrimaryButtonText
                    onClick={handleViewMandatoryDocuments}
                    sx={{
                      mb: 1,
                      width: isXsOrSm ? "100vw" : "auto",
                      border: isXsOrSm ? "1px solid #00b3b5" : "none",
                    }}
                  >
                    <img src={Eyecon} alt="Upload" style={{ marginRight: "5px" }} />
                    View Mandatory Documents
                  </PrimaryButtonText> */}
                  <UploadButton
                    onClick={handleViewBulkDocuments}
                    customHeight={"38px"}
                    sx={{
                      mb: 1,
                      width: isXsOrSm ? "100vw !important" : "auto",
                      position: "relative",
                    }}
                  >
                    <img src={Eyecon} alt="Upload" style={{ marginRight: "5px" }} />
                    View bulk documents
                    {countBulkUpload > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          backgroundColor: "#ff4444",
                          color: "#fff",
                          borderRadius: "50%",
                          minWidth: "20px",
                          height: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          padding: "2px",
                        }}
                      >
                        {countBulkUpload > 99 ? "99+" : countBulkUpload}
                      </Box>
                    )}
                  </UploadButton>
                  <PrimaryButton
                    type="submit"
                    onClick={handleBulkUploadModal}
                    sx={{ width: isXsOrSm ? "100vw" : "auto" }}
                  >
                    <img
                      src={UploadWhiteIcon}
                      alt="Upload"
                      style={{ marginRight: "5px" }}
                    />
                    Upload bulk documents
                  </PrimaryButton>
                </>
              )}
            </Box>
          )}
        </Box>

        {/* Tabs */}
        {isApplicant && (
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              mb: 2,
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={handleChange}
              variant="scrollable"
              {...(isXsOrSm && {
                scrollButtons: "auto",
                allowScrollButtonsMobile: false,
              })}
              sx={{
                flexGrow: 1,
                minWidth: 0,
                "& .MuiTabs-indicator": {
                  backgroundColor: "#00b3b5",
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  color: "#616161",
                  "&.Mui-selected": {
                    color: "#00b3b5",
                  },
                },
              }}
            >
              {applicants?.map((a: any, i: any) => (
                <Tab
                  key={i}
                  label={a == "Applicant" ? a : `Co-Applicant ${i}`}
                  {...a11yProps(i)}
                />
              ))}
            </Tabs>
          </Box>
        )}

        {isLoading || isLoadingDoc ? (
          renderSkeletonContent()
        ) : (
          <TabPanel value={tabIndex} index={tabIndex}>
            {isApplicant && isAdditional===false && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  bgcolor: "#fff3cf",
                  borderRadius: "8px",
                  flexWrap: "wrap",
                  gap: 1,
                  p: 2,
                  mb: 2,
                }}
              >
                {isXsOrSm ? (
                  <Typography sx={{ fontSize: "13px", color: "#5d586c" }}>
                    {isAdditional===false && 
                      <>
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "#1F2233",
                            marginRight: "8px",
                            textTransform: 'capitalize'
                          }}
                        >
                          {getAppCoApplicantDetails("name")}
                        </span>

                        <span>
                          {tabIndex == 0 ? (
                            // applicant view
                            partnerStartedJourney ? (
                              !mainApplicantDetails ? (
                                <Skeleton
                                  variant="text"
                                  width={120}
                                  sx={{ display: "inline-block" }}
                                />
                              ) : (
                                (() => {
                                  const email = mainApplicantDetails?.find(
                                    (item: any) => item.name === "email"
                                  )?.value;
                                  const phone = mainApplicantDetails?.find(
                                    (item: any) => item.name === "phone_number"
                                  )?.value;

                                  if (
                                    (email === undefined || email === "") &&
                                    (phone === undefined || phone === "")
                                  ) {
                                    return "Email: NA";
                                  }

                                  return (
                                    <>
                                      <Box sx={{ display: 'flex', alignItems: 'center', mt: !isEmailVerified && !isMobileVerified ? '5px' : '0px' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: isEmailVerified ? '5px' : '8px', fontSize: "13px" }}>
                                          Email:
                                          <TruncatedTextWithTooltip
                                            style={{ fontSize: "14px", marginRight: '5px' }}
                                            text={String(email || "NA")}
                                            limit={20}
                                          />
                                        </span>
                                        {!partnerStartedJourney && email && (
                                          <Button
                                            type="button"
                                            onClick={() => handleSendEmailOtp(email)}
                                            disabled={isEmailVerified || isLoading}
                                            sx={{
                                              backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                              color: isEmailVerified ? "#28C76F" : "#000000",
                                              "&:hover": {
                                                backgroundColor: isEmailVerified ? "transparent" : "#E5AF00",
                                              },
                                              "&.Mui-disabled": {
                                                backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                                color: isEmailVerified ? "#28C76F" : "#000000",
                                                opacity: 1, // Add this to prevent the blur/fading
                                                WebkitTextFillColor: isEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                              },
                                              textTransform: "none",
                                              fontSize: isEmailVerified ? "13px" : "10px",
                                              fontWeight: isEmailVerified ? 500 : 700,
                                              py: '3px',
                                              borderRadius: "4px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "5px",
                                              boxShadow: "none",
                                            }}
                                          >
                                            {isEmailVerified ? (
                                              <>
                                                <img
                                                  src={greenCheckVerified}
                                                  alt="Verified"
                                                  style={{ height: '12px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                                />
                                                <Typography variant="inherit">Verified</Typography>
                                              </>
                                            ) : (
                                              <>
                                                <Typography variant="inherit">Verify</Typography>
                                                <img
                                                  src={arrowRightVerify}
                                                  alt="Verified"
                                                  style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                                />
                                              </>
                                            )}
                                          </Button>
                                        )}
                                      </Box>
                                      <Box sx={{ display: 'flex', alignItems: 'center', mt: !isEmailVerified && !isMobileVerified ? '8px' : '0px' }}>
                                        <span style={{ marginRight: isMobileVerified ? '5px' : '8px', fontSize: "13px" }}>
                                          Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                        </span>
                                        {!partnerStartedJourney && phone && (
                                          <Button
                                            type="button"
                                            onClick={() =>
                                              handleSendMobileOtp(phone)
                                            }
                                            disabled={isMobileVerified || isLoading}
                                            sx={{
                                              backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                              color: isMobileVerified ? "#28C76F" : "#000000",
                                              "&:hover": {
                                                backgroundColor: isMobileVerified ? "transparent" : "#E5AF00",
                                              },
                                              "&.Mui-disabled": {
                                                backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                                color: isMobileVerified ? "#28C76F" : "#000000",
                                                opacity: 1, // Add this to prevent the blur/fading
                                                WebkitTextFillColor: isMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                              },
                                              textTransform: "none",
                                              fontSize: isMobileVerified ? "13px" : "10px",
                                              fontWeight: isMobileVerified ? 500 : 700,
                                              py: '3px',
                                              borderRadius: "4px",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "5px",
                                              boxShadow: "none",
                                            }}
                                          >
                                            {isMobileVerified ? (
                                              <>
                                                <img
                                                  src={greenCheckVerified}
                                                  alt="Verified"
                                                  style={{ height: '12px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                                />
                                                <Typography variant="inherit">Verified</Typography>
                                              </>
                                            ) : (
                                              <>
                                                <Typography variant="inherit">Verify</Typography>
                                                <img
                                                  src={arrowRightVerify}
                                                  alt="Verified"
                                                  style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                                />
                                              </>
                                            )}
                                          </Button>
                                        )}
                                      </Box>
                                    </>
                                  );
                                })()
                              )
                            ) : (
                              <>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: !isEmailVerified && !isMobileVerified ? '5px' : '0px' }}>
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: '2px', fontSize: "13px" }}>
                                    Email:
                                    <TruncatedTextWithTooltip
                                      style={{ fontSize: "14px", marginRight: '5px' }}
                                      text={String(formUserData?.email || "NA")}
                                      limit={20}
                                    />
                                  </span>
                                  {/* {!partnerStartedJourney && formUserData?.email && (
                                    <Button
                                      type="button"
                                      onClick={() => handleSendEmailOtp(formUserData?.email)}
                                      disabled={isEmailVerified || isLoading}
                                      sx={{
                                        backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                        color: isEmailVerified ? "#28C76F" : "#000000",
                                        "&:hover": {
                                          backgroundColor: isEmailVerified ? "transparent" : "#E5AF00",
                                        },
                                        "&.Mui-disabled": {
                                          backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                          color: isEmailVerified ? "#28C76F" : "#000000",
                                          opacity: 1, // Add this to prevent the blur/fading
                                          WebkitTextFillColor: isEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                        },
                                        textTransform: "none",
                                        fontSize: isEmailVerified ? "13px" : "10px",
                                        fontWeight: isEmailVerified ? 500 : 700,
                                        py: '3px',
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        boxShadow: "none",
                                      }}
                                    >
                                      {isEmailVerified ? (
                                        <>
                                          <img
                                            src={greenCheckVerified}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                          <Typography variant="inherit">Verified</Typography>
                                        </>
                                      ) : (
                                        <>
                                          <Typography variant="inherit">Verify</Typography>
                                          <img
                                            src={arrowRightVerify}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                        </>
                                      )}
                                    </Button>
                                  )} */}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: !isEmailVerified && !isMobileVerified ? '8px' : '0px' }}>
                                  <span style={{ marginRight: '2px', fontSize: "13px" }}>
                                    Phone: <span style={{ fontSize: "13px" }}>{formUserData?.phone_number || "NA"}</span>
                                  </span>
                                  {/* {!partnerStartedJourney && formUserData?.phone_number && (
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        handleSendMobileOtp(formUserData?.phone_number)
                                      }
                                      disabled={isMobileVerified || isLoading}
                                      sx={{
                                        backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                        color: isMobileVerified ? "#28C76F" : "#000000",
                                        "&:hover": {
                                          backgroundColor: isMobileVerified ? "transparent" : "#E5AF00",
                                        },
                                        "&.Mui-disabled": {
                                          backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                          color: isMobileVerified ? "#28C76F" : "#000000",
                                          opacity: 1, // Add this to prevent the blur/fading
                                          WebkitTextFillColor: isMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                        },
                                        textTransform: "none",
                                        fontSize: isMobileVerified ? "13px" : "10px",
                                        fontWeight: isMobileVerified ? 500 : 700,
                                        py: '3px',
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        boxShadow: "none",
                                      }}
                                    >
                                      {isMobileVerified ? (
                                        <>
                                          <img
                                            src={greenCheckVerified}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                          <Typography variant="inherit">Verified</Typography>
                                        </>
                                      ) : (
                                        <>
                                          <Typography variant="inherit">Verify</Typography>
                                          <img
                                            src={arrowRightVerify}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                        </>
                                      )}
                                    </Button>
                                  )} */}
                                </Box>
                              </>
                            )
                          ) : partnerStartedJourney ? (
                            (() => {
                              // coapplicant view
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];

                              if (!co) {
                                return (
                                  <Skeleton
                                    variant="text"
                                    width={120}
                                    sx={{ display: "inline-block" }}
                                  />
                                );
                              }

                              const email = co?.coApplicantEmail;
                              const phone = co?.coApplicantPhone;

                              if (
                                (email === undefined || email === "") &&
                                (phone === undefined || phone === "")
                              ) {
                                return "Email: NA";
                              }

                              return (
                                <>
                                  <span style={{ marginRight: '5px', fontSize: "13px" }}>
                                    Email: <span style={{ fontSize: "14px" }}>{email || "NA"}</span>
                                  </span>
                                  <br />
                                  <span style={{ marginRight: '5px', fontSize: "13px" }}>
                                    Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                  </span>
                                </>
                              );
                            })()
                          ) : (
                            (() => {
                              // coapplicant view
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];
                              const email = co?.Email;
                              const phone = co?.PhoneNumber;

                              if (
                                (email === undefined || email === "") &&
                                (phone === undefined || phone === "")
                              ) {
                                return "Email: NA";
                              }

                              return (
                                <>
                                  <Box sx={{ display: 'flex', alignItems: 'center', mt: !co?.IsEmailVerified && !co?.IsMobileVerified ? '5px' : '0px' }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: '2px', fontSize: "13px" }}>
                                      Email:
                                      <TruncatedTextWithTooltip
                                        style={{ fontSize: "14px", marginRight: '5px' }}
                                        text={String(email || "NA")}
                                        limit={20}
                                      />
                                    </span>
                                    {/* {!partnerStartedJourney && email && (
                                      <Button
                                        type="button"
                                        onClick={() => handleSendEmailOtp(co?.Email)}
                                        disabled={co?.IsEmailVerified || isLoading}
                                        sx={{
                                          backgroundColor: co?.IsEmailVerified ? "transparent" : "#FEC10D",
                                          color: co?.IsEmailVerified ? "#28C76F" : "#000000",
                                          "&:hover": {
                                            backgroundColor: co?.IsEmailVerified ? "transparent" : "#E5AF00",
                                          },
                                          "&.Mui-disabled": {
                                            backgroundColor: co?.IsEmailVerified ? "transparent" : "#FEC10D",
                                            color: co?.IsEmailVerified ? "#28C76F" : "#000000",
                                            opacity: 1, // Add this to prevent the blur/fading
                                            WebkitTextFillColor: co?.IsEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                          },
                                          textTransform: "none",
                                          fontSize: co?.IsEmailVerified ? "13px" : "10px",
                                          fontWeight: co?.IsEmailVerified ? 500 : 700,
                                          py: '3px',
                                          borderRadius: "4px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          boxShadow: "none",
                                        }}
                                      >
                                        {co?.IsEmailVerified ? (
                                          <>
                                            <img
                                              src={greenCheckVerified}
                                              alt="Verified"
                                              style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                            />
                                            <Typography variant="inherit">Verified</Typography>
                                          </>
                                        ) : (
                                          <>
                                            <Typography variant="inherit">Verify</Typography>
                                            <img
                                              src={arrowRightVerify}
                                              alt="Verified"
                                              style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                            />
                                          </>
                                        )}
                                      </Button>
                                    )} */}
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', mt: !co?.IsEmailVerified && !co?.IsMobileVerified ? '8px' : '0px' }}>
                                    <span style={{ marginRight: co?.IsMobileVerified ? '5px' : '8px', fontSize: "13px" }}>
                                      Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                    </span>
                                    {/* {!partnerStartedJourney && phone && (
                                      <Button
                                        type="button"
                                        onClick={() =>
                                          handleSendMobileOtp(phone)
                                        }
                                        disabled={co?.IsMobileVerified || isLoading}
                                        sx={{
                                          backgroundColor: co?.IsMobileVerified ? "transparent" : "#FEC10D",
                                          color: co?.IsMobileVerified ? "#28C76F" : "#000000",
                                          "&:hover": {
                                            backgroundColor: co?.IsMobileVerified ? "transparent" : "#E5AF00",
                                          },
                                          "&.Mui-disabled": {
                                            backgroundColor: co?.IsMobileVerified ? "transparent" : "#FEC10D",
                                            color: co?.IsMobileVerified ? "#28C76F" : "#000000",
                                            opacity: 1, // Add this to prevent the blur/fading
                                            WebkitTextFillColor: co?.IsMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                          },
                                          textTransform: "none",
                                          fontSize: co?.IsMobileVerified ? "13px" : "10px",
                                          fontWeight: co?.IsMobileVerified ? 500 : 700,
                                          py: '3px',
                                          borderRadius: "4px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          boxShadow: "none",
                                        }}
                                      >
                                        {co?.IsMobileVerified ? (
                                          <>
                                            <img
                                              src={greenCheckVerified}
                                              alt="Verified"
                                              style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                            />
                                            <Typography variant="inherit">Verified</Typography>
                                          </>
                                        ) : (
                                          <>
                                            <Typography variant="inherit">Verify</Typography>
                                            <img
                                              src={arrowRightVerify}
                                              alt="Verified"
                                              style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                            />
                                          </>
                                        )} 
                                      </Button>
                                    )}*/}
                                  </Box>
                                </>
                              );
                            })()
                          )}
                        </span>
                      </>
                    }
                    <span>
                      {isApplicant && (
                        <>
                          {tabIndex > 0 && !partnerStartedJourney && (
                            <Typography
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                color: "#00b3b5",
                                cursor: "pointer",
                                fontSize: "0.85rem",
                                mt: 1,
                              }}
                              onClick={() =>
                                handleTriggerLinkToCollectDocuments(
                                  findCoApplicantNumber,
                                  "co-applicant"
                                )
                              }
                            >
                              <img
                                src={LinkIcon}
                                alt="link"
                                style={{ height: 16, marginRight: 4 }}
                              />{" "}
                              Trigger Link to Collect documents
                            </Typography>
                          )}
                        </>
                      )}
                    </span>
                  </Typography>
                ) : (
                  // desktop view 
                  <Typography
                    sx={{
                      alignItems: "center",
                      width: "100%",
                      fontSize: "13px",
                      color: "#5d586c",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      {/* Left side */}
                      {isAdditional===false && 
                        <span style={{ marginRight: 1, fontWeight: "600", fontSize: "14px", color: "#1F2233", textTransform: 'capitalize' }}>
                          {getAppCoApplicantDetails("name")}
                        </span>
                      }

                      {/* Right side */}
                      {isApplicant && tabIndex > 0 && !partnerStartedJourney && (
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "#00b3b5",
                            cursor: "pointer",
                            fontSize: "0.85rem",
                          }}
                          onClick={() =>
                            handleTriggerLinkToCollectDocuments(
                              findCoApplicantNumber,
                              "co-applicant"
                            )
                          }
                        >
                          <img src={LinkIcon} alt="link" style={{ height: 16 }} />
                          Trigger Link to Collect documents
                        </Typography>
                      )}
                    </Box>
                    {isAdditional===false && 
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        <span>
                          {tabIndex == 0 ? (
                            partnerStartedJourney ? (
                              !mainApplicantDetails ? (
                                <Skeleton
                                  variant="text"
                                  width={120}
                                  sx={{ display: "inline-block" }}
                                />
                              ) : (
                                (() => {
                                  const email = mainApplicantDetails?.find(
                                    (item: any) => item.name === "email"
                                  )?.value;
                                  const phone = mainApplicantDetails?.find(
                                    (item: any) => item.name === "phone_number"
                                  )?.value;

                                  if (!email && !phone) return "Email: NA";

                                  return (
                                    <Box sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                      flexWrap: "nowrap",
                                      color: "#5d586c",
                                      mt: !isEmailVerified && !isMobileVerified ? '5px' : '0px'
                                    }}>
                                      <span style={{ marginRight: isEmailVerified ? '5px' : '8px', fontSize: "13px" }}>
                                        Email: <span style={{ fontSize: "14px" }}>{email || "NA"}</span>
                                      </span>
                                      {/* {!partnerStartedJourney && email && (
                                        <Button
                                          type="button"
                                          onClick={() => handleSendEmailOtp(email)}
                                          disabled={isEmailVerified || isLoading}
                                          sx={{
                                            backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                            color: isEmailVerified ? "#28C76F" : "#000000",
                                            "&:hover": {
                                              backgroundColor: isEmailVerified ? "transparent" : "#E5AF00",
                                            },
                                            "&.Mui-disabled": {
                                              backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                              color: isEmailVerified ? "#28C76F" : "#000000",
                                              opacity: 1, // Add this to prevent the blur/fading
                                              WebkitTextFillColor: isEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                            },
                                            textTransform: "none",
                                            fontSize: isEmailVerified ? "13px" : "10px",
                                            fontWeight: isEmailVerified ? 500 : 700,
                                            px: isEmailVerified ? '5px' : "10px",
                                            py: isEmailVerified ? '0px' : "5px",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            boxShadow: "none"
                                          }}
                                        >
                                          {isEmailVerified ? (
                                            <>
                                              <img
                                                src={greenCheckVerified}
                                                alt="Verified"
                                                style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                              />
                                              <Typography variant="inherit">Verified</Typography>
                                            </>
                                          ) : (
                                            <>
                                              <Typography variant="inherit">Verify</Typography>
                                              <img
                                                src={arrowRightVerify}
                                                alt="Verified"
                                                style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                              />
                                            </>
                                          )}
                                        </Button>
                                      )} */}
                                    </Box>
                                  );
                                })()
                              )
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                  color: "#5d586c",
                                  mt: !isEmailVerified && !isMobileVerified ? '5px' : '0px'
                                }}
                              >
                                {/* Email */}
                                <span style={{ marginRight: isEmailVerified ? '5px' : '8px', fontSize: "13px" }}>
                                  Email: <span style={{ fontSize: "14px" }}>{formUserData?.email || "NA"}</span>
                                </span>
                                {/* {!partnerStartedJourney && formUserData?.email && (
                                  <Button
                                    type="button"
                                    onClick={() => handleSendEmailOtp(formUserData?.email)}
                                    disabled={isEmailVerified || isLoading}
                                    sx={{
                                      backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                      color: isEmailVerified ? "#28C76F" : "#000000",
                                      "&:hover": {
                                        backgroundColor: isEmailVerified ? "transparent" : "#E5AF00",
                                      },
                                      "&.Mui-disabled": {
                                        backgroundColor: isEmailVerified ? "transparent" : "#FEC10D",
                                        color: isEmailVerified ? "#28C76F" : "#000000",
                                        opacity: 1, // Add this to prevent the blur/fading
                                        WebkitTextFillColor: isEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                      },
                                      textTransform: "none",
                                      fontSize: isEmailVerified ? "13px" : "10px",
                                      fontWeight: isEmailVerified ? 500 : 700,
                                      px: isEmailVerified ? '5px' : "10px",
                                      py: isEmailVerified ? '0px' : "5px",
                                      borderRadius: "4px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                      boxShadow: "none"
                                    }}
                                  >
                                    {isEmailVerified ? (
                                      <>
                                        <img
                                          src={greenCheckVerified}
                                          alt="Verified"
                                          style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                        />
                                        <Typography variant="inherit">Verified</Typography>
                                      </>
                                    ) : (
                                      <>
                                        <Typography variant="inherit">Verify</Typography>
                                        <img
                                          src={arrowRightVerify}
                                          alt="Verified"
                                          style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                        />
                                      </>
                                    )}
                                  </Button>
                                )} */}
                              </Box>
                            )
                          ) : partnerStartedJourney ? (
                            (() => {
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];

                              if (!co)
                                return (
                                  <Skeleton
                                    variant="text"
                                    width={120}
                                    sx={{ display: "inline-block" }}
                                  />
                                );

                              const email = co?.coApplicantEmail;
                              const phone = co?.coApplicantPhone;

                              if (!email && !phone) return "Email: NA";

                              return (
                                <>
                                  <span style={{ marginRight: '5px', fontSize: "13px" }}>
                                    Email: <span style={{ fontSize: "13px" }}>{email || "NA"}</span>
                                  </span>
                                </>
                              );
                            })()
                          ) : (
                            (() => {
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];
                              const email = co?.Email;
                              const phone = co?.PhoneNumber;

                              if (!email && !phone) return "Email: NA";

                              return (
                                <Box sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                  color: "#5d586c",
                                  mt: !co?.IsEmailVerified && !co?.IsMobileVerified ? '5px' : '0px'
                                }}>
                                  <span style={{ marginRight: co?.IsEmailVerified ? '5px' : '8px', fontSize: "13px" }}>
                                    Email: <span style={{ fontSize: "14px" }}>{email || "NA"}</span>
                                  </span>
                                  {/* {!partnerStartedJourney && email && (
                                    <Button
                                      type="button"
                                      onClick={() => handleSendEmailOtp(co?.Email)}
                                      disabled={co?.IsEmailVerified || isLoading}
                                      sx={{
                                        backgroundColor: co?.IsEmailVerified ? "transparent" : "#FEC10D",
                                        color: co?.IsEmailVerified ? "#28C76F" : "#000000",
                                        "&:hover": {
                                          backgroundColor: co?.IsEmailVerified ? "transparent" : "#E5AF00",
                                        },
                                        "&.Mui-disabled": {
                                          backgroundColor: co?.IsEmailVerified ? "transparent" : "#FEC10D",
                                          color: co?.IsEmailVerified ? "#28C76F" : "#000000",
                                          opacity: 1, // Add this to prevent the blur/fading
                                          WebkitTextFillColor: co?.IsEmailVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                        },
                                        textTransform: "none",
                                        fontSize: co?.IsEmailVerified ? "13px" : "10px",
                                        fontWeight: co?.IsEmailVerified ? 500 : 700,
                                        px: co?.IsEmailVerified ? '5px' : "10px",
                                        py: co?.IsEmailVerified ? '0px' : "5px",
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        boxShadow: "none"
                                      }}
                                    >
                                      {co?.IsEmailVerified ? (
                                        <>
                                          <img
                                            src={greenCheckVerified}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                          <Typography variant="inherit">Verified</Typography>
                                        </>
                                      ) : (
                                        <>
                                          <Typography variant="inherit">Verify</Typography>
                                          <img
                                            src={arrowRightVerify}
                                            alt="Verified"
                                            style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                        </>
                                      )}
                                    </Button>
                                  )} */}
                                </Box>
                              );
                            })()
                          )}
                        </span>

                        <span>
                          {tabIndex == 0 ? (
                            partnerStartedJourney ? (
                              !mainApplicantDetails ? (
                                <Skeleton
                                  variant="text"
                                  width={120}
                                  sx={{ display: "inline-block" }}
                                />
                              ) : (
                                (() => {
                                  const email = mainApplicantDetails?.find(
                                    (item: any) => item.name === "email"
                                  )?.value;
                                  const phone = mainApplicantDetails?.find(
                                    (item: any) => item.name === "phone_number"
                                  )?.value;

                                  if (!email && !phone) return "Email: NA";

                                  return (
                                    <Box sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                      flexWrap: "nowrap",
                                      color: "#5d586c",
                                      mt: !isEmailVerified && !isMobileVerified ? '8px' : '0px'
                                    }}>
                                      <span style={{ marginRight: isMobileVerified ? '5px' : '8px', fontSize: "13px" }}>
                                        Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                      </span>
                                      {/* {!partnerStartedJourney && phone && (
                                        <Button
                                          type="button"
                                          onClick={() =>
                                            handleSendMobileOtp(phone)
                                          }
                                          disabled={isMobileVerified || isLoading}
                                          sx={{
                                            backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                            color: isMobileVerified ? "#28C76F" : "#000000",
                                            "&:hover": {
                                              backgroundColor: isMobileVerified ? "transparent" : "#E5AF00",
                                            },
                                            "&.Mui-disabled": {
                                              backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                              color: isMobileVerified ? "#28C76F" : "#000000",
                                              opacity: 1, // Add this to prevent the blur/fading
                                              WebkitTextFillColor: isMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                            },
                                            textTransform: "none",
                                            fontSize: isMobileVerified ? "13px" : "10px",
                                            fontWeight: isMobileVerified ? 500 : 700,
                                            px: isMobileVerified ? '5px' : "10px",
                                            py: isMobileVerified ? '0px' : "5px",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            boxShadow: "none"
                                          }}
                                        >
                                          {isMobileVerified ? (
                                            <>
                                              <img
                                                src={greenCheckVerified}
                                                alt="Verified"
                                                style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                              />
                                              <Typography variant="inherit">Verified</Typography>
                                            </>
                                          ) : (
                                            <>
                                              <Typography variant="inherit">Verify</Typography>
                                              <img
                                                src={arrowRightVerify}
                                                alt="Verified"
                                                style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                              />
                                            </>
                                          )}
                                        </Button>
                                      )} */}
                                    </Box>
                                  );
                                })()
                              )
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                  color: "#5d586c",
                                  mt: !isEmailVerified && !isMobileVerified ? '8px' : '0px'
                                }}
                              >
                                {/* Phone */}
                                <span style={{ marginRight: isMobileVerified ? '5px' : '8px', fontSize: "13px" }}>
                                  Phone: <span style={{ fontSize: "13px" }}>{formUserData?.phone_number || "NA"}</span>
                                </span>
                                {/* {!partnerStartedJourney && formUserData?.phone_number && (
                                  <Button
                                    type="button"
                                    onClick={() =>
                                      handleSendMobileOtp(formUserData?.phone_number)
                                    }
                                    disabled={isMobileVerified || isLoading}
                                    sx={{
                                      backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                      color: isMobileVerified ? "#28C76F" : "#000000",
                                      "&:hover": {
                                        backgroundColor: isMobileVerified ? "transparent" : "#E5AF00",
                                      },
                                      "&.Mui-disabled": {
                                        backgroundColor: isMobileVerified ? "transparent" : "#FEC10D",
                                        color: isMobileVerified ? "#28C76F" : "#000000",
                                        opacity: 1, // Add this to prevent the blur/fading
                                        WebkitTextFillColor: isMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                      },
                                      textTransform: "none",
                                      fontSize: isMobileVerified ? "13px" : "10px",
                                      fontWeight: isMobileVerified ? 500 : 700,
                                      px: isMobileVerified ? '5px' : "10px",
                                      py: isMobileVerified ? '0px' : "5px",
                                      borderRadius: "4px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                      boxShadow: "none"
                                    }}
                                  >
                                    {isMobileVerified ? (
                                      <>
                                        <img
                                          src={greenCheckVerified}
                                          alt="Verified"
                                          style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                        />
                                        <Typography variant="inherit">Verified</Typography>
                                      </>
                                    ) : (
                                      <>
                                        <Typography variant="inherit">Verify</Typography>
                                        <img
                                          src={arrowRightVerify}
                                          alt="Verified"
                                          style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                        />
                                      </>
                                    )}
                                  </Button>
                                )} */}
                              </Box>
                            )
                          ) : partnerStartedJourney ? (
                            (() => {
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];

                              if (!co)
                                return (
                                  <Skeleton
                                    variant="text"
                                    width={120}
                                    sx={{ display: "inline-block" }}
                                  />
                                );

                              const email = co?.coApplicantEmail;
                              const phone = co?.coApplicantPhone;

                              if (!email && !phone) return "Phone: NA";

                              return (
                                <>
                                  <span style={{ marginRight: '5px', fontSize: "13px" }}>
                                    Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                  </span>
                                </>
                              );
                            })()
                          ) : (
                            (() => {
                              const key: any = `coapplicant${findCoApplicantNumber}`;
                              const co = coApplicantDetails?.[key];
                              const email = co?.Email;
                              const phone = co?.PhoneNumber;

                              if (!email && !phone) return "Phone: NA";

                              return (
                                <Box sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                  color: "#5d586c",
                                  mt: !co?.IsEmailVerified && !co?.IsMobileVerified ? '8px' : '0px'
                                }}>
                                  <span style={{ marginRight: co?.IsMobileVerified ? '5px' : '8px', fontSize: "13px" }}>
                                    Phone: <span style={{ fontSize: "13px" }}>{phone || "NA"}</span>
                                  </span>
                                  {/* {!partnerStartedJourney && phone && (
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        handleSendMobileOtp(phone)
                                      }
                                      disabled={co?.IsMobileVerified || isLoading}
                                      sx={{
                                        backgroundColor: co?.IsMobileVerified ? "transparent" : "#FEC10D",
                                        color: co?.IsMobileVerified ? "#28C76F" : "#000000",
                                        "&:hover": {
                                          backgroundColor: co?.IsMobileVerified ? "transparent" : "#E5AF00",
                                        },
                                        "&.Mui-disabled": {
                                          backgroundColor: co?.IsMobileVerified ? "transparent" : "#FEC10D",
                                          color: co?.IsMobileVerified ? "#28C76F" : "#000000",
                                          opacity: 1, // Add this to prevent the blur/fading
                                          WebkitTextFillColor: co?.IsMobileVerified ? "#28C76F" : "#000000", // Ensures consistent color on iOS/Safari
                                        },
                                        textTransform: "none",
                                        fontSize: co?.IsMobileVerified ? "13px" : "10px",
                                        fontWeight: co?.IsMobileVerified ? 500 : 700,
                                        px: co?.IsMobileVerified ? '5px' : "10px",
                                        py: co?.IsMobileVerified ? '0px' : "5px",
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        boxShadow: "none"
                                      }}
                                    >
                                      {co?.IsMobileVerified ? (
                                        <>
                                          <img
                                            src={greenCheckVerified}
                                            alt="Verified"
                                            style={{ height: '13px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                          <Typography variant="inherit">Verified</Typography>
                                        </>
                                      ) : (
                                        <>
                                          <Typography variant="inherit">Verify</Typography>
                                          <img
                                            src={arrowRightVerify}
                                            alt="Verified"
                                            style={{ height: '14px', objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
                                          />
                                        </>
                                      )}
                                    </Button>
                                  )} */}
                                </Box>
                              );
                            })()
                          )}
                        </span>
                      </Box>
                    }
                  </Typography>
                )}
              </Box>
            )}
            {isAdditional===false && 
              <Typography
                variant="subtitle1"
                sx={{
                  mt: isApplicant ? 3 : 0,
                  mb: 3,
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#1F2233",
                }}
              >
                Please upload pending documents
              </Typography>
            }

            {isLoading ? (
              <>Loading ...</>
            ) : (
              <>
                {documentData &&
                  Array.isArray(documentData) &&
                  documentData
                    // ?.filter((elem: any) => elem?.isMand)
                    ?.map((elem: any, i: number) => {
                      return (
                        <Box key={i}>
                          <Box 
                            data-document-section={elem?.name}
                            sx={{ mb: 4, scrollMarginTop: "16px" }}
                          >
                            {/* Main Card Container */}
                            <Box
                              sx={{
                                borderRadius: "8px",
                                border: "1px solid #e0e0e0",
                                backgroundColor: "#fff",
                                p: 0,
                              }}
                            >
                              {/* Header */}
                              <Box
                                sx={{
                                  backgroundColor: "rgba(0, 179, 181, 0.08)",
                                  padding: "12px 16px",
                                  borderRadius: "8px 8px 0 0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    color: "#1F2233",
                                  }}
                                >
                                  {elem?.name}
                                </Typography>
                                {isPartnerJourneyCategoryEditable(elem?.name) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                  <Button
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    sx={{
                                      borderColor: "#00b3b5",
                                      color: "#00b3b5",
                                      textTransform: "none",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      px: 2,
                                      py: 0.5,
                                      borderRadius: "6px",
                                      backgroundColor:
                                        "rgba(0, 179, 181, 0.08)",
                                      "&:hover": {
                                        borderColor: "#00999a",
                                        backgroundColor:
                                          "rgba(0, 179, 181, 0.08)",
                                      },
                                    }}
                                    onClick={() =>
                                      handleShowAddMoreDocument(elem?.id)
                                    }
                                  >
                                    Add
                                  </Button>
                                ): null}
                              </Box>

                              {/* Showing text for address proof */}
                              {elem?.name?.toLowerCase() === "address proof" && (isAddressProofMandetory(elem?.documents)) && (
                                 <Grid
                                        item
                                        xs={12}
                                        sx={{
                                         mb: 1,
                                         p: 1,
                                         bgcolor: "#fff3cf",
                                         borderRadius: "8px",
                                         display: "flex",
                                         alignItems: "center", 
                                         ml: 2,
                                         mr: 2,
                                         mt:2
                                        }}
                                        >
                                           <Box
                                  sx={{
                                    pl: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                  }}
                                >
                                  <Typography color="textSecondary">
                                   Please submit at least one valid proof of address document to proceed.
                                  </Typography>
                                </Box>
                                          
                              </Grid>
                               
                              )}
                              {/* Showing text for address proof end */}

                              {elem?.documents?.length <= 0 && (
                                <Box
                                  sx={{
                                    p: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                  }}
                                >
                                  <Typography>
                                    Please upload the {elem?.name} as applicable
                                  </Typography>
                                </Box>
                              )}

                              {elem?.documents?.map((item: any, index: any) => {
                                // Check if this document has multiple uploads
                                const hasMultipleUploads =
                                  elem?.name === "Income Document" &&
                                  item?.userDocs?.length > 0;
                                const isAccAggrMan = item?.userDocs?.find(
                                  (val: any) =>
                                    val.uploadedVia ===
                                    "account_aggregator_manual"
                                );
                                return (
                                  <Box key={item?.docName + "-" + item?.id}>
                                    <Box
                                      sx={{
                                        p: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                      }}
                                    >
                                      {/* If document has multiple uploads, show each one separately */}
                                      {hasMultipleUploads ? (
                                        <>
                                          {isAccAggrMan === undefined &&
                                            item?.docName ===
                                            "Bank Statement" &&
                                            canManualUploadDocument(
                                              item,
                                              elem?.name
                                            ) &&  partnerStartedJourney===false &&(
                                              <Box
                                                sx={{
                                                  p: 2,
                                                  borderRadius: "8px",
                                                  border: "1px solid #e0e0e0",
                                                  backgroundColor: "#fff",
                                                }}
                                              >
                                                <Grid
                                                  container
                                                  spacing={2}
                                                  alignItems="center"
                                                >
                                                  <Grid item xs={12} sm={6}>
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                        mb: 1,
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          fontWeight: 600,
                                                          fontSize: "16px",
                                                          color: "#1F2233",
                                                        }}
                                                      >
                                                        {item?.docName}
                                                        {item.isMandatory && (
                                                          <span
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            *
                                                          </span>
                                                        )}
                                                      </Typography>

                                                      {/* mobile only  */}
                                                      {isXsOrSm && (
                                                        <Box
                                                          sx={{
                                                            backgroundColor:
                                                              "#ffebee",
                                                            color: "#d32f2f",
                                                            px: 1.5,
                                                            py: 0.5,
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: 500,
                                                            textTransform:
                                                              "uppercase",
                                                          }}
                                                        >
                                                          {"Pending"}
                                                        </Box>
                                                      )}
                                                    </Box>

                                                    <Typography
                                                      sx={{
                                                        fontSize: "14px",
                                                        color: "#666",
                                                        lineHeight: 1.4,
                                                      }}
                                                    >
                                                      {item?.description}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={1}
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    {/* desktop only  */}
                                                    {!isXsOrSm && (
                                                      <Box
                                                        sx={{
                                                          backgroundColor:
                                                            "#ffebee",
                                                          color: "#d32f2f",
                                                          px: 1.5,
                                                          py: 0.5,
                                                          borderRadius: "4px",
                                                          fontSize: "12px",
                                                          fontWeight: 500,
                                                          textTransform:
                                                            "uppercase",
                                                        }}
                                                      >
                                                        {"Pending"}
                                                      </Box>
                                                    )}
                                                  </Grid>
                                                  <Grid item xs={12} sm={2}>
                                                    {canManualUploadDocument(
                                                      item,
                                                      elem?.name
                                                    ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                        <Box
                                                          sx={{
                                                            display: "flex",
                                                            justifyContent:
                                                              "start",
                                                            alignItems: "center",
                                                            gap: 2,
                                                            mt: isXsOrSm ? 1 : 0,
                                                          }}
                                                        >
                                                          <Button
                                                            variant="outlined"
                                                            startIcon={
                                                              <img
                                                                src={UploadIcon}
                                                                alt="Upload"
                                                                style={{
                                                                  height: 16,
                                                                  width: 16,
                                                                }}
                                                              />
                                                            }
                                                            onClick={() =>
                                                              handleUploadDocument(
                                                                item?.id,
                                                                item,
                                                                undefined,
                                                                elem?.name
                                                              )
                                                            }
                                                            sx={{
                                                              textTransform:
                                                                "none",
                                                              borderColor:
                                                                "#00b3b5",
                                                              color: "#00b3b5",
                                                              "&:hover": {
                                                                borderColor:
                                                                  "#00999a",
                                                                bgcolor:
                                                                  "#e0f7fa",
                                                              },
                                                              px: 2,
                                                              py: 0.5,
                                                              borderRadius: "6px",
                                                              fontSize: "14px",
                                                              fontWeight: 500,
                                                              minWidth: "auto",
                                                              whiteSpace:
                                                                "nowrap",
                                                            }}
                                                            disabled={uploadDocumentLoader.includes(
                                                              item?.id
                                                            )}
                                                          >
                                                            {uploadDocumentLoader.includes(
                                                              item?.id
                                                            ) ? (
                                                              <CircularProgress
                                                                size={16}
                                                              />
                                                            ) : (
                                                              "Upload"
                                                            )}
                                                          </Button>
                                                        </Box>
                                                      ): null}
                                                  </Grid>
                                                </Grid>
                                              </Box>
                                            )}
                                          {item?.userDocs?.map(
                                            (
                                              userDoc: any,
                                              docIndex: number
                                            ) => {
                                              const isLastDocument =
                                                docIndex ===
                                                item?.userDocs?.length - 1;
                                              return (
                                                <Box key={userDoc?.docUrl + "-" + userDoc?.id}>
                                                  {userDoc?.uploadedVia ===
                                                    "account_aggregator_manual" && (
                                                      <ManualBankStatement
                                                        item={item}
                                                        userDoc={userDoc}
                                                        isXsOrSm={isXsOrSm}
                                                        handleUploadDocument={
                                                          handleUploadDocument
                                                        }
                                                        partnerStartedJourney={
                                                          partnerStartedJourney
                                                        }
                                                        categoryName={elem?.name}
                                                        canReUpload={canManualUploadDocument(
                                                          item,
                                                          elem?.name
                                                        )}
                                                        uploadDocumentLoader={
                                                          uploadDocumentLoader
                                                        }
                                                        handlePreviewDocument={
                                                          handlePreviewDocument
                                                        }
                                                        isLoadingButton={isLoadingButton}
                                                        docSecName={elem?.name}
                                                      />
                                                    )}
                                                  <Box
                                                    key={`${item?.id}-${docIndex}`}
                                                    sx={
                                                      userDoc?.uploadedVia ===
                                                        "account_aggregator_manual"
                                                        ? {}
                                                        : {
                                                          p: 2,
                                                          borderRadius: "8px",
                                                          border:
                                                            "1px solid #e0e0e0",
                                                          backgroundColor:
                                                            "#fff",
                                                        }
                                                    }
                                                  >
                                                    <Grid
                                                      container
                                                      spacing={2}
                                                      alignItems="center"
                                                    >
                                                      {userDoc?.uploadedVia !==
                                                        "account_aggregator_manual" && (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                          >
                                                            <Box
                                                              sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                  "space-between",
                                                                alignItems:
                                                                  "center",
                                                                mb: 1,
                                                              }}
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontWeight: 600,
                                                                  fontSize:
                                                                    "16px",
                                                                  color:
                                                                    "#1F2233",
                                                                }}
                                                              >
                                                                {item?.docName}{" "}
                                                                {
                                                                  userDoc?.bankName
                                                                }{" "}
                                                                {item.isMandatory && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "red",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>
                                                                )}
                                                              </Typography>

                                                              {/* mobile only  */}
                                                              {isXsOrSm && (
                                                                <Box
                                                                  sx={{
                                                                    backgroundColor:
                                                                      "rgba(40, 199, 111, 0.16)",
                                                                    color:
                                                                      "rgba(40, 199, 111, 1)",
                                                                    px: 1.5,
                                                                    py: 0.5,
                                                                    borderRadius:
                                                                      "4px",
                                                                    fontSize:
                                                                      "12px",
                                                                    fontWeight: 500,
                                                                    textTransform:
                                                                      "uppercase",
                                                                  }}
                                                                >
                                                                  Uploaded
                                                                </Box>
                                                              )}
                                                            </Box>

                                                            <Typography
                                                              sx={{
                                                                fontSize: "14px",
                                                                color: "#666",
                                                                lineHeight: 1.4,
                                                              }}
                                                            >
                                                              {item?.description}
                                                            </Typography>
                                                          </Grid>
                                                        )}
                                                      {userDoc?.uploadedVia !==
                                                        "account_aggregator_manual" && (
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            sm={2}
                                                            sx={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "space-between",
                                                              alignItems:
                                                                "center",
                                                            }}
                                                          >
                                                            {/* desktop only  */}
                                                            {!isXsOrSm && (
                                                              <Box
                                                                sx={{
                                                                  backgroundColor:
                                                                    "rgba(40, 199, 111, 0.16)",
                                                                  color:
                                                                    "rgba(40, 199, 111, 1)",
                                                                  px: 1.5,
                                                                  py: 0.5,
                                                                  borderRadius:
                                                                    "4px",
                                                                  fontSize:
                                                                    "12px",
                                                                  fontWeight: 500,
                                                                  textTransform:
                                                                    "uppercase",
                                                                }}
                                                              >
                                                                Uploaded
                                                              </Box>
                                                            )}

                                                            <Box
                                                              sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                  "space-between",
                                                                alignItems:
                                                                  "center",
                                                                gap: 2,
                                                                mt: isXsOrSm
                                                                  ? 1
                                                                  : 0,
                                                                ml:isXsOrSm ? 0 : 1
                                                              }}
                                                            >
                                                              {canManualUploadDocument(
                                                                item,
                                                                elem?.name
                                                              ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                                  <>
                                                                    <Button
                                                                      variant="outlined"
                                                                      startIcon={
                                                                        <img
                                                                          src={
                                                                            UploadIcon
                                                                          }
                                                                          alt="Upload"
                                                                          style={{
                                                                            height: 16,
                                                                            width: 16,
                                                                          }}
                                                                        />
                                                                      }
                                                                      onClick={() =>
                                                                        handleUploadDocument(
                                                                          item?.id,
                                                                          item,
                                                                          userDoc?.bankName,
                                                                          elem?.name
                                                                        )
                                                                      }
                                                                      sx={{
                                                                        textTransform:
                                                                          "none",
                                                                        borderColor:
                                                                          "#00b3b5",
                                                                        color:
                                                                          "#00b3b5",
                                                                        "&:hover": {
                                                                          borderColor:
                                                                            "#00999a",
                                                                          bgcolor:
                                                                            "#e0f7fa",
                                                                        },
                                                                        px: 2,
                                                                        py: 0.5,
                                                                        borderRadius:
                                                                          "6px",
                                                                        fontSize:
                                                                          "14px",
                                                                        fontWeight: 500,
                                                                        minWidth:
                                                                          "auto",
                                                                        whiteSpace:
                                                                          "nowrap",
                                                                      }}
                                                                      disabled={uploadDocumentLoader.includes(
                                                                        item?.id
                                                                      )}
                                                                    >
                                                                      {uploadDocumentLoader.includes(
                                                                        item?.id
                                                                      ) ? (
                                                                        <CircularProgress
                                                                          size={16}
                                                                        />
                                                                      ) : (
                                                                        "Re-Upload"
                                                                      )}
                                                                    </Button>
                                                                  </>
                                                                ): null}

                                                              <Button
                                                                startIcon={
                                                                  <img
                                                                    src={Eyecon}
                                                                    alt="View"
                                                                    style={{
                                                                      height: 16,
                                                                      width: 16,
                                                                    }}
                                                                  />
                                                                }
                                                                onClick={() => {
                                                                  const docUrl =
                                                                    userDoc?.docUrl;
                                                                  const docUuid =
                                                                    userDoc?.uuid;
                                                                  const docS3location =
                                                                    userDoc?.s3Location;
                                                                  if (userDoc?.bankName) {
                                                                    setLoadingIndex(userDoc?.bankName ?? docUrl ?? docUuid ?? docS3location);
                                                                  } else {
                                                                    setLoadingIndex(userDoc?.documentId ?? docUrl ?? docUuid ?? docS3location);
                                                                  }

                                                                  if (
                                                                    userDoc?.isPartnerDoc===true
                                                                  ) {
                                                                    handlePreviewDownloadDocument(
                                                                      docUuid,
                                                                      docS3location
                                                                    );
                                                                  } else {
                                                                    if (
                                                                      userDoc?.uploadedVia ===
                                                                      "account_agreegator"
                                                                    ) {
                                                                      handlePreviewAggregateDocument(
                                                                        docUrl ?? docUuid ?? docS3location
                                                                      );
                                                                    } else {
                                                                      handlePreviewDocument(
                                                                        docUrl ?? docUuid ?? docS3location
                                                                      );
                                                                    }
                                                                  }
                                                                }}
                                                                disabled={
                                                                  isLoadingButton
                                                                }
                                                                 variant="outlined"
                                                                sx={{
                                                                  borderColor: "#00b3b5",
                                                                  border: { xs: "", sm: "none" },
                                                                  borderRadius: "6px",
                                                                  textTransform:
                                                                    "none",
                                                                  color:
                                                                    "#00b3b5",
                                                                  "&:hover": {
                                                                    borderColor:
                                                                      "#00999a",
                                                                    bgcolor:
                                                                      "#e0f7fa",
                                                                  },
                                                                  px: 2,
                                                                  py: 0.5,
                                                                  mt: isXsOrSm
                                                                    ? 0
                                                                    : 0,
                                                                  fontSize:
                                                                    "14px",
                                                                  fontWeight: 500,
                                                                  minWidth:
                                                                    "auto",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                 // remove border and hover effects when the button is disabled
                                                                 "&.Mui-disabled": {
                                                                   border: { xs: "1px solid #9e9e9e", sm: "none" },
                                                                   borderColor: "transparent",
                                                                   bgcolor: "transparent",
                                                                   color: "#9e9e9e",
                                                                   "&:hover": {
                                                                     border: "none",
                                                                     bgcolor: "transparent",
                                                                   },
                                                                   "& img": {
                                                                     opacity: 0.5,
                                                                   },
                                                                 },
                                                                }}
                                                              >
                                                                {isLoadingButton && (userDoc?.bankName === loadingIndex || userDoc?.documentId === loadingIndex || userDoc?.docUrl === loadingIndex || userDoc?.uuid === loadingIndex || userDoc?.s3Location === loadingIndex)
                                                                  ? "Loading..."
                                                                  : "View"}
                                                              </Button>
                                                            </Box>
                                                          </Grid>
                                                        )}

                                                      {/* Account Aggregator section for multiple documents - only on last document */}
                                                      {isLastDocument &&
                                                        canUseAccountAggregatorDocument(
                                                          item,
                                                          elem?.name
                                                        ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                          <Grid item xs={12}>
                                                            <Box
                                                              sx={{
                                                                mt: 2,
                                                                p: 2,
                                                                backgroundColor:
                                                                  "rgba(255, 159, 67, 0.16)",
                                                                borderRadius:
                                                                  "8px",
                                                              }}
                                                            >
                                                              <Grid
                                                                container
                                                                spacing={2}
                                                                alignItems="center"
                                                              >
                                                                <Grid
                                                                  item
                                                                  xs={12}
                                                                  sm={12}
                                                                >
                                                                  <Box
                                                                    sx={{
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      gap: 1,
                                                                      mb: 0.5,
                                                                    }}
                                                                  >
                                                                    <Box
                                                                      sx={{
                                                                        width: 26,
                                                                        height: 26,
                                                                        backgroundColor:
                                                                          "rgba(255, 159, 67, 1)",
                                                                        borderRadius:
                                                                          "6px",
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        justifyContent:
                                                                          "center",
                                                                        flexShrink: 0,
                                                                      }}
                                                                    >
                                                                      <img
                                                                        src={
                                                                          fileTextAccountStatement
                                                                        }
                                                                        alt="Account Aggregator"
                                                                        style={{
                                                                          height: 16,
                                                                          width: 16,
                                                                        }}
                                                                      />
                                                                    </Box>
                                                                    <Typography
                                                                      sx={{
                                                                        fontWeight: 600,
                                                                        fontSize:
                                                                          "16px",
                                                                        color:
                                                                          "#1F2233",
                                                                      }}
                                                                    >
                                                                      Account
                                                                      Aggregator
                                                                    </Typography>
                                                                  </Box>
                                                                  <Typography
                                                                    sx={{
                                                                      fontSize:
                                                                        "14px",
                                                                      color:
                                                                        "#1F2233",
                                                                      paddingLeft:
                                                                        "3%",
                                                                    }}
                                                                  >
                                                                    Account
                                                                    Aggregator
                                                                    is an
                                                                    RBI-regulated
                                                                    service that
                                                                    allows
                                                                    secure,
                                                                    consent-based
                                                                    sharing of
                                                                    your
                                                                    financial
                                                                    data
                                                                    directly
                                                                    from your
                                                                    bank without
                                                                    sharing
                                                                    passwords or
                                                                    login
                                                                    credentials.
                                                                  </Typography>
                                                                </Grid>
                                                                <Grid
                                                                  item
                                                                  xs={12}
                                                                  sm={12}
                                                                >
                                                                  {isAggregateVerify && (
                                                                    <Box>
                                                                      <Typography
                                                                        sx={{
                                                                          fontSize:
                                                                            "14px",
                                                                          color:
                                                                            "#1F2233",
                                                                          display:
                                                                            "block",
                                                                          fontWeight: 600,
                                                                        }}
                                                                        pb={1}
                                                                      >
                                                                        Fetching
                                                                        the
                                                                        document
                                                                        until it
                                                                        is
                                                                        fetched.
                                                                      </Typography>
                                                                    </Box>
                                                                  )}
                                                                  <Box
                                                                    sx={{
                                                                      display:
                                                                        "flex",
                                                                    }}
                                                                  >
                                                                    <Button
                                                                      variant="contained"
                                                                      endIcon={
                                                                        <ChevronRight />
                                                                      }
                                                                      sx={{
                                                                        textTransform:
                                                                          "none",
                                                                        backgroundColor:
                                                                          "#ffcc02",
                                                                        color:
                                                                          "#1F2233",
                                                                        "&:hover":
                                                                        {
                                                                          backgroundColor:
                                                                            "#ffb300",
                                                                        },
                                                                        px: 2,
                                                                        py: 0.5,
                                                                        borderRadius:
                                                                          "6px",
                                                                        fontSize:
                                                                          "14px",
                                                                        fontWeight: 500,
                                                                        minWidth:
                                                                          "auto",
                                                                        whiteSpace:
                                                                          "nowrap",
                                                                      }}
                                                                      disabled={
                                                                        isAggregateVerify
                                                                      }
                                                                      onClick={async () => {
                                                                        try {

                                                                          await trackCustomerJourneyEventAndWait(  
                                                                            tabIndex == 0 ? "APPLICANT_ACCOUNTAGGREGATOR" : `COAPPLICANT(${findApplicantIndex})_ACCOUNTAGGREGATOR_DIGILOCKER`,
                                                                            decrypt(userProfile?.id) ?? "",
                                                                            applicationNumber,
                                                                            {
                                                                              label: tabIndex == 0 ? "APPLICANT_ACCOUNTAGGREGATOR" : `COAPPLICANT(${findApplicantIndex})_ACCOUNTAGGREGATOR_DIGILOCKER`,
                                                                              category: tabIndex == 0 ? "APPLICANT_ACCOUNTAGGREGATOR" : `COAPPLICANT(${findApplicantIndex})_ACCOUNTAGGREGATOR_DIGILOCKER`,
                                                                              action: tabIndex == 0 ? "APPLICANT_ACCOUNTAGGREGATOR" : `COAPPLICANT(${findApplicantIndex})_ACCOUNTAGGREGATOR_DIGILOCKER`,
                                                                              page: tabIndex == 0 ? "Applicant Account Aggregator" : `Co-Applicant (${findApplicantIndex}) Account Aggregator`,
                                                                            }
                                                                          , 500);

                                                                          const mobileNumber: any =
                                                                            getAppCoApplicantDetails(
                                                                              "phone"
                                                                            );
                                                                          setMobileNumberError(
                                                                            ""
                                                                          );
                                                                          setAccountAggregatorMobileNumber(
                                                                            mobileNumber ||
                                                                            ""
                                                                          );
                                                                          localStorage.setItem(
                                                                            "accountAggregatorMobile",
                                                                            mobileNumber ||
                                                                            ""
                                                                          );
                                                                          handleAccountAggregatorRequest(
                                                                            item?.id,
                                                                            "button",
                                                                            item
                                                                          );
                                                                        } catch (error) {
                                                                          console.error(
                                                                            "Error in Account Aggregator button click:",
                                                                            error
                                                                          );
                                                                          dispatch(
                                                                            setStatusPopup(
                                                                              {
                                                                                status:
                                                                                  "error",
                                                                                message:
                                                                                  "Error opening Account Aggregator modal. Please try again.",
                                                                              }
                                                                            )
                                                                          );
                                                                        }
                                                                      }}
                                                                    >
                                                                      Share via
                                                                      Account
                                                                      Aggregator
                                                                    </Button>
                                                                  </Box>
                                                                  <Typography
                                                                    sx={{
                                                                      fontSize:
                                                                        "14px",
                                                                      color:
                                                                        "#666",
                                                                      mt: 1,
                                                                      lineHeight: 1.4,
                                                                    }}
                                                                  >
                                                                    If you wish
                                                                    to update
                                                                    your mobile
                                                                    number or
                                                                    change the
                                                                    statement
                                                                    duration in
                                                                    the Account
                                                                    Aggregator,
                                                                    please{" "}
                                                                    <Typography
                                                                      component="span"
                                                                      sx={{
                                                                        color:
                                                                          "#00b3b5",
                                                                        textDecoration:
                                                                          "underline",
                                                                        cursor:
                                                                          "pointer",
                                                                        "&:hover":
                                                                        {
                                                                          color:
                                                                            "#00999a",
                                                                        },
                                                                      }}
                                                                      onClick={() => {
                                                                        try {
                                                                          const mobileNumber: any =
                                                                            getAppCoApplicantDetails(
                                                                              "phone"
                                                                            );
                                                                          setMobileNumberError(
                                                                            ""
                                                                          );
                                                                          setAccountAggregatorMobileNumber(
                                                                            mobileNumber ||
                                                                            ""
                                                                          );
                                                                          setSelectedDocumentId(
                                                                            item?.id
                                                                          );
                                                                          setSelectedDocumentItem(
                                                                            item
                                                                          );
                                                                          setIsAccountAggregatorModalOpen(
                                                                            true
                                                                          );
                                                                          localStorage.setItem(
                                                                            "accountAggregatorMobile",
                                                                            mobileNumber ||
                                                                            ""
                                                                          );
                                                                        } catch (error) {
                                                                          console.error(
                                                                            "Error in Account Aggregator button click:",
                                                                            error
                                                                          );
                                                                          dispatch(
                                                                            setStatusPopup(
                                                                              {
                                                                                status:
                                                                                  "error",
                                                                                message:
                                                                                  "Error opening Account Aggregator modal. Please try again.",
                                                                              }
                                                                            )
                                                                          );
                                                                        }
                                                                      }}
                                                                    >
                                                                      Click here
                                                                    </Typography>
                                                                    .
                                                                  </Typography>
                                                                </Grid>
                                                              </Grid>
                                                            </Box>
                                                          </Grid>
                                                        ): null}
                                                    </Grid>
                                                  </Box>
                                                </Box>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : (
                                        /* Single document or no upload - existing layout */
                                        <Box
                                          sx={{
                                            p: 2,
                                            borderRadius: "8px",
                                            border: "1px solid #e0e0e0",
                                            backgroundColor: "#fff",
                                          }}
                                        >
                                          <Grid
                                            container
                                            spacing={2}
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} sm={6}>
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  mb: 1,
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontWeight: 600,
                                                    fontSize: "16px",
                                                    color: "#1F2233",
                                                  }}
                                                >
                                                  {item?.docName}
                                                  {item.isMandatory && (
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Typography>

                                                {/* mobile only  */}
                                                {isXsOrSm && (
                                                  <Box
                                                    sx={{
                                                      backgroundColor:
                                                        item?.userDocs?.length >
                                                          0
                                                          ? "rgba(40, 199, 111, 0.16)"
                                                          : "#ffebee",
                                                      color:
                                                        item?.userDocs?.length >
                                                          0
                                                          ? "rgba(40, 199, 111, 1)"
                                                          : "#d32f2f",
                                                      px: 1.5,
                                                      py: 0.5,
                                                      borderRadius: "4px",
                                                      fontSize: "12px",
                                                      fontWeight: 500,
                                                      textTransform:
                                                        "uppercase",
                                                    }}
                                                  >
                                                    {item?.userDocs?.length > 0
                                                      ? "Uploaded"
                                                      : "Pending"}
                                                  </Box>
                                                )}
                                              </Box>

                                              <Typography
                                                sx={{
                                                  fontSize: "14px",
                                                  color: "#666",
                                                  lineHeight: 1.4,
                                                }}
                                              >
                                                {item?.description}
                                              </Typography>
                                            </Grid>

                                            <Grid
                                              item
                                              xs={12}
                                              sm={6}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                              }}
                                            >
                                              {/* desktop only  */}
                                              {!isXsOrSm && (
                                                <Box
                                                  sx={{
                                                    backgroundColor:
                                                      item?.userDocs?.length > 0
                                                        ? "rgba(40, 199, 111, 0.16)"
                                                        : "#ffebee",
                                                    color:
                                                      item?.userDocs?.length > 0
                                                        ? "rgba(40, 199, 111, 1)"
                                                        : "#d32f2f",
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    fontWeight: 500,
                                                    textTransform: "uppercase",
                                                  }}
                                                >
                                                  {item?.userDocs?.length > 0
                                                    ? "Uploaded"
                                                    : "Pending"}
                                                </Box>
                                              )}
                                              {item?.userDocs?.length > 0 ? (
                                                <Box
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: isXsOrSm ? "column" : "row", // Mobile: stack vertically, Desktop: row
                                                  justifyContent: "space-between",
                                                  alignItems: isXsOrSm ? "stretch" : "center",
                                                  gap: 2,
                                                  mt: isXsOrSm ? 1 : 0,
                                                  width: "100%",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: isXsOrSm ? "space-between" : "flex-start",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    width: isXsOrSm ? "100%" : "auto",
                                                  }}
                                                >
                                                  {(canManualUploadDocument(
                                                    item,
                                                    elem?.name
                                                  ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status)) ? (
                                                      <Button
                                                        variant="outlined"
                                                        startIcon={
                                                          <img
                                                            src={UploadIcon}
                                                            alt="Upload"
                                                            style={{
                                                              height: 16,
                                                              width: 16,
                                                            }}
                                                          />
                                                        }
                                                        onClick={() =>
                                                          handleUploadDocument(
                                                            item?.id,
                                                            item,
                                                            undefined,
                                                            elem?.name
                                                          )
                                                        }
                                                        sx={{
                                                          textTransform: "none",
                                                          borderColor: "#00b3b5",
                                                          color: "#00b3b5",
                                                          "&:hover": {
                                                            borderColor:
                                                              "#00999a",
                                                            bgcolor: "#e0f7fa",
                                                          },
                                                          px: 2,
                                                          py: 0.5,
                                                          ml: {xs: 0, sm: 1 },
                                                          borderRadius: "6px",
                                                          fontSize: "14px",
                                                          fontWeight: 500,
                                                          minWidth: "auto",
                                                          whiteSpace: "nowrap",
                                                        }}
                                                        disabled={uploadDocumentLoader.includes(
                                                          item?.id
                                                        )}
                                                      >
                                                        {uploadDocumentLoader.includes(
                                                          item?.id
                                                        ) ? (
                                                          <CircularProgress
                                                            size={16}
                                                          />
                                                        ) : (
                                                          "Re-Upload"
                                                        )}
                                                      </Button>
                                                    ): null}

                                                  <Button
                                                    startIcon={
                                                      <img
                                                        src={Eyecon}
                                                        alt="View"
                                                        style={{
                                                          height: 16,
                                                          width: 16,
                                                        }}
                                                      />
                                                    }
                                                    onClick={() => {
                                                      const docUrl =
                                                        item?.userDocs?.[0]
                                                          ?.docUrl;
                                                      const docUuid =
                                                        item?.userDocs?.[0]
                                                          ?.uuid;
                                                      const docS3location =
                                                        item?.userDocs?.[0]
                                                          ?.s3Location;
                                                      if (item?.userDocs?.[0]?.bankName) {
                                                        setLoadingIndex(item?.userDocs?.[0]?.bankName ?? docUrl ?? docUuid ?? docS3location);
                                                      } else {
                                                        setLoadingIndex(item?.userDocs?.[0]?.documentId ?? docUrl ?? docUuid ?? docS3location);
                                                      }
                                                      //setLoadingIndex(item?.userDocs?.[0]?.documentId ?? docUrl ?? docUuid ?? docS3location);
                                                      if (
                                                        item?.userDocs?.[0]?.isPartnerDoc===true
                                                      ) {
                                                        handlePreviewDownloadDocument(
                                                            docUuid,
                                                            docS3location
                                                        );
                                                      } else {
                                                        if (
                                                          item?.uploadedVia ===
                                                          "account_agreegator"
                                                        ) {
                                                          handlePreviewAggregateDocument(
                                                            docUrl ?? docUuid ?? docS3location
                                                          );
                                                        } else {
                                                          handlePreviewDocument(
                                                            docUrl ?? docUuid ?? docS3location
                                                          );
                                                        }
                                                      }
                                                    }}
                                                    disabled={isLoadingButton}
                                                     variant="outlined"
                                                    sx={{
                                                      textTransform: "none",
                                                      borderColor: "#00b3b5",
                                                      border: { xs: "", sm: "none" },
                                                      color: "#00b3b5",
                                                      "&:hover": {
                                                        borderColor: "#00999a",
                                                        bgcolor: "#e0f7fa",
                                                      },
                                                      px: 2,
                                                      py: 0.5,
                                                      mt: isXsOrSm ? 0 : 0,
                                                      fontSize: "14px",
                                                      fontWeight: 500,
                                                      minWidth: "auto",
                                                      whiteSpace: "nowrap",
                                                      // remove border and hover effects when the button is disabled
                                                      "&.Mui-disabled": {
                                                        border:  { xs: "1px solid #9e9e9e", sm: "none" },
                                                        borderColor: "transparent",
                                                        bgcolor: "transparent",
                                                        color: "#9e9e9e",
                                                        "&:hover": {
                                                          border: "none",
                                                          bgcolor: "transparent",
                                                        },
                                                        "& img": {
                                                          opacity: 0.5,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    {isLoadingButton && (loadingIndex === item?.userDocs?.[0]?.bankName || loadingIndex === item?.userDocs?.[0]
                                                      ?.documentId || item?.userDocs?.[0]
                                                        ?.docUrl === loadingIndex || item?.userDocs?.[0]
                                                          ?.uuid === loadingIndex || item?.userDocs?.[0]
                                                            ?.s3Location === loadingIndex)
                                                      ? "Loading..."
                                                      : "View"}
                                                  </Button>
                                                {/* Desktop: Third button appears to the right of View */}
                                                {!isMdOrBelow &&
                                                canUseDigiLockerForDocument(
                                                  item,
                                                  elem?.name
                                                ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ?  (
                                                  <Button
                                                    variant="outlined"
                                                    startIcon={
                                                      <img
                                                        src={DigiLockerIcon}
                                                        alt="Upload"
                                                        style={{
                                                          height: 16,
                                                          width: 16,
                                                        }}
                                                      />
                                                    }
                                                    onClick={() =>
                                                      handleDigiLockerDocument(
                                                        item?.id,
                                                        item?.docName,
                                                        item?.docType,
                                                        item,
                                                        elem?.name
                                                      )
                                                    }
                                                    disabled={digiLockerLoaderId.includes(
                                                      item?.id
                                                    )}
                                                    sx={{
                                                      textTransform: "none",
                                                      borderColor: "#00b3b5",
                                                      border: { xs: "", sm: "none" },
                                                      color: "#00b3b5",
                                                      "&:hover": {
                                                        borderColor:
                                                          "#00999a",
                                                        bgcolor: "#e0f7fa",
                                                      },
                                                      py: 0.5,
                                                      width: { xs: "100%", sm: "100px" },
                                                      borderRadius: "6px",
                                                      fontSize: "14px",
                                                      fontWeight: 500,
                                                      minWidth: "auto",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {digiLockerLoaderId.includes(
                                                      item?.id
                                                    ) ? (
                                                      <>
                                                        <CircularProgress
                                                          size={16}
                                                        />
                                                        <Typography
                                                          sx={{
                                                            fontSize: "12px",
                                                            fontWeight: 500,
                                                            color: "#00b3b5",
                                                          }}
                                                        >
                                                          Verifying...
                                                        </Typography>
                                                      </>
                                                    ) : (
                                                      "DigiLocker"
                                                    )}
                                                  </Button>
                                                ): null}
                                              </Box>

                                              {/* Mobile: Third button full width below both buttons */}
                                              {isMdOrBelow && 
                                              canUseDigiLockerForDocument(
                                                item,
                                                elem?.name
                                              ) &&  isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                <Button
                                                  variant="outlined"
                                                  startIcon={
                                                    <img
                                                      src={DigiLockerIcon}
                                                      alt="Upload"
                                                      style={{
                                                        height: 16,
                                                        width: 16,
                                                      }}
                                                    />
                                                  }
                                                  onClick={() =>
                                                    handleDigiLockerDocument(
                                                      item?.id,
                                                      item?.docName,
                                                      item?.docType,
                                                      item,
                                                      elem?.name
                                                    )
                                                  }
                                                  disabled={digiLockerLoaderId.includes(
                                                    item?.id
                                                  )}
                                                  sx={{
                                                    textTransform: "none",
                                                    borderColor: "#00b3b5",
                                                    border: { xs: "", sm: "none" },
                                                    color: "#00b3b5",
                                                    "&:hover": {
                                                      borderColor:
                                                        "#00999a",
                                                      bgcolor: "#e0f7fa",
                                                    },
                                                    py: 0.5,
                                                    width: { xs: "100%", sm: "100px" },
                                                    borderRadius: "6px",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    minWidth: "auto",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {digiLockerLoaderId.includes(
                                                    item?.id
                                                  ) ? (
                                                    <>
                                                      <CircularProgress
                                                        size={16}
                                                      />
                                                      <Typography
                                                        sx={{
                                                          fontSize: "12px",
                                                          fontWeight: 500,
                                                          color: "#00b3b5",
                                                        }}
                                                      >
                                                        Verifying...
                                                      </Typography>
                                                    </>
                                                  ) : (
                                                    "DigiLocker"
                                                  )}
                                                </Button>
                                              ): null
                                              }
                                              </Box>
                                              ) : (
                                                <Box
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: isXsOrSm ? "column" : "row", // Mobile: stack vertically, Desktop: row
                                                  justifyContent: "space-between",
                                                  alignItems: isXsOrSm ? "stretch" : "center",
                                                  gap: 2,
                                                  mt: isXsOrSm ? 1 : 0,
                                                  width: "100%",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    gap: { xs: 0.5, sm: 1.5 },
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                    alignItems: "center",
                                                    justifyContent: { xs: "space-between", sm: "flex-end" }, // Mobile: split, Web: right-aligned as before
                                                    boxSizing: "border-box",
                                                  }}
                                                >
                                                
                                                  {canManualUploadDocument(
                                                    item,
                                                    elem?.name
                                                  ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                      <Button
                                                        variant="outlined"
                                                        startIcon={
                                                          <img
                                                            src={UploadIcon}
                                                            alt="Upload"
                                                            style={{
                                                              height: 16,
                                                              width: 16,
                                                            }}
                                                          />
                                                        }
                                                        onClick={() =>
                                                          handleUploadDocument(
                                                            item?.id,
                                                            item,
                                                            undefined,
                                                            elem?.name
                                                          )
                                                        }
                                                        sx={{
                                                          textTransform: "none",
                                                          color: "#00b3b5",
                                                          borderColor: "#00b3b5",
                                                          "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                                                          borderRadius: "6px",
                                                          fontWeight: 500,

                                                          // --- Mobile vs Web Behavior ---
                                                          flex: { xs: 1, sm: "none" }, // Mobile: split equal width | Web: fixed content size
                                                          width: { xs: "auto", sm: "100px" }, // Web: exact 100px as before
                                                          minWidth: { xs: 0, sm: "100px" },

                                                          // --- Font & Padding ---
                                                          fontSize: { xs: "11px", sm: "14px" }, // Mobile: 11px | Web: exact 14px as before
                                                          px: { xs: 0.5, sm: 2 }, // Mobile: compact | Web: px: 2 as before
                                                          py: 0.5,

                                                          whiteSpace: "nowrap",
                                                          "& .MuiButton-startIcon": {
                                                            marginRight: { xs: "3px", sm: "8px" },
                                                            marginLeft: 0,
                                                            flexShrink: 0,
                                                          },
                                                        }}
                                                        disabled={uploadDocumentLoader.includes(
                                                          item?.id
                                                        )}
                                                      >
                                                        {uploadDocumentLoader.includes(
                                                          item?.id
                                                        ) ? (
                                                          <CircularProgress
                                                            size={16}
                                                          />
                                                        ) : (
                                                          "Upload"
                                                        )}
                                                      </Button>
                                                    ) : null}

                                                  {canUseDigiLockerForDocument(
                                                    item,
                                                    elem?.name
                                                  ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                                    <Button
                                                      variant="outlined"
                                                      startIcon={
                                                        <img
                                                          src={DigiLockerIcon}
                                                          alt="DigiLocker"
                                                          style={{ height: 14, width: 14, flexShrink: 0 }}
                                                        />
                                                      }
                                                      onClick={() =>
                                                        handleDigiLockerDocument(
                                                          item?.id,
                                                          item?.docName,
                                                          item?.docType,
                                                          item,
                                                          elem?.name
                                                        )
                                                      }
                                                      disabled={digiLockerLoaderId.includes(item?.id)}
                                                      sx={{
                                                        textTransform: "none",
                                                        color: "#00b3b5",
                                                        borderColor: { xs: "#00b3b5", sm: "" },
                                                        border: { sm: "none" }, // Web: border-none restored
                                                        "&:hover": { borderColor: "#00999a", bgcolor: "#e0f7fa" },
                                                        borderRadius: "6px",
                                                        fontWeight: 500,

                                                        // --- Mobile vs Web Behavior ---
                                                        flex: { xs: 1, sm: "none" }, // Mobile: split equal width | Web: fixed content size
                                                        width: { xs: "auto", sm: "100px" }, // Web: exact 100px as before
                                                        minWidth: { xs: 0, sm: "100px" },

                                                        // --- Font & Padding ---
                                                        fontSize: { xs: "11px", sm: "14px" }, // Mobile: 11px | Web: exact 14px as before
                                                        px: { xs: 0.5, sm: 2 }, // Mobile: compact | Web: px: 2 as before
                                                        py: 0.5,

                                                        whiteSpace: "nowrap",
                                                        "& .MuiButton-startIcon": {
                                                          marginRight: { xs: "3px", sm: "8px" },
                                                          marginLeft: 0,
                                                          flexShrink: 0,
                                                        },
                                                      }}
                                                    >
                                                      {digiLockerLoaderId.includes(item?.id) ? (
                                                        <Box
                                                          component="span"
                                                          sx={{
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 0.3,
                                                            whiteSpace: "nowrap",
                                                          }}
                                                        >
                                                          <CircularProgress size={12} sx={{ color: "#00b3b5" }} />
                                                          <Typography
                                                            component="span"
                                                            sx={{
                                                              fontSize: { xs: "10px", sm: "12px" },
                                                              fontWeight: 500,
                                                              color: "#00b3b5",
                                                            }}
                                                          >
                                                            Verifying...
                                                          </Typography>
                                                        </Box>
                                                      ) : (
                                                        "DigiLocker"
                                                      )}
                                                    </Button>
                                                  ) : (
                                                    <Box
                                                      sx={{
                                                        width: "100px",
                                                      }}
                                                    ></Box>
                                                  )}
                                                  </Box>
                                                </Box>
                                              )}
                                            </Grid>

                                            {canUseAccountAggregatorDocument(
                                              item,
                                              elem?.name
                                            ) && isUploadOptionShow(elem?.name, fetchUserApplicationData?.status) ? (
                                              <>
                                                <Box
                                                  sx={{
                                                    mt: 2,
                                                    p: 2,
                                                    ml: 2,
                                                    backgroundColor: "rgba(255, 159, 67, 0.16)",
                                                    borderRadius: "8px",
                                                    width: isXsOrSm ? "100%" : "auto",
                                                    maxWidth: "100%",
                                                    boxSizing: "border-box",
                                                    overflow: "hidden"
                                                  }}
                                                >
                                                  <Grid
                                                    container
                                                    spacing={isXsOrSm ? 1 : 2}
                                                    alignItems="center"
                                                  >
                                                    <Grid item xs={12}>
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: 1,
                                                          mb: 0.5,
                                                          flexWrap: "nowrap"
                                                        }}
                                                      >
                                                        <Box
                                                          sx={{
                                                            width: 26,
                                                            height: 26,
                                                            backgroundColor: "rgba(255, 159, 67, 1)",
                                                            borderRadius: "6px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            flexShrink: 0,
                                                          }}
                                                        >
                                                          <img
                                                            src={fileTextAccountStatement}
                                                            alt="Account Aggregator"
                                                            style={{ height: 16, width: 16 }}
                                                          />
                                                        </Box>
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 600,
                                                            fontSize: isXsOrSm ? "14px" : "16px",
                                                            color: "#1F2233",
                                                            whiteSpace: "normal"
                                                          }}
                                                        >
                                                          Account Aggregator
                                                        </Typography>
                                                      </Box>
                                                      <Typography
                                                        sx={{
                                                          fontSize: "13px",
                                                          color: "#1F2233",
                                                          paddingLeft: isXsOrSm ? "0" : "3%",
                                                          lineHeight: 1.4,
                                                          wordBreak: "break-word"
                                                        }}
                                                      >
                                                        Account Aggregator is an RBI-regulated service that allows secure,
                                                        consent-based sharing of your financial data directly from your bank
                                                        without sharing passwords or login credentials.
                                                      </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                      <Box sx={{ display: "flex", mt: 1, width: "100%" }}>
                                                        <Button
                                                          variant="contained"
                                                          endIcon={<ChevronRight />}
                                                          disabled={isAggregateVerify}
                                                          onClick={() => {
                                                            try {
                                                              const mobileNumber: any = getAppCoApplicantDetails("phone");
                                                              setMobileNumberError("");
                                                              setAccountAggregatorMobileNumber(mobileNumber || "");
                                                              localStorage.setItem("accountAggregatorMobile", mobileNumber || "");
                                                              handleAccountAggregatorRequest(item?.id, "button", item);
                                                            } catch (error) {
                                                              console.error("Error in Account Aggregator button click:", error);
                                                              dispatch(
                                                                setStatusPopup({
                                                                  status: "error",
                                                                  message:
                                                                    "Error opening Account Aggregator modal. Please try again.",
                                                                })
                                                              );
                                                            }
                                                          }}
                                                          sx={{
                                                            textTransform: "none",
                                                            backgroundColor: "#ffcc02",
                                                            color: "#1F2233",
                                                            "&:hover": { backgroundColor: "#ffb300" },
                                                            borderRadius: "6px",
                                                            fontWeight: 600,
                                                            boxShadow: "none",

                                                            // --- Responsive Width & Layout ---
                                                            width: isXsOrSm ? "100%" : "auto",

                                                            // --- Responsive Padding ---
                                                            px: { xs: 1.5, sm: 2 }, // Compact on mobile, default on web
                                                            py: { xs: 0.8, sm: 0.5 }, // Extra vertical cushion for mobile line wrapping

                                                            // --- Responsive Font & Text Wrapping ---
                                                            fontSize: { xs: "12px", sm: "13px" }, // Slightly smaller on mobile, exact 13px on web
                                                            whiteSpace: { xs: "normal", sm: "nowrap" }, // Wraps on mobile if screen is tiny, exact single-line on web
                                                            wordBreak: "break-word",
                                                            lineHeight: { xs: 1.25, sm: 1.5 },

                                                            // Ensure icon doesn't shrink on mobile
                                                            "& .MuiButton-endIcon": {
                                                              marginLeft: { xs: 0.5, sm: 1 },
                                                              flexShrink: 0,
                                                            },
                                                          }}
                                                        >
                                                          Share via Account Aggregator
                                                        </Button>
                                                      </Box>
                                                      <Typography
                                                        sx={{
                                                          fontSize: "12px",
                                                          color: "#666",
                                                          mt: 1.5,
                                                          lineHeight: 1.5,
                                                          whiteSpace: "normal"
                                                        }}
                                                      >
                                                        If you wish to update your mobile number or change the statement
                                                        duration in the Account Aggregator, please{" "}
                                                        <Typography
                                                          component="span"
                                                          sx={{
                                                            color: "#00b3b5",
                                                            fontSize: "12px",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            fontWeight: 600
                                                          }}
                                                          onClick={() => {
                                                            try {
                                                              const mobileNumber: any = getAppCoApplicantDetails("phone");
                                                              setMobileNumberError(
                                                                ""
                                                              );
                                                              setAccountAggregatorMobileNumber(
                                                                mobileNumber ||
                                                                ""
                                                              );
                                                              setSelectedDocumentId(
                                                                item?.id
                                                              );
                                                              setSelectedDocumentItem(
                                                                item
                                                              );
                                                              setIsAccountAggregatorModalOpen(
                                                                true
                                                              );
                                                              localStorage.setItem(
                                                                "accountAggregatorMobile",
                                                                mobileNumber ||
                                                                ""
                                                              );
                                                            } catch (error) {
                                                              console.error(
                                                                "Error in Account Aggregator button click:",
                                                                error
                                                              );
                                                              dispatch(
                                                                setStatusPopup(
                                                                  {
                                                                    status:
                                                                      "error",
                                                                    message:
                                                                      "Error opening Account Aggregator modal. Please try again.",
                                                                  }
                                                                )
                                                              );
                                                            }
                                                          }}
                                                        >
                                                          Click here
                                                        </Typography>
                                                        .
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                              </>
                                            ): null}
                                          </Grid>
                                        </Box>
                                      )}
                                    </Box>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
              </>
            )}

            {!partnerStartedJourney && fetchUserApplicationData?.status!=="Application Submitted" &&(
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setIsAddMoreModalOpen(true);
                  setMasterDocumentList([]);
                  handleGetCategoryList(0);
                  setModelType("addMainDocument");
                }}
                sx={{
                  my: 2,
                  bgcolor: "#00b3b5",
                  color: "#fff",
                  "&:hover": {
                    bgcolor: "#00999a",
                  },
                  textTransform: "none",
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                Add More Document
              </Button>
            )}

            {isXsOrSm && <CustomDivider />}
          </TabPanel>
        )}

        {isXsOrSm ? (
          <BottomSheet
            open={isBulkUploadModalOpen}
            onClose={handleCloseBulkUploadModal}
          >
            <BulkUploadModalContent
              onCancel={handleCloseBulkUploadModal}
              onContinue={handleContinueBulkUpload}
              tabIndex={tabIndex}
              handleDocCount={handleDocCount}
            />
          </BottomSheet>
        ) : (
          <ModalPopup
            isOpen={isBulkUploadModalOpen}
            onClose={handleCloseBulkUploadModal}
            title="Upload Bulk Documents"
          >
            <BulkUploadModalContent
              onCancel={handleCloseBulkUploadModal}
              onContinue={handleContinueBulkUpload}
              tabIndex={tabIndex}
              handleDocCount={handleDocCount}
            />
          </ModalPopup>
        )}

        <ModalPopup
          isOpen={isAddMoreModalOpen}
          onClose={() => {
            setIsAddMoreModalOpen(false);
            setDocumentCategoryId(0);
            setModelType("");
          }}
          title="Add More Documents"
        >
          <AddMoreDocumentForm
            applicants={applicants}
            onClose={() => {
              setIsAddMoreModalOpen(false);
              setDocumentCategoryId(0);
              setModelType("");
            }}
            tabIndex={tabIndex}
            modelType={modelType}
            documentCategories={documentCategories}
            documentCategoryId={documentCategoryId}
            masterDocumentList={masterDocumentList}
            documentData={documentData}
            hasNotRequiredDocument={hasNotRequiredDocument}
            setDocumentData={setDocumentData}
            handleGetMasterDocumentList={handleGetMasterDocumentList}
            getDocumentCategoriesViaAPI={getDocumentCategoriesViaAPI}
          />
        </ModalPopup>

        <AddNewCoApplicantModal
          isOpen={isAddCoApplicantModalOpen}
          onClose={() => {
            setIsAddCoApplicantModalOpen(false);
            setApiNextCoApplicantNumber(null);
            setPreloadedRelationshipOptions([]);
            setPreloadedSalutationOptions([]);
            setPreloadedNationalityOptions([]);
            setPreloadedMaritalStatusOptions([]);
            setPreloadedCountryOptions([]);
          }}
          disabled={partnerStartedJourney}
          nextCoApplicantNumber={apiNextCoApplicantNumber ?? nextCoApplicantNumber}
          trackingId={String(submissionTrackingId || "")}
          applicationId={applicationId || fetchUserApplicationData?.applicationId}
          onSuccess={handleFetchApplicationDetail}
          preloadedRelationshipOptions={preloadedRelationshipOptions}
          preloadedSalutationOptions={preloadedSalutationOptions}
          preloadedNationalityOptions={preloadedNationalityOptions}
          preloadedMaritalStatusOptions={preloadedMaritalStatusOptions}
          preloadedCountryOptions={preloadedCountryOptions}
        />

        <Modal
          open={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: isXsOrSm ? "300px" : "80%",
              minHeight: isXsOrSm ? "380px" : "",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
            }}
          >
            <Close
              onClick={() => {
                setIsModalOpen(false);
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
              }}
            />
            {handleShowImageMList()}
          </Box>
        </Modal>

        {/* Account Aggregator Modal */}
        <Modal
          open={isAccountAggregatorModalOpen}
          onClose={() => {
            resetConsentDraftDates();
            setIsAccountAggregatorModalOpen(false);
          }}
          aria-labelledby="account-aggregator-modal-title"
          aria-describedby="account-aggregator-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "400px" },
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              p: 4,
              outline: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                id="account-aggregator-modal-title"
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#1F2233",
                }}
              >
                Share via Account Aggregator
              </Typography>
              <Button
                onClick={() => {
                  resetConsentDraftDates();
                  setIsAccountAggregatorModalOpen(false);
                }}
                sx={{
                  minWidth: "auto",
                  p: 0.5,
                  color: "#666",
                }}
              >
                <Close />
              </Button>
            </Box>

            <Typography
              variant="body2"
              sx={{
                mb: 3,
                color: "#666",
                fontSize: "14px",
              }}
            >
              Please verify your mobile number to proceed with account
              aggregator
            </Typography>

            <Box sx={{ mb: 1 }}>
              <SelectOptions
                options={consentTypeOptions}
                label="Consent Type"
                value={consentDurData?.consentType || "periodic"}
                isMandatory={false}
                disabled={true}
                onChange={(val) => {
                  const nextConsentType = val.toString();
                  const defaults = getConsentDefaults(nextConsentType);
                  setConsentDurData((prev) => ({
                    ...prev,
                    consentType: nextConsentType,
                    consentDuration: CONSENT_DURATION_UNIT,
                    consentDurationValue: getDerivedConsentDurationValue(
                      defaults.fromDate,
                      defaults.toDate,
                    ),
                  }));
                  applyConsentDates(defaults.fromDate, defaults.toDate);
                }}
              />
            </Box>
            <Box sx={{ mb: 1 }}>
              <SelectOptions
                options={dataTypeOptions}
                label="Data Type"
                value={dataType}
                isMandatory={false}
                onChange={(val: any) => setDataType(val?.toString())}
              />
            </Box>
            <Box>
              <label className="text-lable" style={{ display: "block" }}>
                Mobile Number for Consent
              </label>
              <InputField
                type="text"
                placeholder="Enter Mobile Number"
                fullWidth
                value={accountAggregatorMobileNumber || ""}
                variant="outlined"
                onInput={(e: any) => {
                  try {
                    // Extract numeric value only
                    const val = e.target.value.replace(/\D/g, "");
                    setAccountAggregatorMobileNumber(val);
                    localStorage.setItem("accountAggregatorMobile", val);
                    validateMobileNumber(val);
                  } catch (error) {
                    dispatch(
                      setStatusPopup({
                        status: "error",
                        message: "Error processing mobile number input. Please try again.",
                      })
                    );
                  }
                }}
                sx={{
                  mb: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                error={!!mobileNumberError}
                helperText={mobileNumberError}
              />
            </Box>

            {/* From Date Picker */}
            <BasicDatePicker
              label="From Date"
              value={fromDate ? dayjs(fromDate) : null}
              disabled={(consentDurData?.consentType || "periodic") === "periodic"}
              onChange={(date) => {
                const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
                setFromDate(formattedDate);
                if (!formattedDate) {
                  setFromDateError("");
                }
              }}
              onBlur={() => {
                if (fromDate && fromDate.length === 10) {
                  validateDate(fromDate, setFromDateError, "from");
                  if (toDate) validateDate(toDate, setToDateError, "to");
                } else if (fromDate) {
                  setFromDateError("Please enter a valid date");
                }
              }}
              minDate={
                (consentDurData?.consentType || "periodic") === "one_time"
                  ? dayjs().subtract(ONE_TIME_LOOKBACK_DAYS, "day")
                  : undefined
              }
              maxDate={
                (consentDurData?.consentType || "periodic") === "one_time"
                  ? dayjs()
                  : undefined
              }
              error={!!fromDateError}
              helperText={fromDateError}
            />

            <Box sx={{ mb: 1 }} />

            {/* To Date Picker */}
            <BasicDatePicker
              label="To Date"
              value={toDate ? dayjs(toDate) : null}
              onChange={(date) => {
                const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
                setToDate(formattedDate);
                if (!formattedDate) {
                  setToDateError("");
                }
              }}
              onBlur={() => {
                if (toDate && toDate.length === 10) {
                  validateDate(toDate, setToDateError, "to");
                  if (fromDate) validateDate(fromDate, setFromDateError, "from");
                } else if (toDate) {
                  setToDateError("Please enter a valid date");
                }
              }}
              minDate={
                (consentDurData?.consentType || "periodic") === "periodic"
                  ? dayjs()
                  : dayjs().subtract(ONE_TIME_LOOKBACK_DAYS, "day")
              }
              maxDate={
                (consentDurData?.consentType || "periodic") === "periodic"
                  ? dayjs().add(PERIODIC_DEFAULT_TO_DAYS, "day")
                  : dayjs()
              }
              error={!!toDateError}
              helperText={toDateError}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  resetConsentDraftDates();
                  setIsAccountAggregatorModalOpen(false);
                }}
                sx={{
                  textTransform: "none",
                  borderColor: "#ddd",
                  color: "#666",
                  "&:hover": {
                    borderColor: "#ccc",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  try {
                    handleAccountAggregatorRequest(
                      selectedDocumentId,
                      "link",
                      selectedDocumentItem
                    );
                    setIsAccountAggregatorModalOpen(false);
                  } catch (error) {
                    console.error("Error in Proceed button click:", error);
                    dispatch(
                      setStatusPopup({
                        status: "error",
                        message:
                          "Error processing account aggregator request. Please try again.",
                      })
                    );
                  }
                }}
                disabled={!isProceedEnabled()}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#00b3b5",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#00999a",
                  },
                  "&:disabled": {
                    backgroundColor: "#f5f5f5",
                    color: "#999",
                  },
                }}
                startIcon={aggregatorLoader && <CircularProgress size={16} />}
              >
                {aggregatorLoader ? "Processing..." : "Proceed"}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Bank Statement Upload Confirmation Modal */}
        <ModalPopup
          isOpen={isBankStatementConfirmModalOpen}
          onClose={handleCancelBankStatementUpload}
          title="Confirm Upload"
          style={{ maxWidth: "500px" }}
        >
          <Box sx={{ p: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                color: "#1F2233",
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              Uploading a new Bank Statement will remove all existing bank
              statement documents. Do you want to continue?
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCancelBankStatementUpload}
                sx={{
                  textTransform: "none",
                  borderColor: "#ddd",
                  color: "#666",
                  px: 3,
                  py: 1,
                  "&:hover": {
                    borderColor: "#ccc",
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleConfirmBankStatementUpload}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#00b3b5",
                  color: "#fff",
                  px: 3,
                  py: 1,
                  "&:hover": {
                    backgroundColor: "#00999a",
                  },
                }}
              >
                Yes, Continue
              </Button>
            </Box>
          </Box>
        </ModalPopup>

        {/* Hidden file input for direct file selection */}
        {/* SECURITY NOTE: accept attribute is only for UX convenience.
            We do NOT trust it for security - all image files are validated using magic bytes */}
        <input
          type="file"
          accept=".jpeg,.jpg,.png,.webp,.gif,.pdf,image/jpeg,image/jpg,image/png,image/webp,image/gif,application/pdf"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </Paper>

      {/* Email OTP Modal */}
      <ModalPopup
        isOpen={openEmailOtpModal}
        onClose={() => {
          setOpenEmailOtpModal(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{
          width: "100%",
          maxWidth: shouldShowEmailVerifiedConsent ? "600px" : "450px"
        }}
      >
        <OtpInputForm
          emailMasked={usernameDet?.email}
          onOtpSubmit={handleEmailOtpSubmit}
          onResendOtp={async () => {
            // Handle applicant and co-applicant email
            if (tabIndex === 0) {
              // Applicant
              if (usernameDet?.email) {
                await handleSendEmailOtp(usernameDet?.email);
              }
            } else {
              // Co-applicant
              const key: any = `coapplicant${tabIndex}`;
              const co = coApplicantDetails?.[key];
              // Try both possible email keys
              const coEmail = co?.Email || co?.coApplicantEmail;
              if (coEmail) {
                await handleSendEmailOtp(coEmail);
              }
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          showConsentMessage={shouldShowEmailVerifiedConsent}
        />
      </ModalPopup>

      {/* Mobile OTP Modal */}
      <ModalPopup
        isOpen={openMobileOtpModal}
        onClose={() => {
          setOpenMobileOtpModal(false);
          setErrorMsg("");
        }}
        title=""
        isOtpModal={true}
        style={{
          width: "100%",
          maxWidth: shouldShowPhoneVerifiedConsent ? "600px" : "450px"
        }}
      >
        <OtpInputForm
          mobileMasked={usernameDet?.phone}
          onOtpSubmit={handleMobileOtpSubmit}
          onResendOtp={async () => {
            // Handle applicant and co-applicant mobile
            if (tabIndex === 0) {
              // Applicant
              if (usernameDet?.phone) {
                await handleSendMobileOtp(usernameDet?.phone);
              }
            } else {
              // Co-applicant
              const key: any = `coapplicant${tabIndex}`;
              const co = coApplicantDetails?.[key];
              // Try both possible phone keys
              const coPhone = co?.PhoneNumber || co?.coApplicantPhone;
              if (coPhone) {
                await handleSendMobileOtp(coPhone);
              }
            }
          }}
          errorMessage={errorMsg}
          setErrorMsg={setErrorMsg}
          showConsentMessage={shouldShowPhoneVerifiedConsent}
        />
      </ModalPopup>

      {/* Alert  */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ApplicantTabs;